
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eqKgz", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");

const $631da813c6a2d352$var$adfTransformer = new (0, $h9yJL.JSONTransformer)();
const $631da813c6a2d352$export$e83f06e0073cd34f = (html)=>{
    const element = document.createElement('div');
    element.innerHTML = html;
    const doc = (0, $5SAOw.DOMParser).fromSchema((0, $iyDxB.defaultSchema)).parse(element);
    return $631da813c6a2d352$var$adfTransformer.encode(doc);
};
module.exports["htmlToADF"] = $631da813c6a2d352$export$e83f06e0073cd34f;

});

parcelRegister("4aiCO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $b8aa98a6a4a50068$export$83f018e4a62abc64 = {
    NAV: 'NAV',
    FLOATING: 'FLOATING'
};
const $b8aa98a6a4a50068$export$106572395d8035d = {
    isWarningDialogOpen: false,
    warningDialog: $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV
};
const $b8aa98a6a4a50068$export$e324594224ef24da = {
    showWarningDialog: (warningDialogDisplayType)=>({ setState: setState })=>{
            const warningDialog = warningDialogDisplayType || $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV;
            setState({
                isWarningDialogOpen: true,
                warningDialog: warningDialog
            });
        },
    hideWarningDialog: ()=>({ setState: setState })=>{
            setState({
                isWarningDialogOpen: false,
                warningDialog: $b8aa98a6a4a50068$export$83f018e4a62abc64.NAV
            });
        }
};
const $b8aa98a6a4a50068$var$Store = (0, $1P1Tu.createStore)({
    initialState: $b8aa98a6a4a50068$export$106572395d8035d,
    actions: $b8aa98a6a4a50068$export$e324594224ef24da,
    name: 'WarningDialogState'
});
const $b8aa98a6a4a50068$export$b306247a3820322e = (0, $FOT9i.createContainer)($b8aa98a6a4a50068$var$Store);
const $b8aa98a6a4a50068$export$cbed96beb63c6f4b = (0, $9zUhf.createActionsHook)($b8aa98a6a4a50068$var$Store);
const $b8aa98a6a4a50068$export$4516c77130246355 = (0, $9zUhf.createStateHook)($b8aa98a6a4a50068$var$Store, {
    selector: (state)=>state.isWarningDialogOpen
});
const $b8aa98a6a4a50068$export$33ce673123557ab7 = (0, $9zUhf.createStateHook)($b8aa98a6a4a50068$var$Store, {
    selector: (state)=>state.warningDialog
});
module.exports["WarningDialog"] = $b8aa98a6a4a50068$export$83f018e4a62abc64;
module.exports["IssueCreateWarningDialogContainer"] = $b8aa98a6a4a50068$export$b306247a3820322e;
module.exports["useWarningDialogStateActions"] = $b8aa98a6a4a50068$export$cbed96beb63c6f4b;
module.exports["useIsWarningDialogOpen"] = $b8aa98a6a4a50068$export$4516c77130246355;
module.exports["useGetWarningDialog"] = $b8aa98a6a4a50068$export$33ce673123557ab7;

});

parcelRegister("1mDVg", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $caRYB = parcelRequire("caRYB");


var $2FFuS = parcelRequire("2FFuS");

var $5a132039fb6a1ec6$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["VIEW"] = "view";
    // Regular Page View Mode
    PageMode["EDIT"] = "edit";
    // Regular Page Edit Mode
    PageMode["LIVE_VIEW"] = "live-view";
    // Live Page View Mode
    PageMode["LIVE_EDIT"] = "live-edit";
    return PageMode;
}({});
const $5a132039fb6a1ec6$var$initialIssueCreateSidePanelState = {
    contentId: '',
    contentType: 'page',
    summary: '',
    descriptionAdf: (0, $caRYB.doc)((0, $2FFuS.paragraph)('')),
    highlightedText: (0, $caRYB.doc)((0, $2FFuS.paragraph)('')),
    selectedAdf: undefined,
    selectedTable: undefined,
    selectedActionItems: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertMultipleStorageFragmentsRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: 'idle',
    isCreatedWithAi: false,
    firstAttempt: true,
    totalRetries: 0,
    aiAnalyticsContext: {
        aiResponseLength: 0,
        pageContextLength: 0,
        highlightedTextLength: 0
    },
    currentSiteSelection: '',
    currentProjectSelection: undefined,
    aiIssueCreationEnablement: {
        isEnabled: false
    },
    isCreateManuallyPressed: false,
    isGicIframeReady: false,
    pageMode: undefined,
    hasEditPermission: false,
    isCreatedFromActionItems: false,
    editorAPI: undefined
};
const $5a132039fb6a1ec6$var$issueCreateSidePanelActions = {
    setContentId: (contentId)=>({ setState: setState })=>{
            setState({
                contentId: contentId
            });
        },
    setContentType: (contentType)=>({ setState: setState })=>{
            setState({
                contentType: contentType
            });
        },
    setSummary: (summary)=>({ setState: setState })=>{
            setState({
                summary: summary
            });
        },
    setDescriptionAdf: (descriptionAdf)=>({ setState: setState })=>{
            setState({
                descriptionAdf: descriptionAdf
            });
        },
    setHighlightedText: (highlightedText)=>({ setState: setState })=>{
            setState({
                highlightedText: highlightedText
            });
        },
    setSelectedAdf: (selectedAdf)=>({ setState: setState })=>{
            setState({
                selectedAdf: selectedAdf
            });
        },
    setSelectedTable: (selectedTable)=>({ setState: setState })=>{
            setState({
                selectedTable: selectedTable
            });
        },
    setSelectedActionItems: (selectedActionItems)=>({ setState: setState })=>{
            setState({
                selectedActionItems: selectedActionItems
            });
        },
    setAiState: (aiState)=>({ setState: setState })=>{
            setState({
                aiState: aiState
            });
        },
    setIsCreatedWithAi: (isCreatedWithAi)=>({ setState: setState })=>{
            setState({
                isCreatedWithAi: isCreatedWithAi
            });
        },
    setIsCreatedFromActionItem: (isCreatedFromActionItems)=>({ setState: setState })=>{
            setState({
                isCreatedFromActionItems: isCreatedFromActionItems
            });
        },
    setInsertStorageFragmentRequestPayload: (insertStorageFragmentRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload
            });
        },
    setInsertMultipleStorageFragmentsRequestPayload: (insertMultipleStorageFragmentsRequestPayload)=>({ setState: setState })=>{
            setState({
                insertMultipleStorageFragmentsRequestPayload: insertMultipleStorageFragmentsRequestPayload
            });
        },
    setInsertStorageColumnTableRequestPayload: (insertStorageColumnTableRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload
            });
        },
    setAiAnalyticsContext: (key, value)=>({ setState: setState, getState: getState })=>{
            setState({
                aiAnalyticsContext: {
                    ...getState()['aiAnalyticsContext'],
                    [key]: value
                }
            });
        },
    setFirstAttempt: (firstAttempt)=>({ setState: setState })=>{
            setState({
                firstAttempt: firstAttempt
            });
        },
    setTotalRetries: ()=>({ setState: setState, getState: getState })=>{
            const currentTotalRetries = getState().totalRetries;
            setState({
                totalRetries: currentTotalRetries + 1
            });
        },
    setCurrentSiteSelection: (currentSiteSelection)=>({ setState: setState })=>{
            setState({
                currentSiteSelection: currentSiteSelection
            });
        },
    setCurrentProjectSelection: (currentProjectSelection)=>({ setState: setState })=>{
            setState({
                currentProjectSelection: currentProjectSelection
            });
        },
    setAiIssueCreationEnablement: (aiIssueCreationEnablement)=>({ setState: setState })=>{
            setState({
                aiIssueCreationEnablement: aiIssueCreationEnablement
            });
        },
    setIsCreateManuallyPressed: (isCreateManuallyPressed)=>({ setState: setState })=>{
            setState({
                isCreateManuallyPressed: isCreateManuallyPressed
            });
        },
    setIsGicIframeReady: (isGicIframeReady)=>({ setState: setState })=>{
            setState({
                isGicIframeReady: isGicIframeReady
            });
        },
    setPageMode: (pageMode)=>({ setState: setState })=>{
            setState({
                pageMode: pageMode
            });
        },
    setHasEditPermission: (hasEditPermission)=>({ setState: setState })=>{
            setState({
                hasEditPermission: hasEditPermission
            });
        },
    setEditorAPI: (editorAPI)=>({ setState: setState })=>{
            setState({
                editorAPI: editorAPI
            });
        }
};
const $5a132039fb6a1ec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$5a132039fb6a1ec6$var$initialIssueCreateSidePanelState
    },
    actions: $5a132039fb6a1ec6$var$issueCreateSidePanelActions,
    name: 'issueCreateSidePanelContext'
});
const $5a132039fb6a1ec6$export$a8290271bb06280a = (0, $FOT9i.createContainer)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$2a12c9775e55a317 = (0, $9zUhf.createHook)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$74cf44ce4ce6c99b = (0, $9zUhf.createActionsHook)($5a132039fb6a1ec6$var$Store);
const $5a132039fb6a1ec6$export$daa560916caa4ae4 = (0, $9zUhf.createStateHook)($5a132039fb6a1ec6$var$Store, {
    selector: (state)=>state.aiIssueCreationEnablement
});
module.exports["PageMode"] = $5a132039fb6a1ec6$export$6ea4b0c62affbe44;
module.exports["IssueCreateSidePanelContainer"] = $5a132039fb6a1ec6$export$a8290271bb06280a;
module.exports["useIssueCreateSidePanelContext"] = $5a132039fb6a1ec6$export$2a12c9775e55a317;
module.exports["useIssueCreateSidePanelActions"] = $5a132039fb6a1ec6$export$74cf44ce4ce6c99b;
module.exports["useAiIssueCreationEnablementState"] = $5a132039fb6a1ec6$export$daa560916caa4ae4;

});

parcelRegister("98CLM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");


var $8TTLA = parcelRequire("8TTLA");


var $8o1lj = parcelRequire("8o1lj");


var $1DHa6 = parcelRequire("1DHa6");


var $d8eRd = parcelRequire("d8eRd");


var $9ot3w = parcelRequire("9ot3w");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $e9c533ef122c07a9$var$headerStyles = (0, $ecnYn.xcss)({
    flexDirection: 'row-reverse',
    width: '100%',
    justifyContent: 'space-between'
});
const $e9c533ef122c07a9$var$footerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    gap: 'space.050'
});
const $e9c533ef122c07a9$export$4385dd64e7fb8e2d = ({ onConfirm: onConfirm, onCancel: onCancel, issuesCount: issuesCount = 1 })=>{
    const handleConfirm = ()=>{
        onConfirm();
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
    };
    const Footer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $e9c533ef122c07a9$var$footerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "issue-create-warning-cancel-button",
            onClick: handleCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).unsavedActionCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "issue-create-warning-ok-button",
            appearance: "warning",
            onClick: handleConfirm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).unsavedActionDiscard))));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).unsavedHeadingIssueTermRefresh : (0, $3E5yu.messages).unsavedHeading,
        values: {
            issuesCount: issuesCount
        }
    }, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
            testId: "modal-dialog-issue-create-warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $e9c533ef122c07a9$var$headerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            onClick: handleCancel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
            appearance: "warning"
        }, text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).unsavedContentIssueTermRefresh : (0, $3E5yu.messages).unsavedContent,
            values: {
                issuesCount: issuesCount
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Footer, null)));
};
module.exports["IssueCreateWarningDialog"] = $e9c533ef122c07a9$export$4385dd64e7fb8e2d;

});

parcelRegister("3E5yu", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $340704cf66283bf0$var$messagesBase = (0, $aXWIB.defineMessages)({
    sidePanelHeader: {
        id: "issue-create-side-panel.header",
        defaultMessage: "Create Jira issue"
    },
    sidePanelFooterSubmit: {
        id: "issue-create-side-panel.footer.submit",
        defaultMessage: "Submit"
    },
    sidePanelFooterCancel: {
        id: "issue-create-side-panel.footer.cancel",
        defaultMessage: "Cancel"
    },
    sidePanelIssueCreateInsertionFailed: {
        id: "issue-create-side-panel.insertion-failed",
        defaultMessage: "We were unable to insert a link for <link>{issueKey} {issueSummary}</link>"
    },
    sidePanelFooterDisclaimerText: {
        id: "issue-create-side-panel.footer.disclaimer-text",
        defaultMessage: "Content quality may vary"
    },
    sidePanelIssueCreateAiToggleLabel: {
        id: "issue-create-side-panel.ai-toggle-label",
        defaultMessage: "Use Rovo to generate summary and description"
    },
    sidePanelFooterRovoText: {
        id: "issue-create-side-panel.footer.ai-text",
        defaultMessage: "Powered by Rovo"
    },
    sidePanelAiLoading: {
        id: "issue-create-side-panel.body.ai-loading",
        defaultMessage: "Generating issue"
    },
    sidePanelAiLoadingBulk: {
        id: "issue-create-side-panel.bulk-body.ai-loading",
        defaultMessage: "Generating issues"
    },
    manualBulkCreateLoadingTextFirst: {
        id: "issue-create-side-panel.bulk-create.manual-loading-text",
        defaultMessage: "Teleporting text to Jira..."
    },
    manualBulkCreateLoadingTextSecond: {
        id: "issue-create-side-panel.bulk-create.manual-loading-text-second",
        defaultMessage: "Building your next big thing..."
    },
    manualBulkCreateLoadingTextThird: {
        id: "issue-create-side-panel.bulk-create.manual-loading-text-third",
        defaultMessage: "Your work items are on the way..."
    },
    jiraSiteHeading: {
        id: "issue-create-side-panel.body.site.heading",
        defaultMessage: "Site:"
    },
    jiraProjectHeading: {
        id: "issue-create-side-panel.body.project.heading",
        defaultMessage: "Project:"
    },
    jiraProjectHeadingGalaxia: {
        id: "issue-create-side-panel.body.project.heading-galaxia",
        defaultMessage: "Space:"
    },
    bulkCreateConfigureButtonText: {
        id: "issue-create-side-panel.bulk-create.configure-button-text",
        defaultMessage: "Configure"
    },
    singleCreateAiErrorDescription: {
        id: "issue-create-side-panel.single-create-ai-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Try again or create your issue manually."
    },
    issueGenerationErrorDescription: {
        id: "issue-create-side-panel.bulk-create-issue-generation-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Add more content and try again. Or highlight specific text to create manually."
    },
    ethicalViolationErrorDescription: {
        id: "issue-create-side-panel.ethical-violation-ai-error-description",
        defaultMessage: "Your selected content or other content on this page might not comply with our <link>Acceptable Use Policy</link>. You can always create an issue manually."
    },
    rateLimitErrorDescription: {
        id: "issue-create-side-panel.rate-limit-ai-error-description",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create an issue manually."
    },
    exceedingTokenLimitDescription: {
        id: "issue-create-side-panel.exceed-token-limit-description",
        defaultMessage: "Atlassian Intelligence can\u2019t create issues for lengthy Confluence pages right now. You can always create an issue manually."
    },
    noAnswerSuggestedIssues: {
        id: "issue-create-side-panel.no-answer-suggested-issues-ai-error-description",
        defaultMessage: "We can\u2019t understand the content to suggest an issue. Select different content or create an issue manually."
    },
    bulkCreateAiErrorDescription: {
        id: "issue-create-side-panel.bulk-create-ai-error-description",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Try again or highlight specific text to create manually."
    },
    singleCreateAiErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.single-create-ai-error-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Try again or create your issue manually."
    },
    issueGenerationErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.bulk-create-issue-generation-error-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Add more content and try again. Or highlight specific text to create manually."
    },
    rateLimitErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-rebrand-to-rovo",
        defaultMessage: "We\u2019ve received too many recent requests for Rovo. Try again in a few minutes or <link>read about excessive use of Rovo</link>. You can always create an issue manually."
    },
    exceedingTokenLimitDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.exceed-token-limit-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t create issues for lengthy Confluence pages right now. You can always create an issue manually."
    },
    bulkCreateAiErrorDescriptionRebrandToRovo: {
        id: "issue-create-side-panel.bulk-create-ai-error-description-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Try again or highlight specific text to create manually."
    },
    connectJiraProjectErrorDescription: {
        id: "issue-create-side-panel.bulk-create-connect-jira-project-error-description",
        defaultMessage: "We weren\u2019t able to connect to your Jira project. Please try again."
    },
    connectJiraProjectErrorDescriptionGalaxia: {
        id: "issue-create-side-panel.bulk-create-connect-jira-project-error-description-galaxia",
        defaultMessage: "We weren\u2019t able to connect to your Jira space. Please try again."
    },
    errorTryAgainButton: {
        id: "issue-create-side-panel.error.button.try-again",
        defaultMessage: "Try again"
    },
    errorCreateManuallyButton: {
        id: "issue-create-side-panel.error.button.create-manually",
        defaultMessage: "Create manually"
    },
    sidePanelSingleIssueCreateSuccessFlagTitle: {
        id: "issue-create-side-panel.sucess-flag-title",
        defaultMessage: "You\u2019ve created <link>{issueKey} {issueSummary}</link> issue"
    },
    sidePanelMultipleIssueCreateSuccessFlagTitle: {
        id: "issue-create-side-panel.multiple.sucess-flag-title",
        defaultMessage: "You\u2019ve created {issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    sidePanelSingleIssueInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.insert-link-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert a link for <link>{issueKey} {issueSummary}</link>"
    },
    sidePanelMultipleIssuesInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.multiple.insert-link-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert links for  {issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    documentModifiedSingleIssueInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.page-modified-after-selection-single-insert-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert a link for <link>{issueKey} {issueSummary}</link> because page content was modified after the side panel was opened"
    },
    documentModifiedMultipleIssuesInsertLinkFailureFlagTitle: {
        id: "issue-create-side-panel.page-modified-after-selection-multiple-insert-failure-flag.title",
        defaultMessage: "We couldn\u2019t insert links for {issueCount} {issueCount, plural, one {issue} other {issues}} because page content was modified after the side panel was opened"
    },
    sidePanelMultipleIssueCreateFlagViewIssue: {
        id: "issue-create-side-panel.multiple.flag-view-issue",
        defaultMessage: "View {issueCount, plural, one {issue} other {issues}} in Jira"
    },
    sidePanelMultipleIssueCreateFlagCopyLink: {
        id: "issue-create-side-panel.multiple.flag-copy-link",
        defaultMessage: "Copy link"
    },
    sidePanelMultipleIssueCreateFlagReloadToSeeLinks: {
        id: "issue-create-side-panel.multiple.flag-reload-to-see-links",
        defaultMessage: "Reload to see links appear"
    },
    sidePanelIssueCreateErrorMessage: {
        id: "issue-create-side-panel.bulk-create.error.message",
        defaultMessage: "We weren\u2019t able to save your {issuesCount, plural, one {issue} other {issues}}. Please try again."
    },
    sidePanelIssueCreatePartialErrorMessage: {
        id: "issue-create-side-panel.bulk-create.partial.error.message",
        defaultMessage: "We couldn\u2019t create some of your issues. Select the checkmark on the remaining issues to create them one at a time."
    },
    sidePanelBetaText: {
        id: "issue-create-side-panel.beta-text",
        defaultMessage: "Beta"
    },
    unsavedHeading: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.heading",
        defaultMessage: "Discard {issuesCount, plural, =0 {issue} one {issue} other {issues}}?"
    },
    unsavedContent: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.content",
        defaultMessage: "Your {issuesCount, plural, =0 {issue} one {issue} other {issues}} will be lost."
    },
    unsavedActionDiscard: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.action.discard",
        defaultMessage: "Discard"
    },
    unsavedActionCancel: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.action.cancel",
        defaultMessage: "Cancel"
    },
    bulkCreateHeaderText: {
        id: "issue-create-side-panel.bulk-create.header",
        defaultMessage: "Create Jira issues"
    },
    bulkCreateCreateAllFooterButton: {
        id: "issue-create-side-panel.bulk-create.footer-button.create-all",
        defaultMessage: "Create all"
    },
    bulkCreateCancelFooterButton: {
        id: "issue-create-side-panel.bulk-create.footer-button.cancel",
        defaultMessage: "Cancel"
    },
    bulkCreateEditHeaderText: {
        id: "issue-create-side-panel.bulk-create-edit.header",
        defaultMessage: "Edit issue"
    },
    bulkCreateConfigureBodyText: {
        id: "issue-create-side-panel.bulk-create.configure.body",
        defaultMessage: "Changing these settings might re-generate the issues list."
    },
    singleWorkCreateFormBodyText: {
        id: "issue-create-side-panel.single-work-create-form.body",
        defaultMessage: "Changing these settings might re-generate the issues list."
    },
    bulkConfigureHeaderText: {
        id: "issue-create-side-panel.bulk-configure.header",
        defaultMessage: "Configure"
    },
    bulkConfigureJiraErrorText: {
        id: "issue-create-side-panel.bulk-configure.jira-error",
        defaultMessage: "There are no available projects in this site."
    },
    bulkConfigureJiraErrorTextGalaxia: {
        id: "issue-create-side-panel.bulk-configure.jira-error-galaxia",
        defaultMessage: "There are no available spaces in this site."
    },
    singleWorkCreateFormJiraErrorText: {
        id: "issue-create-side-panel.single-work-create-form.jira-error",
        defaultMessage: "There are no available projects in this site."
    },
    singleWorkCreateFormJiraErrorTextGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.jira-error-galaxia",
        defaultMessage: "There are no available spaces in this site."
    },
    bulkConfigureMissingTableCoulumnMappingErrorHeaderText: {
        id: "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-header",
        defaultMessage: "Missing table column mapping"
    },
    bulkConfigureMissingTableCoulumnMappingErrorText: {
        id: "issue-create-side-panel.bulk-configure.missing-table-column-mapping-error-text",
        defaultMessage: "Please update and save the mapping of your table columns to work item fields."
    },
    bulkConfigureFormSite: {
        id: "issue-create-side-panel.bulk-configure.form.site",
        defaultMessage: "Site"
    },
    singleWorkCreateFormSite: {
        id: "issue-create-side-panel.single-work-create-form.form.site",
        defaultMessage: "Site"
    },
    bulkConfigureFormProject: {
        id: "issue-create-side-panel.bulk-configure.form.project",
        defaultMessage: "Project"
    },
    bulkConfigureFormProjectGalaxia: {
        id: "issue-create-side-panel.bulk-configure.form.project-galaxia",
        defaultMessage: "Space"
    },
    singleWorkCreateFormProject: {
        id: "issue-create-side-panel.single-work-create-form.form.project",
        defaultMessage: "Project"
    },
    singleWorkCreateFormProjectGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.form.project-galaxia",
        defaultMessage: "Space"
    },
    bulkConfigureFormDefaultIssueType: {
        id: "issue-create-side-panel.bulk-configure.form.default.issue.type",
        defaultMessage: "Default Issue type"
    },
    singleWorkCreateFormDefaultIssueType: {
        id: "issue-create-side-panel.single-work-create-form.form.default.issue.type",
        defaultMessage: "Issue type"
    },
    bulkConfigureFormProjectSelectorProjects: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.projects",
        defaultMessage: "Projects"
    },
    bulkConfigureFormProjectSelectorProjectsGalaxia: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.projects-galaxia",
        defaultMessage: "Spaces"
    },
    singleWorkCreateFormProjectSelectorProjects: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.projects",
        defaultMessage: "Projects"
    },
    singleWorkCreateFormProjectSelectorProjectsGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.projects-galaxia",
        defaultMessage: "Spaces"
    },
    bulkConfigureFormProjectSelectorRecentProjects: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.recent-projects",
        defaultMessage: "Recent Projects"
    },
    bulkConfigureFormProjectSelectorRecentProjectsGalaxia: {
        id: "issue-create-side-panel.bulk-configure.form.project-selector.recent-projects-galaxia",
        defaultMessage: "Recent Spaces"
    },
    singleWorkCreateFormProjectSelectorRecentProjects: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.recent-projects",
        defaultMessage: "Recent Projects"
    },
    singleWorkCreateFormProjectSelectorRecentProjectsGalaxia: {
        id: "issue-create-side-panel.single-work-create-form.form.project-selector.recent-projects-galaxia",
        defaultMessage: "Recent Spaces"
    },
    bulkConfigureFooterCancel: {
        id: "issue-create-side-panel.bulk-configure.footer.cancel",
        defaultMessage: "Cancel"
    },
    singleCreateIssueFormFooterCancel: {
        id: "issue-create-side-panel.single-create-issue-form.footer.cancel",
        defaultMessage: "Cancel"
    },
    bulkConfigureFooterSave: {
        id: "issue-create-side-panel.bulk-configure.footer.save",
        defaultMessage: "Save"
    },
    singleCreateIssueFormFooterSave: {
        id: "issue-create-side-panel.single-create-issue-form.footer.save",
        defaultMessage: "Create"
    },
    bulkConfigureMapTableToIssueTitle: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.title",
        defaultMessage: "Map table to issue fields"
    },
    bulkConfigureMapTableToIssueDescription: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.description",
        defaultMessage: "You can map your highlighted table\u2019s columns to specific fields in your issues."
    },
    bulkConfigureMapTableToIssueTableColumn: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.table-column",
        defaultMessage: "Table column"
    },
    bulkConfigureMapTableToIssueIssueField: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field",
        defaultMessage: "Issue field"
    },
    bulkConfigureMapTableToIssueAddMapping: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.add-mapping",
        defaultMessage: "Add mapping"
    },
    bulkConfigureMapTableToIssueErrorColumnNotSelected: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.column-not-selected",
        defaultMessage: "Column must be selected."
    },
    bulkConfigureMapTableToIssueErrorFieldNotSelected: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-not-selected",
        defaultMessage: "Field must be selected."
    },
    bulkConfigureMapTableToIssueErrorFieldAlreadyMapped: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.error.field-already-mapped",
        defaultMessage: "Another column is already mapped to selected field."
    },
    issueCardDescriptionIconLabel: {
        id: "issue-create-side-panel.bulk-create.card.description-icon",
        defaultMessage: "Description"
    },
    // TODO update objects below with correct fields
    requiredFieldsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-title",
        defaultMessage: "These suggestions have required fields"
    },
    requiredFieldsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-description",
        defaultMessage: "Edit each suggestion and complete the required fields to create the issues"
    },
    workflowValidatorFieldsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.workflow-validator-fields-message-title",
        defaultMessage: "These suggestions have required fields specified through workflow validators"
    },
    bulkCreateIssueInsertionHeading: {
        id: "issue-create-side-panel.bulk-create.issue-insertion-heading",
        defaultMessage: "Linked Jira Issues"
    },
    sidePanelAiLoadingIssueTermRefresh: {
        id: "issue-create-side-panel.body.ai-loading-issue-term-refresh",
        defaultMessage: "Generating"
    },
    sidePanelAiLoadingIssueExperiment: {
        id: "issue-create-side-panel.body.ai-loading-issue-experiment",
        defaultMessage: "Atlassian Intelligence is generating the summary and description, which may take a few moments."
    },
    sidePanelAiLoadingIssueExperimentRebrandToRovo: {
        id: "issue-create-side-panel.body.ai-loading-issue-experiment-rebrand-to-rovo",
        defaultMessage: "Rovo is generating the summary and description, which may take a few moments."
    },
    unsavedHeadingIssueTermRefresh: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.heading-issue-term-refresh",
        defaultMessage: "Discard {issuesCount, plural, =0 {work item} one {work item} other {work items}}?"
    },
    singleCreateAiErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.single-create-ai-error-description-issue-term-refresh",
        defaultMessage: "Atlassian Intelligence can\u2018t provide a response right now. Try again or create your work item manually."
    },
    singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo: {
        id: "issue-create-side-panel.single-create-ai-error-description-issue-term-refresh-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t provide a response right now. Try again or create your work item manually."
    },
    sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.sucess-flag-title-issue-term-refresh",
        defaultMessage: "You\u2019ve created <link>{issueKey} {issueSummary}</link> work item"
    },
    sidePanelIssueCreatePartialErrorMessageIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.partial.error.message-issue-term-refresh",
        defaultMessage: "We couldn\u2019t create some of your work items. Select the checkmark on the remaining work items to create them one at a time."
    },
    unsavedContentIssueTermRefresh: {
        id: "issue-create-side-panel.unsaved-issue.warning.dialog.content-issue-term-refresh",
        defaultMessage: "Your {issuesCount, plural, =0 {work item} one {work item} other {work items}} will be lost."
    },
    sidePanelAiLoadingBulkIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-body.ai-loading-issue-term-refresh",
        defaultMessage: "Generating"
    },
    sidePanelMultipleIssueCreateSuccessFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.multiple.sucess-flag-title-issue-term-refresh",
        defaultMessage: "You\u2019ve created {issueCount} {issueCount, plural, one {work item} other {work items}}"
    },
    sidePanelHeaderIssueTermRefresh: {
        id: "issue-create-side-panel.header-issue-term-refresh",
        defaultMessage: "Create Jira work item"
    },
    noAnswerSuggestedIssuesIssueTermRefresh: {
        id: "issue-create-side-panel.no-answer-suggested-issues-ai-error-description-issue-term-refresh",
        defaultMessage: "We can\u2019t understand the content to suggest a work item. Select different content or create manually."
    },
    ethicalViolationErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.ethical-violation-ai-error-description-issue-term-refresh",
        defaultMessage: "Your selected content or other content on this page might not comply with our <link>Acceptable Use Policy</link>. You can always create a work item manually."
    },
    rateLimitErrorDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-issue-term-refresh",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create a work item manually."
    },
    exceedingTokenLimitDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.exceed-token-limit-description-issue-term-refresh",
        defaultMessage: "Atlassian Intelligence can\u2019t create work items for lengthy Confluence pages right now. You can always create a work item manually."
    },
    rateLimitErrorDescriptionIssueTermRefreshRebrandToRovo: {
        id: "issue-create-side-panel.rate-limit-ai-error-description-issue-term-refresh-rebrand-to-rovo",
        defaultMessage: "We\u2019ve received too many recent requests for Rovo. Try again in a few minutes or <link>read about excessive use of AI</link>. You can always create a work item manually."
    },
    exceedingTokenLimitDescriptionIssueTermRefreshRebrandToRovo: {
        id: "issue-create-side-panel.exceed-token-limit-description-issue-term-refresh-rebrand-to-rovo",
        defaultMessage: "Rovo can\u2019t create work items for lengthy Confluence pages right now. You can always create a work item manually."
    },
    sidePanelMultipleIssuesInsertLinkFailureFlagTitleIssueTermRefresh: {
        id: "issue-create-side-panel.multiple.insert-link-failure-flag.title-issue-term-refresh",
        defaultMessage: "We couldn\u2019t insert links to the page for {issueCount} {issueCount, plural, one {work item} other {work items}}"
    },
    sidePanelIssueCreateErrorMessageIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.error.message-issue-term-refresh",
        defaultMessage: "We weren\u2019t able to save your {issuesCount, plural, one {work item} other {work items}}. Please try again."
    },
    bulkCreateConfigureBodyTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.configure.body-issue-term-refresh",
        defaultMessage: "Changing these settings might re-generate the list."
    },
    bulkCreateConfigureBodyWorkFieldMappingsComponentsFieldOption: {
        id: "issue-create-side-panel.bulk-create.configure.body.work-field-mappings.components-field-option",
        defaultMessage: "Components"
    },
    singleWorkCreateFormBodyTextIssueTermRefresh: {
        id: "issue-create-side-panel.single-work-create-form.body-issue-term-refresh",
        defaultMessage: "Changing these settings might re-generate the list."
    },
    requiredFieldsSectionMessageDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.body.required-fields-message-description-issue-term-refresh",
        defaultMessage: "Edit each suggestion and complete the required fields to create the work items"
    },
    workflowValidatorFieldsSectionMessageDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.body.workflow-validator-fields-message-description-issue-term-refresh",
        defaultMessage: "Edit each suggestion and complete the following required fields to create the work items:"
    },
    moreThanFiftyWorkItemsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.more-than-fifty-work-items-message-title",
        defaultMessage: "There are more than 50 work items"
    },
    moreThanFiftyWorkItemsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.more-than-fifty-work-items-message-description",
        defaultMessage: "We can\u2019t create more than 50 work items at once. Please delete or approve work items from this list, or limit your {context, select, table {table to 50 rows} list {list to 50 action items} other {selection to 50 items}}."
    },
    moreThanTenAIWorkItemsSectionMessageTitle: {
        id: "issue-create-side-panel.bulk-create.body.more-than-ten-ai-work-items-message-title",
        defaultMessage: "Creation with Rovo is unavailable for more than 10 work items"
    },
    moreThanTenAIWorkItemsSectionMessageDescription: {
        id: "issue-create-side-panel.bulk-create.body.more-than-ten-ai-work-items-message-description",
        defaultMessage: "To create with Rovo, close this panel and reselect a {context, select, table {table with 10 or fewer rows} list {list with 10 or fewer action items} other {selection with 10 or fewer items}}. Otherwise, you can still create work items manually."
    },
    bulkConfigureFormDefaultIssueTypeIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.form.default.issue.type-issue-term-refresh",
        defaultMessage: "Default work type"
    },
    singleWorkCreateFormDefaultIssueTypeIssueTermRefresh: {
        id: "issue-create-side-panel.single-work-create-form.form.default.issue.type-issue-term-refresh",
        defaultMessage: "Work type"
    },
    bulkCreateIssueInsertionHeadingIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.issue-insertion-heading-issue-term-refresh",
        defaultMessage: "Linked Jira work items"
    },
    bulkCreateHeaderTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create.header-issue-term-refresh",
        defaultMessage: "Create Jira work items"
    },
    bulkConfigureMapTableToIssueTitleIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.title-issue-term-refresh",
        defaultMessage: "Map table to work item fields"
    },
    bulkConfigureMapTableToIssueDescriptionIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.description-issue-term-refresh",
        defaultMessage: "You can map your highlighted table\u2019s columns to specific fields in your work items."
    },
    bulkConfigureMapTableToIssueIssueFieldIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-configure.map-table-to-issue.issue-field-issue-term-refresh",
        defaultMessage: "Work item field"
    },
    bulkCreateEditHeaderTextIssueTermRefresh: {
        id: "issue-create-side-panel.bulk-create-edit.header-issue-term-refresh",
        defaultMessage: "Edit work item"
    },
    workCreateCommonRequiredFieldsSectionMessageNote: {
        id: "issue-create-side-panel.work-create-form-common.required-fields-message-note",
        defaultMessage: "Required fields are marked with an asterisk *"
    },
    workCreateCommonRequiredFieldsSectionMessageNoteWithoutTailingAsterisk: {
        id: "issue-create-side-panel.work-create-form-common.required-fields-message-note-without-tailing-asterisk",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    workCreateCommonSummaryLabel: {
        id: "issue-create-side-panel.work-create-form-common.text-field-label",
        defaultMessage: "Summary"
    },
    workCreateCommonSummaryError: {
        id: "issue-create-side-panel.work-create-form-common.text-field-error",
        defaultMessage: "Summary is required"
    },
    workCreateCommonDescriptionLabel: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-label",
        defaultMessage: "Description"
    },
    workCreateCommonDescriptionPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-placeholder",
        defaultMessage: "Add a description..."
    },
    workCreateCommonSummaryAiLoadingPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.text-field-ai-loading-placeholder",
        defaultMessage: "Generating summary..."
    },
    workCreateCommonDescriptionAiLoadingPlaceholder: {
        id: "issue-create-side-panel.work-create-form-common.rich-text-field-ai-loading-placeholder",
        defaultMessage: "Generating description..."
    },
    transitionToGicAnywhereSectionMessage: {
        id: "issue-create-side-panel.transition-to-gic-anywhere-section-message",
        defaultMessage: "We have updated this form to show additional required fields."
    }
});
const $340704cf66283bf0$export$defe85febe8b728c = $340704cf66283bf0$var$messagesBase;
const $340704cf66283bf0$export$79a7c1ed4f4b06be = 'jiraEmbedIssueSiteSelected';
const $340704cf66283bf0$export$4e8bd21788b520a = 'jiraEmbedIssueProjectSelected';
const $340704cf66283bf0$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $340704cf66283bf0$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
module.exports["messages"] = $340704cf66283bf0$export$defe85febe8b728c;
module.exports["JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED"] = $340704cf66283bf0$export$79a7c1ed4f4b06be;
module.exports["JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED"] = $340704cf66283bf0$export$4e8bd21788b520a;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $340704cf66283bf0$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $340704cf66283bf0$export$a402043ad8e6699;

});

parcelRegister("hq2Sz", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $f0BVO = parcelRequire("f0BVO");


var $3E5yu = parcelRequire("3E5yu");


var $aMxFD = parcelRequire("aMxFD");

const $9380a12614698ffc$export$298219811dc2c4cb = {
    ABORT: 'abort',
    LOADING: 'loading',
    ERROR: 'error',
    IDLE: 'idle'
};
const $9380a12614698ffc$export$b6616fff1cd26f39 = {
    BULK_CREATION: 'bulk-issue-creation-failed',
    ISSUE_GENERATION: 'ai-issue-generation-failed',
    SITE_RETRIEVAL: 'jira-site-retreival-failed',
    PROJECT_RETRIEVAL: 'jira-project-retreival-failed',
    ISSUE_TYPE_RETRIEVAL: 'issue-type-retreival-failed',
    EMPTY: ''
};
const $9380a12614698ffc$export$ed15e8f0bf6a46a2 = (()=>{
    return {
        [$9380a12614698ffc$export$b6616fff1cd26f39.BULK_CREATION]: ()=>(0, $3E5yu.messages).bulkCreateAiErrorDescriptionRebrandToRovo,
        [$9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION]: ()=>(0, $3E5yu.messages).issueGenerationErrorDescriptionRebrandToRovo,
        [$9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL]: ()=>(0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription,
        [$9380a12614698ffc$export$b6616fff1cd26f39.PROJECT_RETRIEVAL]: ()=>(0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription,
        [$9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_TYPE_RETRIEVAL]: ()=>(0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription
    };
})();
// TODO: replace with initialPersistedBulkCreateState and initialTransientBulkCreateState when removing expVal('confluence-bulk-work-create-editor', 'isEnabled', false)
const $9380a12614698ffc$var$initialBulkCreateState = {
    bulkIssuesList: [],
    currentIssueId: '',
    contentLastModifiedTimestamp: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: $9380a12614698ffc$export$298219811dc2c4cb.IDLE,
    isCreatedWithAi: false,
    isCreatedFromTable: false,
    isCreatedFromActionItems: false,
    currentJiraSite: undefined,
    currentJiraProject: undefined,
    currentDefaultIssueType: undefined,
    issueTypeHasRequiredFields: false,
    singleIssuesCreated: [],
    error: '',
    issueTypeFields: {
        requiredFields: [],
        optionalFields: []
    },
    manualCreateState: 'idle',
    aiResultViewedFiredOnce: false,
    closeAndAddIssuesToPage: false,
    expectedIssueIndices: [],
    selectedTableAdf: undefined,
    userChoseManualCreation: false,
    workflowValidators: null,
    isRovoPanelWidth: false
};
// TODO: Uncomment when removing expVal('confluence-bulk-work-create-editor')
// // Persisted state: survives panel close/reopen to maintain user's Jira configuration
// // and track issues that need to be inserted into the page
// const initialPersistedBulkCreateState = {
// 	currentJiraSite: undefined as State['currentJiraSite'],
// 	currentJiraProject: undefined as State['currentJiraProject'],
// 	currentDefaultIssueType: undefined as State['currentDefaultIssueType'],
// 	issueTypeFields: {
// 		requiredFields: [],
// 		optionalFields: [],
// 	} as State['issueTypeFields'],
// 	issueTypeHasRequiredFields: false,
// 	singleIssuesCreated: [] as State['singleIssuesCreated'],
// };
// Transient state: reset on panel close
// Workflow-specific state for the current session
const $9380a12614698ffc$var$initialTransientBulkCreateState = {
    bulkIssuesList: [],
    currentIssueId: '',
    contentLastModifiedTimestamp: undefined,
    insertStorageFragmentRequestPayload: undefined,
    insertStorageColumnTableRequestPayload: undefined,
    aiState: $9380a12614698ffc$export$298219811dc2c4cb.IDLE,
    isCreatedWithAi: false,
    isCreatedFromTable: false,
    isCreatedFromActionItems: false,
    error: '',
    manualCreateState: 'idle',
    aiResultViewedFiredOnce: false,
    closeAndAddIssuesToPage: false,
    expectedIssueIndices: [],
    selectedTableAdf: undefined,
    userChoseManualCreation: false,
    workflowValidators: null,
    isRovoPanelWidth: false
};
const $9380a12614698ffc$var$bulkCreateActions = {
    setCurrentIssueId: (currentIssueId)=>({ setState: setState })=>{
            setState({
                currentIssueId: currentIssueId
            });
        },
    setBulkIssuesList: (bulkIssuesList)=>({ setState: setState })=>{
            setState({
                bulkIssuesList: bulkIssuesList
            });
        },
    setIssueTypeFields: (issueTypeFields)=>({ setState: setState })=>{
            setState({
                issueTypeFields: issueTypeFields
            });
        },
    setAiState: (aiState)=>({ setState: setState, getState: getState })=>{
            const { error: error } = getState();
            if (error === $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION && aiState == $9380a12614698ffc$export$298219811dc2c4cb.LOADING) setState({
                aiState: aiState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY
            });
            else if (aiState == $9380a12614698ffc$export$298219811dc2c4cb.ERROR) setState({
                aiState: aiState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_GENERATION
            });
            else setState({
                aiState: aiState
            });
        },
    setIsCreatedWithAi: (isCreatedWithAi)=>({ setState: setState })=>{
            setState({
                isCreatedWithAi: isCreatedWithAi
            });
        },
    setIsCreatedFromTable: (isCreatedFromTable)=>({ setState: setState })=>{
            setState({
                isCreatedFromTable: isCreatedFromTable
            });
        },
    setIsCreatedFromActionItems: (isCreatedFromActionItems)=>({ setState: setState })=>{
            setState({
                isCreatedFromActionItems: isCreatedFromActionItems
            });
        },
    setContentLastModifiedTimestamp: (contentLastModifiedTimestamp)=>({ setState: setState })=>{
            setState({
                contentLastModifiedTimestamp: contentLastModifiedTimestamp
            });
        },
    setInsertStorageFragmentRequestPayload: (insertStorageFragmentRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload
            });
        },
    setInsertStorageColumnTableRequestPayload: (insertStorageColumnTableRequestPayload)=>({ setState: setState })=>{
            setState({
                insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload
            });
        },
    removeBulkIssue: (issueId)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList } = getState();
            const newBulkIssuesList = bulkIssuesList.filter((issue)=>issue.id !== issueId);
            setState({
                bulkIssuesList: newBulkIssuesList,
                closeAndAddIssuesToPage: newBulkIssuesList.length === 0
            });
        },
    removeBulkIssueList: (issueIds)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList } = getState();
            setState({
                bulkIssuesList: bulkIssuesList.filter((issue)=>!issueIds.includes(issue.id))
            });
        },
    setSingleIssuesCreated: (singleIssue)=>({ setState: setState, getState: getState })=>{
            const { singleIssuesCreated: singleIssuesCreated } = getState();
            setState({
                singleIssuesCreated: [
                    ...singleIssuesCreated,
                    singleIssue
                ]
            });
        },
    resetSingleIssuesCreated: ()=>({ setState: setState })=>{
            setState({
                singleIssuesCreated: $9380a12614698ffc$var$initialBulkCreateState.singleIssuesCreated
            });
        },
    setCurrentJiraSite: (currentJiraSite)=>({ setState: setState })=>{
            setState({
                currentJiraSite: currentJiraSite,
                workflowValidators: null
            });
        },
    setCurrentJiraProject: (currentJiraProject)=>({ setState: setState })=>{
            setState({
                currentJiraProject: currentJiraProject,
                workflowValidators: null
            });
        },
    setNextIssueToEdit: (goToPage)=>({ setState: setState, getState: getState })=>{
            const { bulkIssuesList: bulkIssuesList, currentIssueId: currentIssueId } = getState();
            const currentIssueListIndex = bulkIssuesList.findIndex((issue)=>issue?.id === currentIssueId);
            const newBulkIssuesList = bulkIssuesList.filter((issue)=>issue?.id !== currentIssueId);
            if (currentIssueListIndex >= bulkIssuesList.length - 1) {
                setState({
                    bulkIssuesList: newBulkIssuesList,
                    closeAndAddIssuesToPage: newBulkIssuesList.length === 0
                });
                goToPage('default');
                return;
            }
            setState({
                currentIssueId: bulkIssuesList[currentIssueListIndex + 1]?.id,
                bulkIssuesList: newBulkIssuesList,
                closeAndAddIssuesToPage: newBulkIssuesList.length === 0
            });
        },
    setCurrentDefaultIssueType: (currentDefaultIssueType)=>({ setState: setState })=>{
            setState({
                currentDefaultIssueType: currentDefaultIssueType,
                workflowValidators: null
            });
        },
    setIssueTypeHasRequiredFields: (issueTypeHasRequiredFields)=>({ setState: setState })=>{
            setState({
                issueTypeHasRequiredFields: issueTypeHasRequiredFields
            });
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                error: error
            });
        },
    setManualCreateState: (manualCreateState)=>({ setState: setState, getState: getState })=>{
            const { error: error } = getState();
            const isManualError = error === $9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL || error === $9380a12614698ffc$export$b6616fff1cd26f39.PROJECT_RETRIEVAL || error === $9380a12614698ffc$export$b6616fff1cd26f39.ISSUE_TYPE_RETRIEVAL;
            if (isManualError && manualCreateState === 'loading') setState({
                manualCreateState: manualCreateState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY
            });
            else if (manualCreateState === 'error') setState({
                manualCreateState: manualCreateState,
                error: $9380a12614698ffc$export$b6616fff1cd26f39.SITE_RETRIEVAL
            }); // Can be site , project or issue type retrieval since they all have the same error message
            else setState({
                manualCreateState: manualCreateState
            });
        },
    // Resets transient bulk create state while preserving Jira configuration
    resetTransientBulkCreateState: ()=>({ setState: setState })=>{
            setState($9380a12614698ffc$var$initialTransientBulkCreateState);
        },
    resetManualBulkCreateState: ()=>({ setState: setState })=>{
            setState({
                manualCreateState: 'idle',
                error: $9380a12614698ffc$export$b6616fff1cd26f39.EMPTY,
                bulkIssuesList: []
            });
        },
    resetAIBulkCreateState: ()=>({ setState: setState })=>{
            setState({
                bulkIssuesList: [],
                aiResultViewedFiredOnce: false
            });
        },
    setAiResultViewedFiredOnce: (aiResultViewedFiredOnce)=>({ setState: setState })=>{
            setState({
                aiResultViewedFiredOnce: aiResultViewedFiredOnce
            });
        },
    resetCloseAndAddIssuesToPage: ()=>({ setState: setState })=>{
            setState({
                closeAndAddIssuesToPage: false
            });
        },
    setExpectedIssueIndices: (expectedIssueIndices)=>({ setState: setState })=>{
            setState({
                expectedIssueIndices: expectedIssueIndices
            });
        },
    setSelectedTableAdf: (selectedTableAdf)=>({ setState: setState })=>{
            setState({
                selectedTableAdf: selectedTableAdf
            });
        },
    setUserChoseManualCreation: (userChoseManualCreation)=>({ setState: setState })=>{
            setState({
                userChoseManualCreation: userChoseManualCreation
            });
        },
    setWorkflowValidators: (workflowValidators)=>({ setState: setState })=>{
            setState({
                workflowValidators: workflowValidators
            });
        },
    setIsRovoPanelWidth: (isRovoPanelWidth)=>({ setState: setState })=>{
            setState({
                isRovoPanelWidth: isRovoPanelWidth
            });
        }
};
const $9380a12614698ffc$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$9380a12614698ffc$var$initialBulkCreateState
    },
    actions: $9380a12614698ffc$var$bulkCreateActions,
    name: 'bulkCreateContext'
});
const $9380a12614698ffc$export$92252eadd295fb8a = (0, $FOT9i.createContainer)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$export$490e4a97d97cfc86 = (0, $9zUhf.createHook)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$var$useActions = (0, $9zUhf.createActionsHook)($9380a12614698ffc$var$Store);
const $9380a12614698ffc$export$1b7cc5c3228e5df3 = ()=>{
    const { setIssueTypeFields: setIssueTypeFields } = $9380a12614698ffc$var$useActions();
    return setIssueTypeFields;
};
const $9380a12614698ffc$export$870e2a44cedc7bc5 = ()=>{
    const { setIsCreatedWithAi: setIsCreatedWithAi } = $9380a12614698ffc$var$useActions();
    return setIsCreatedWithAi;
};
const $9380a12614698ffc$export$bbe8b2f72a2f0142 = ()=>{
    const { setIsCreatedFromTable: setIsCreatedFromTable } = $9380a12614698ffc$var$useActions();
    return setIsCreatedFromTable;
};
const $9380a12614698ffc$export$bd9a2bb248501d3c = ()=>{
    const { setIsCreatedFromActionItems: setIsCreatedFromActionItems } = $9380a12614698ffc$var$useActions();
    return setIsCreatedFromActionItems;
};
const $9380a12614698ffc$export$855adaee6d0178f6 = ()=>{
    const { setCurrentIssueId: setCurrentIssueId } = $9380a12614698ffc$var$useActions();
    return setCurrentIssueId;
};
const $9380a12614698ffc$export$296da57e9c6a045e = ()=>{
    const { removeBulkIssue: removeBulkIssue } = $9380a12614698ffc$var$useActions();
    return removeBulkIssue;
};
const $9380a12614698ffc$export$99381c02a30b0305 = ()=>{
    const { setNextIssueToEdit: setNextIssueToEdit } = $9380a12614698ffc$var$useActions();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    return (0, $42omo.useCallback)(()=>void setNextIssueToEdit(goToPage), [
        goToPage,
        setNextIssueToEdit
    ]);
};
const $9380a12614698ffc$export$a4390ab8bce5f04c = ()=>{
    const { setIssueTypeHasRequiredFields: setIssueTypeHasRequiredFields } = $9380a12614698ffc$var$useActions();
    return setIssueTypeHasRequiredFields;
};
const $9380a12614698ffc$export$ba3d9bfa5413fe8b = ()=>{
    const { setSingleIssuesCreated: setSingleIssuesCreated } = $9380a12614698ffc$var$useActions();
    return setSingleIssuesCreated;
};
const $9380a12614698ffc$export$ba48a27b4c861376 = ()=>{
    const { resetTransientBulkCreateState: resetTransientBulkCreateState } = $9380a12614698ffc$var$useActions();
    return resetTransientBulkCreateState;
};
const $9380a12614698ffc$export$d4106eeb3c6fb998 = ()=>{
    const { setManualCreateState: setManualCreateState } = $9380a12614698ffc$var$useActions();
    return setManualCreateState;
};
const $9380a12614698ffc$export$73a6a2784da9c400 = ()=>{
    const { resetManualBulkCreateState: resetManualBulkCreateState } = $9380a12614698ffc$var$useActions();
    return resetManualBulkCreateState;
};
const $9380a12614698ffc$export$b51cb542c700486 = ()=>{
    const { resetSingleIssuesCreated: resetSingleIssuesCreated } = $9380a12614698ffc$var$useActions();
    return resetSingleIssuesCreated;
};
const $9380a12614698ffc$export$de8db8fa7dde89bc = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.contentLastModifiedTimestamp
});
const $9380a12614698ffc$export$244e33037af9cd62 = ()=>{
    const { setContentLastModifiedTimestamp: setContentLastModifiedTimestamp } = $9380a12614698ffc$var$useActions();
    return setContentLastModifiedTimestamp;
};
const $9380a12614698ffc$export$ad6d9721593c93fd = ()=>{
    const { setInsertStorageFragmentRequestPayload: setInsertStorageFragmentRequestPayload } = $9380a12614698ffc$var$useActions();
    return setInsertStorageFragmentRequestPayload;
};
const $9380a12614698ffc$export$9a0d9cff0b566e0d = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>({
            iconUrl: (0, $f0BVO.transformStargateUrl)(state.currentDefaultIssueType?.iconUrl || ''),
            name: state.currentDefaultIssueType?.name || '',
            id: state.currentDefaultIssueType?.id || ''
        })
});
const $9380a12614698ffc$export$eece47bd38cb4087 = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>!state.isCreatedWithAi && state.bulkIssuesList.length === 0
});
const $9380a12614698ffc$export$40eff28c679d44c8 = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.bulkIssuesList
});
const $9380a12614698ffc$export$9beedfe5695c176b = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.isCreatedWithAi
});
const $9380a12614698ffc$export$a7b4ff61662e2485 = ()=>{
    const { setError: setError } = $9380a12614698ffc$var$useActions();
    return setError;
};
const $9380a12614698ffc$export$8f38f84afcc073bc = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.closeAndAddIssuesToPage
});
const $9380a12614698ffc$export$8ed14da773b8613e = ()=>{
    const { resetCloseAndAddIssuesToPage: resetCloseAndAddIssuesToPage } = $9380a12614698ffc$var$useActions();
    return resetCloseAndAddIssuesToPage;
};
const $9380a12614698ffc$export$d035dcbd01eeba65 = ()=>{
    const { setBulkIssuesList: setBulkIssuesList } = $9380a12614698ffc$var$useActions();
    return setBulkIssuesList;
};
const $9380a12614698ffc$export$8698bd5657d8677 = ()=>{
    const { setExpectedIssueIndices: setExpectedIssueIndices } = $9380a12614698ffc$var$useActions();
    return setExpectedIssueIndices;
};
const $9380a12614698ffc$export$d3b3009eefe8d2e5 = ()=>{
    const { setSelectedTableAdf: setSelectedTableAdf } = $9380a12614698ffc$var$useActions();
    return setSelectedTableAdf;
};
const $9380a12614698ffc$export$98217e1ec518131b = ()=>{
    const { setUserChoseManualCreation: setUserChoseManualCreation } = $9380a12614698ffc$var$useActions();
    return setUserChoseManualCreation;
};
const $9380a12614698ffc$export$54281b991e018e12 = ()=>{
    const { setCurrentJiraSite: setCurrentJiraSite } = $9380a12614698ffc$var$useActions();
    return setCurrentJiraSite;
};
const $9380a12614698ffc$export$3083f19844329ad0 = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>({
            currentJiraSite: state.currentJiraSite,
            currentJiraProject: state.currentJiraProject,
            currentDefaultIssueType: state.currentDefaultIssueType
        })
});
const $9380a12614698ffc$export$d414bfb39fd535d3 = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.workflowValidators
});
const $9380a12614698ffc$export$c70d454f6bb9e8b8 = ()=>{
    const { setWorkflowValidators: setWorkflowValidators } = $9380a12614698ffc$var$useActions();
    return setWorkflowValidators;
};
const $9380a12614698ffc$export$f430a11618be5cac = (0, $9zUhf.createStateHook)($9380a12614698ffc$var$Store, {
    selector: (state)=>state.isRovoPanelWidth
});
const $9380a12614698ffc$export$713d96f50e0cb8bb = ()=>{
    const { setIsRovoPanelWidth: setIsRovoPanelWidth } = $9380a12614698ffc$var$useActions();
    return setIsRovoPanelWidth;
};
const $9380a12614698ffc$export$5d9e87214479bf28 = 'Initiative';
const $9380a12614698ffc$export$d93b204c953f19e9 = 'Epic';
module.exports["AiStates"] = $9380a12614698ffc$export$298219811dc2c4cb;
module.exports["ErrorStates"] = $9380a12614698ffc$export$b6616fff1cd26f39;
module.exports["ErrorMessageMap"] = $9380a12614698ffc$export$ed15e8f0bf6a46a2;
module.exports["BulkCreateContainer"] = $9380a12614698ffc$export$92252eadd295fb8a;
module.exports["useBulkCreateContext"] = $9380a12614698ffc$export$490e4a97d97cfc86;
module.exports["useSetIssueTypeFields"] = $9380a12614698ffc$export$1b7cc5c3228e5df3;
module.exports["useSetIsCreatedWithAi"] = $9380a12614698ffc$export$870e2a44cedc7bc5;
module.exports["useSetIsCreatedFromTable"] = $9380a12614698ffc$export$bbe8b2f72a2f0142;
module.exports["useSetIsCreatedFromActionItems"] = $9380a12614698ffc$export$bd9a2bb248501d3c;
module.exports["useSetCurrentIssueId"] = $9380a12614698ffc$export$855adaee6d0178f6;
module.exports["useRemoveBulkIssue"] = $9380a12614698ffc$export$296da57e9c6a045e;
module.exports["useSetNextIssueToEdit"] = $9380a12614698ffc$export$99381c02a30b0305;
module.exports["useSetIssueTypeHasRequiredFields"] = $9380a12614698ffc$export$a4390ab8bce5f04c;
module.exports["useSetSingleIssuesCreated"] = $9380a12614698ffc$export$ba3d9bfa5413fe8b;
module.exports["useResetTransientBulkCreateState"] = $9380a12614698ffc$export$ba48a27b4c861376;
module.exports["useSetManualCreateState"] = $9380a12614698ffc$export$d4106eeb3c6fb998;
module.exports["useResetManualBulkCreateState"] = $9380a12614698ffc$export$73a6a2784da9c400;
module.exports["useResetSingleIssuesCreated"] = $9380a12614698ffc$export$b51cb542c700486;
module.exports["useGetContentLastModifiedTimestamp"] = $9380a12614698ffc$export$de8db8fa7dde89bc;
module.exports["useSetContentLastModifiedTimestamp"] = $9380a12614698ffc$export$244e33037af9cd62;
module.exports["useSetInsertStorageFragmentRequestPayload"] = $9380a12614698ffc$export$ad6d9721593c93fd;
module.exports["useGetIssueType"] = $9380a12614698ffc$export$9a0d9cff0b566e0d;
module.exports["useGetIsMissingColumnMappingError"] = $9380a12614698ffc$export$eece47bd38cb4087;
module.exports["useBulkIssuesList"] = $9380a12614698ffc$export$40eff28c679d44c8;
module.exports["useIsCreatedWithAi"] = $9380a12614698ffc$export$9beedfe5695c176b;
module.exports["useSetError"] = $9380a12614698ffc$export$a7b4ff61662e2485;
module.exports["useCloseAndAddIssuesToPage"] = $9380a12614698ffc$export$8f38f84afcc073bc;
module.exports["useResetCloseAndAddIssuesToPage"] = $9380a12614698ffc$export$8ed14da773b8613e;
module.exports["useSetBulkIssuesList"] = $9380a12614698ffc$export$d035dcbd01eeba65;
module.exports["useSetSelectedTableAdf"] = $9380a12614698ffc$export$d3b3009eefe8d2e5;
module.exports["useSetUserChoseManualCreation"] = $9380a12614698ffc$export$98217e1ec518131b;
module.exports["useSetCurrentJiraSite"] = $9380a12614698ffc$export$54281b991e018e12;
module.exports["useGetJiraConfig"] = $9380a12614698ffc$export$3083f19844329ad0;
module.exports["useGetWorkflowValidators"] = $9380a12614698ffc$export$d414bfb39fd535d3;
module.exports["useSetWorkflowValidators"] = $9380a12614698ffc$export$c70d454f6bb9e8b8;
module.exports["useIsRovoPanelWidth"] = $9380a12614698ffc$export$f430a11618be5cac;
module.exports["useSetIsRovoPanelWidth"] = $9380a12614698ffc$export$713d96f50e0cb8bb;

});

parcelRegister("1uJpg", function(module, exports) {
/* RainbowLoadingSidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $0309755d49e5df30$var$defaultStyles = null;
const $0309755d49e5df30$var$animateBorder = null;
const $0309755d49e5df30$var$gradientBarStyles = null;
const $0309755d49e5df30$var$addAngleStyles = null;
const $0309755d49e5df30$export$b4f1b3140b8717f8 = ({ children: children, isShown: isShown })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testId": "rainbow-loading-sidebar",
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _bfhk1ut7 _4t3i1osq _154iidpf _1xi2idpf _1ltvidpf _94n5idpf _1e0c1txw _2lx21bp4",
            isShown && "",
            isShown && "_5pio1ynq _y44vus0d _1kl7ryy8 _1rrh1i1e",
            isShown && ""
        ])
    }, children);
};
module.exports["RainbowLoadingSidebar"] = $0309755d49e5df30$export$b4f1b3140b8717f8;

});

parcelRegister("5Ew1A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");


var $kmWRd = parcelRequire("kmWRd");

const $08d13ac8ef4b9f2b$var$SidePanelWidthContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $08d13ac8ef4b9f2b$export$e69d833e16dcab27 = $08d13ac8ef4b9f2b$var$SidePanelWidthContext.Provider;
const $08d13ac8ef4b9f2b$export$b3a087f936708dae = ({ children: children, isOpen: isOpen = true })=>{
    const width = (0, $42omo.useContext)($08d13ac8ef4b9f2b$var$SidePanelWidthContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const headerHeight = bannerState.getTotalHeight(true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kmWRd.SidePanel), {
            isFixed: true,
            headerHeight: headerHeight,
            panelTop: headerHeight,
            isOpen: isOpen,
            width: width
        }, children);
    });
};
module.exports["SidePanelWidthProvider"] = $08d13ac8ef4b9f2b$export$e69d833e16dcab27;
module.exports["SidePanelWrapper"] = $08d13ac8ef4b9f2b$export$b3a087f936708dae;

});

parcelRegister("jwedr", function(module, exports) {

var $4aiCO = parcelRequire("4aiCO");


var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $ai7NK = parcelRequire("ai7NK");





var $hq2Sz = parcelRequire("hq2Sz");


var $26Yin = parcelRequire("26Yin");

const $279932bbcfc0ae5e$export$238c59c8fdf58e0f = (onClose)=>{
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { showWarningDialog: showWarningDialog, hideWarningDialog: hideWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const [{ bulkIssuesList: bulkIssuesList, aiState: aiState, error: error, isCreatedWithAi: isCreatedWithAi }] = (0, $hq2Sz.useBulkCreateContext)();
    const { logAiInteractionDismissed: logAiInteractionDismissed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const [nextLocation, setNextLocation] = (0, $42omo.useState)();
    const history = (0, $QU6QS.useHistory)();
    const isLoading = aiState === (0, $hq2Sz.AiStates).LOADING;
    const isError = error !== (0, $hq2Sz.ErrorStates).EMPTY;
    const handleConfirm = (0, $42omo.useCallback)(()=>{
        if (isCreatedWithAi && (isLoading || isError || bulkIssuesList.length === 0)) logAiInteractionDismissed();
        hideWarningDialog();
        if (nextLocation) {
            history.block(()=>{});
            history.push(nextLocation.pathname);
        }
        hideSidePanel();
        onClose();
    }, [
        bulkIssuesList,
        hideSidePanel,
        hideWarningDialog,
        history,
        isCreatedWithAi,
        isError,
        isLoading,
        logAiInteractionDismissed,
        nextLocation,
        onClose
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        hideWarningDialog();
    }, [
        hideWarningDialog
    ]);
    (0, $42omo.useEffect)(()=>{
        const unblockNavigation = history.block((location)=>{
            setNextLocation(location);
            showWarningDialog();
            return false;
        });
        return ()=>unblockNavigation && unblockNavigation();
    }, [
        history,
        showWarningDialog
    ]);
    return {
        handleConfirm: handleConfirm,
        handleCancel: handleCancel
    };
};











const $a9a03e018614f316$export$c93f6c362a2b52d9 = ()=>{
    const { hideWarningDialog: hideWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const handleConfirm = (0, $42omo.useCallback)(async ()=>{
        // This logic will be replaced by a refetch call to the AI API which will render new AI issues
        await setIsCreatedWithAi(false);
        await setIsCreatedWithAi(true);
        hideWarningDialog();
    }, [
        hideWarningDialog,
        setIsCreatedWithAi
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        hideWarningDialog();
    }, [
        hideWarningDialog
    ]);
    return {
        handleConfirm: handleConfirm,
        handleCancel: handleCancel
    };
};


const $4f64a1a829c0cee2$export$df2a64a911f4558c = (onClose)=>{
    const { handleConfirm: navConfirm, handleCancel: navCancel } = (0, $279932bbcfc0ae5e$export$238c59c8fdf58e0f)(onClose);
    const { handleConfirm: retryConfirm, handleCancel: retryCancel } = (0, $a9a03e018614f316$export$c93f6c362a2b52d9)();
    const isWarningDialogOpen = (0, $4aiCO.useIsWarningDialogOpen)();
    const warningDialog = (0, $4aiCO.useGetWarningDialog)();
    const handleConfirm = warningDialog === (0, $4aiCO.WarningDialog).FLOATING ? retryConfirm : navConfirm;
    const handleCancel = warningDialog === (0, $4aiCO.WarningDialog).FLOATING ? retryCancel : navCancel;
    return {
        isWarningDialogOpen: isWarningDialogOpen,
        handleConfirm: handleConfirm,
        handleCancel: handleCancel
    };
};
module.exports["useGetWarningDialogActions"] = $4f64a1a829c0cee2$export$df2a64a911f4558c;

});

parcelRegister("5FJ5W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $5dK2X = parcelRequire("5dK2X");


var $1GzhS = parcelRequire("1GzhS");


var $dcJ7R = parcelRequire("dcJ7R");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3E5yu = parcelRequire("3E5yu");

const $b386c1485ada9c1f$var$GeneratingAnimation = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
const $b386c1485ada9c1f$var$loadingContainerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    padding: 'space.300'
});
const $b386c1485ada9c1f$var$loadingIconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px'
});
const $b386c1485ada9c1f$export$a1eba8f1cc91eb04 = ({ loadingType: loadingType = 'single' })=>{
    const loadingMessage = (0, $42omo.useMemo)(()=>{
        if ((0, $9wGTI.fg)('confluence-issue-terminology-refresh')) {
            const loadingSingleMessageRefresh = (0, $6mKj3.expVal)('aiwc_confluence_update_loading_message', 'isEnabled', false) ? (0, $3E5yu.messages).sidePanelAiLoadingIssueExperimentRebrandToRovo : (0, $3E5yu.messages).sidePanelAiLoadingIssueTermRefresh;
            return loadingType === 'bulk' ? (0, $3E5yu.messages).sidePanelAiLoadingBulkIssueTermRefresh : loadingSingleMessageRefresh;
        }
        const loadingSingleMessage = (0, $6mKj3.expVal)('aiwc_confluence_update_loading_message', 'isEnabled', false) ? (0, $3E5yu.messages).sidePanelAiLoadingIssueExperimentRebrandToRovo : (0, $3E5yu.messages).sidePanelAiLoading;
        return loadingType === 'bulk' ? (0, $3E5yu.messages).sidePanelAiLoadingBulk : loadingSingleMessage;
    }, [
        loadingType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b386c1485ada9c1f$var$loadingContainerStyles,
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b386c1485ada9c1f$var$loadingIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b386c1485ada9c1f$var$GeneratingAnimation, {
        alt: "Generating"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "large",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), loadingMessage))));
};
module.exports["IssueCreateAiLoading"] = $b386c1485ada9c1f$export$a1eba8f1cc91eb04;

});

parcelRegister("1Q0l6", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6mKj3 = parcelRequire("6mKj3");


var $1mDVg = parcelRequire("1mDVg");


var $euVTc = parcelRequire("euVTc");

const $d1908e0af5aa886c$var$REFRESH_TIMEOUT = 3000;
const $d1908e0af5aa886c$export$78fd671954584729 = (jiraSiteUrl, issueKey)=>{
    return `${jiraSiteUrl}/browse/${issueKey}`;
};
const $d1908e0af5aa886c$export$9f5042b23377cc4d = (children)=>{
    return `<div><br />${children}</div>`;
};
const $d1908e0af5aa886c$export$abe60dca128cf840 = (url)=>{
    return `<a href="${url}" data-card-appearance="inline">${url}</a>`;
};
const $d1908e0af5aa886c$export$44af636f2297de15 = (urls)=>{
    return urls.map((url)=>$d1908e0af5aa886c$export$abe60dca128cf840(url)).join(' ');
};
const $d1908e0af5aa886c$export$8f3860761b656032 = (text)=>{
    return `<h2>${text}</h2>`;
};
const $d1908e0af5aa886c$export$5a351b98ac81cb91 = (columnToFieldMappings, isCreatedWithAi)=>{
    // When bulk creating with AI there is currently not support for mapping table columns to work item fields.
    // Therefore we always insert the summary into the first column.
    if (isCreatedWithAi) return 0;
    const summaryMapping = columnToFieldMappings?.find((mapping)=>mapping.field?.fieldId === 'summary');
    return summaryMapping?.column?.index;
};
const $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag = ()=>{
    const metaTag = document.querySelector(`meta[name="confluence-request-time"]`);
    return metaTag ? Number(metaTag.getAttribute('content')) : null;
};
// Get last fetch time of current page.
// This used to be the request time, but this caused problems due to time drift between the server and database.
// So now try to use the content last modification date on load if that exists, then fallback onto the
// request time if it's not available.
const $d1908e0af5aa886c$var$getLastFetchTime = (lastModified)=>lastModified ? new Date(lastModified).getTime() : $d1908e0af5aa886c$var$getLastFetchTimeFromMetaTag();
const $d1908e0af5aa886c$var$constructBasePayload = (result)=>{
    // This happens when the page is completely empty.
    if (!result || !result.searchText || result.searchText.numMatches === undefined) return {
        selectedText: '',
        index: -1,
        numMatches: 0
    };
    const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = result;
    return {
        selectedText: selectedText,
        index: matchIndex,
        numMatches: numMatches
    };
};
const $d1908e0af5aa886c$export$3135b2526beb9ea6 = (contentId, convertSelectionToLegacyFormat, range, contentRef, lastModified)=>{
    const result = convertSelectionToLegacyFormat(contentRef, range, contentId);
    return {
        ...$d1908e0af5aa886c$var$constructBasePayload(result),
        pageId: contentId,
        lastFetchTime: $d1908e0af5aa886c$var$getLastFetchTime(lastModified),
        xmlModification: undefined
    };
};
const $d1908e0af5aa886c$export$914430c62ea916b5 = (contentId, convertSelectionToLegacyFormat, ranges, contentRef, lastModified)=>{
    const result = [];
    let id = 0;
    for (const range of ranges)result.push({
        ...$d1908e0af5aa886c$var$constructBasePayload(convertSelectionToLegacyFormat(contentRef, range, contentId)),
        xmlModification: undefined,
        rowIndex: String(id++)
    });
    return {
        pageId: contentId,
        lastFetchTime: $d1908e0af5aa886c$var$getLastFetchTime(lastModified),
        fragments: result
    };
};
const $d1908e0af5aa886c$export$703688cefc28164e = (contentId, convertSelectionToLegacyFormat, range, contentRef, lastModified, tableColumnIndex)=>{
    const result = convertSelectionToLegacyFormat(contentRef, range, contentId);
    return {
        ...$d1908e0af5aa886c$var$constructBasePayload(result),
        pageId: contentId,
        lastFetchTime: $d1908e0af5aa886c$var$getLastFetchTime(lastModified),
        tableColumnIndex: tableColumnIndex ?? 0,
        cellModifications: []
    };
};
const $d1908e0af5aa886c$export$af14e9631e8de173 = (payload, pageMode)=>{
    if (pageMode && pageMode !== (0, $1mDVg.PageMode).VIEW) payload.lastFetchTime = Date.now();
};
const $d1908e0af5aa886c$export$2c148dbaa22fa887 = (selectedAdf, workItemUrl)=>{
    try {
        const selectedContent = selectedAdf.content ?? [];
        const updatedContent = [
            ...selectedContent,
            {
                type: 'inlineCard',
                attrs: {
                    url: workItemUrl
                }
            }
        ];
        return {
            type: selectedAdf.type,
            attrs: selectedAdf.attrs ?? {},
            content: updatedContent
        };
    } catch  {
        return null;
    }
};
const $d1908e0af5aa886c$export$761e13f48d0db999 = async ({ insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, pageMode: pageMode, selectedAdf: selectedAdf, editorAPI: editorAPI, workItemUrl: workItemUrl })=>{
    if (pageMode !== (0, $1mDVg.PageMode).VIEW && selectedAdf && editorAPI && workItemUrl) {
        const updatedAdf = $d1908e0af5aa886c$export$2c148dbaa22fa887(selectedAdf, workItemUrl);
        const result = await $d1908e0af5aa886c$export$fb99ecbaceee1e4e(editorAPI, updatedAdf);
        if (result.status === 'document-changed') throw new Error('document-changed');
        if (result.status === 'success') // Return true to indicate that the insertion via the editor API was successful.
        // If not, we fall back to using the legacy API below.
        return true;
    }
    return $d1908e0af5aa886c$export$57c9f61b323299ee(insertStorageFragmentRequestPayload);
};
const $d1908e0af5aa886c$export$57c9f61b323299ee = async (insertStorageFragmentRequestPayload)=>{
    try {
        const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-fragment';
        const response = await (0, $f7B1p.cfetch)(restUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(insertStorageFragmentRequestPayload)
        });
        if (!response.ok) throw new Error('Insert storage fragment request failed');
        return await response.json();
    } catch (error) {
        throw error;
    }
};
const $d1908e0af5aa886c$export$74ebcab4c727b6c6 = async (InsertMultipleStorageFragmentsRequestPayload)=>{
    const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-fragments';
    const response = await (0, $f7B1p.cfetch)(restUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(InsertMultipleStorageFragmentsRequestPayload)
    });
    if (!response.ok) throw new Error('Insert storage fragments request failed');
    return response.json();
};
const $d1908e0af5aa886c$export$1f11e8d398d7ee36 = async (insertStorageColumnTableRequestPayload)=>{
    const restUrl = '/wiki/rest/highlighting/1.0/insert-storage-column-table';
    const response = await (0, $f7B1p.cfetch)(restUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(insertStorageColumnTableRequestPayload)
    });
    if (!response.ok) throw new Error('Insert storage column table request failed');
    return response.json();
};
const $d1908e0af5aa886c$export$63b770721cbd3eed = ()=>{
    setTimeout(()=>{
        window.location.reload();
    }, $d1908e0af5aa886c$var$REFRESH_TIMEOUT);
};
const $d1908e0af5aa886c$var$findDeepestChild = (node)=>{
    let current = node;
    while(current.hasChildNodes())current = current.lastChild;
    return current;
};
const $d1908e0af5aa886c$export$7c90eb3225536b1 = (originalRange)=>{
    if (!originalRange) return undefined;
    const currentNode = $d1908e0af5aa886c$var$findDeepestChild(originalRange.endContainer);
    return $d1908e0af5aa886c$export$61726a905a82cbc1(originalRange, currentNode);
};
const $d1908e0af5aa886c$export$61726a905a82cbc1 = (originalRange, startNode)=>{
    if (!originalRange) return undefined;
    const newRange = document.createRange();
    let lastTextNode = null;
    let lastTextNodeStartOffset = 0;
    let lastTextNodeEndOffset = 0;
    const INVALID_NODE_SELECTORS = [
        // Status macro
        'span[data-node-type="status"]',
        // Inline Smart Card/Jira issue link
        '[data-inline-card="true"]',
        '.inlineCardView-content-wrap',
        '.smart-link-title-wrapper'
    ].join(',');
    const isInvalidNode = (node)=>{
        return node.nodeType === Node.ELEMENT_NODE && node.matches(INVALID_NODE_SELECTORS);
    };
    const hasInvalidAncestor = (node, ancestorLimit)=>{
        let currentNode = node;
        while(currentNode && currentNode !== ancestorLimit){
            if (isInvalidNode(currentNode)) return true;
            currentNode = currentNode.parentNode;
        }
        return false;
    };
    const previousNode = (node, range)=>{
        if (node.previousSibling) {
            node = node.previousSibling;
            while(node.hasChildNodes() && !isInvalidNode(node))node = node.lastChild;
            return node;
        }
        return node.parentNode && node.parentNode !== range.commonAncestorContainer ? node.parentNode : null;
    };
    let currentNode = startNode ?? originalRange.endContainer;
    while(currentNode){
        // If the current node is a text node and it is not empty, and it does not have an invalid ancestor, then it is a valid node.
        if (currentNode.nodeType === Node.TEXT_NODE && currentNode.textContent && currentNode.textContent.trim() !== '' && !hasInvalidAncestor(currentNode, originalRange.commonAncestorContainer)) {
            lastTextNode = currentNode;
            if (originalRange.endContainer === currentNode) lastTextNodeEndOffset = originalRange.endOffset;
            else lastTextNodeEndOffset = currentNode.textContent.length;
            if (originalRange.startContainer === currentNode) lastTextNodeStartOffset = originalRange.startOffset;
            else lastTextNodeStartOffset = 0;
            break; // Early termination as soon as we find the last valid text node.
        }
        // Terminate when we reach the start of the original range.
        if (currentNode === originalRange.startContainer) break;
        currentNode = previousNode(currentNode, originalRange);
    }
    if (lastTextNode) {
        newRange.setStart(lastTextNode, lastTextNodeStartOffset);
        newRange.setEnd(lastTextNode, lastTextNodeEndOffset);
        return newRange;
    }
    return originalRange;
};
const $d1908e0af5aa886c$export$6884d917093a4918 = ()=>{
    const contentElement = document.getElementById('main-content');
    if (contentElement) {
        const range = document.createRange();
        range.selectNodeContents(contentElement);
        const endContainer = $d1908e0af5aa886c$var$findDeepestChild(range.endContainer);
        let endOffset = 0;
        if (endContainer.nodeType === Node.TEXT_NODE) endOffset = endContainer.textContent?.length || 0;
        else if (endContainer.nodeType === Node.ELEMENT_NODE) endOffset = endContainer.childNodes.length;
        range.setEnd(endContainer, endOffset);
        return range;
    }
    return undefined;
};
const $d1908e0af5aa886c$export$fb99ecbaceee1e4e = async (editorApi, adfNode)=>{
    if (!editorApi || !adfNode) return {
        status: 'failed-to-replace'
    };
    try {
        const result = await editorApi.selectionExtension?.actions.replaceWithAdf(adfNode);
        const status = result?.status === 'success' || result?.status === 'document-changed' ? result?.status : 'failed-to-replace';
        return {
            status: status
        };
    } catch  {
        return {
            status: 'failed-to-replace'
        };
    }
};
const $d1908e0af5aa886c$export$3724e27407b1cddd = async ({ createdIssues: createdIssues, currentJiraSiteUrl: currentJiraSiteUrl, pageMode: pageMode, selectedTableAdf: selectedTableAdf, editorAPI: editorAPI, payload: payload, summaryInsertionColumn: summaryInsertionColumn })=>{
    // Determine that we are in a non-view mode and whether we should use editorAPI for insertion
    const isEditorPathEnabled = (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) && pageMode !== (0, $1mDVg.PageMode).VIEW;
    if (isEditorPathEnabled && selectedTableAdf && editorAPI && summaryInsertionColumn != null) {
        // Construct map of row indices to work item URLs
        const workItemsByRow = new Map();
        for (const issue of createdIssues)if (issue.rowIndex != null) workItemsByRow.set(Number(issue.rowIndex), $d1908e0af5aa886c$export$78fd671954584729(currentJiraSiteUrl, issue.key));
        const tableAdf = (0, $euVTc.constructTableWithWorkItems)(selectedTableAdf, workItemsByRow, summaryInsertionColumn);
        if (!tableAdf) return false;
        const result = await $d1908e0af5aa886c$export$fb99ecbaceee1e4e(editorAPI, tableAdf);
        if (result.status === 'document-changed') throw new Error('document-changed');
        return result.status === 'success';
    }
    const response = await $d1908e0af5aa886c$export$1f11e8d398d7ee36(payload);
    return response;
};
module.exports["constructJiraIssueUrl"] = $d1908e0af5aa886c$export$78fd671954584729;
module.exports["constructBreakContainerTag"] = $d1908e0af5aa886c$export$9f5042b23377cc4d;
module.exports["constructSmartlinkTag"] = $d1908e0af5aa886c$export$abe60dca128cf840;
module.exports["bulkConstructSmartlinkTags"] = $d1908e0af5aa886c$export$44af636f2297de15;
module.exports["constructHeading"] = $d1908e0af5aa886c$export$8f3860761b656032;
module.exports["getSummaryInsertionColumn"] = $d1908e0af5aa886c$export$5a351b98ac81cb91;
module.exports["constructInsertStorageFragmentRequestPayload"] = $d1908e0af5aa886c$export$3135b2526beb9ea6;
module.exports["constructInsertMultipleStorageFragmentsRequestPayload"] = $d1908e0af5aa886c$export$914430c62ea916b5;
module.exports["constructInsertStorageColumnTableRequestPayload"] = $d1908e0af5aa886c$export$703688cefc28164e;
module.exports["updateLastFetchTimeIfNotViewMode"] = $d1908e0af5aa886c$export$af14e9631e8de173;
module.exports["insertSingleWorkItemToEndOfSelection"] = $d1908e0af5aa886c$export$761e13f48d0db999;
module.exports["insertContentAtSelectionEnd"] = $d1908e0af5aa886c$export$57c9f61b323299ee;
module.exports["insertMultipleContentAtSelectionEnd"] = $d1908e0af5aa886c$export$74ebcab4c727b6c6;
module.exports["refreshPageWithTimeout"] = $d1908e0af5aa886c$export$63b770721cbd3eed;
module.exports["getValidRangeForActionItem"] = $d1908e0af5aa886c$export$7c90eb3225536b1;
module.exports["getValidRange"] = $d1908e0af5aa886c$export$61726a905a82cbc1;
module.exports["getPageContentRange"] = $d1908e0af5aa886c$export$6884d917093a4918;
module.exports["insertWorkItemsIntoTable"] = $d1908e0af5aa886c$export$3724e27407b1cddd;

});

parcelRegister("euVTc", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $2R8mu = parcelRequire("2R8mu");


var $CbMiC = parcelRequire("CbMiC");

const $39b1e229aed8b0e2$var$TEAM_ID_PATTERN = /[0-9A-Za-z]{8}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{4}-[0-9A-Za-z]{12}/;
const $39b1e229aed8b0e2$var$getFieldTypeFromMapping = (mapping)=>{
    if (mapping.field) return $39b1e229aed8b0e2$export$485ff2ccf56b085f(mapping.field);
    return (0, $CbMiC.FieldType).UNSUPPORTED;
};
const $39b1e229aed8b0e2$export$485ff2ccf56b085f = (metadata)=>{
    switch(metadata.schema.type){
        // "SHORT_TEXT" is the least restrictive type, so we can use it for "ANY"
        case (0, $2R8mu.FieldMetadataSchemaType).STRING:
            const customType = metadata.schema.custom;
            return customType === (0, $2R8mu.FieldMetadataSchemaCustom).TEXT_AREA ? (0, $CbMiC.FieldType).PARAGRAPH : (0, $CbMiC.FieldType).SHORT_TEXT;
        case (0, $2R8mu.FieldMetadataSchemaType).NUMBER:
            return (0, $CbMiC.FieldType).NUMBER;
        case (0, $2R8mu.FieldMetadataSchemaType).DATE:
            return (0, $CbMiC.FieldType).DATE;
        case (0, $2R8mu.FieldMetadataSchemaType).USER:
            return (0, $CbMiC.FieldType).USER;
        case (0, $2R8mu.FieldMetadataSchemaType).PRIORITY:
            return (0, $CbMiC.FieldType).PRIORITY;
        case (0, $2R8mu.FieldMetadataSchemaType).DATETIME:
            return (0, $CbMiC.FieldType).TIMESTAMP;
        case (0, $2R8mu.FieldMetadataSchemaType).ARRAY:
            if (metadata.schema.custom === (0, $2R8mu.FieldMetadataSchemaCustom).PEOPLE) return (0, $CbMiC.FieldType).PEOPLE;
            else if (metadata.schema.system === (0, $2R8mu.FieldMetadataSchemaSystem).LABELS) return (0, $CbMiC.FieldType).LABELS;
            else if (metadata.schema.items === (0, $2R8mu.FieldMetadataSchemaItems).VERSION) return (0, $CbMiC.FieldType).VERSIONS;
            else if (metadata.schema.items === (0, $2R8mu.FieldMetadataSchemaItems).OPTION && metadata.operations?.includes((0, $2R8mu.FieldMetadataSchemaOperations).ADD)) return (0, $CbMiC.FieldType).MULTI_SELECT;
            else if (metadata.schema.items === (0, $2R8mu.FieldMetadataSchemaItems).OPTION && metadata.operations?.includes((0, $2R8mu.FieldMetadataSchemaOperations).SET)) return (0, $CbMiC.FieldType).SINGLE_SELECT;
            return (0, $CbMiC.FieldType).UNSUPPORTED;
        case (0, $2R8mu.FieldMetadataSchemaType).TEAM:
            return (0, $CbMiC.FieldType).TEAM;
        case (0, $2R8mu.FieldMetadataSchemaType).ISSUELINK:
            if (metadata.schema.system === (0, $2R8mu.FieldMetadataSchemaSystem).PARENT) return (0, $CbMiC.FieldType).PARENT;
            return (0, $CbMiC.FieldType).UNSUPPORTED;
        case (0, $2R8mu.FieldMetadataSchemaType).COMPONENTS:
            // NOTE: Components are not a standard field type.
            return (0, $CbMiC.FieldType).COMPONENTS;
        default:
            return (0, $CbMiC.FieldType).UNSUPPORTED;
    }
};
const $39b1e229aed8b0e2$var$getMentionAccountIdFromAdfNode = (adfNode)=>{
    return adfNode.type == 'mention' && adfNode.attrs?.id ? adfNode.attrs.id : null;
};
const $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    const accountIds = [];
    let node;
    while((node = nodes.pop()) !== undefined){
        const accountId = $39b1e229aed8b0e2$var$getMentionAccountIdFromAdfNode(node);
        accountId && accountIds.push(node.attrs.id);
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
    }
    return accountIds;
};
const $39b1e229aed8b0e2$var$getTeamIdFromUrl = (urlString)=>{
    if (!urlString) return null;
    let url;
    try {
        url = new URL(urlString);
    } catch  {
        return null;
    }
    const path = url.pathname;
    const pathParts = path.split('/');
    if (path.startsWith('/people/team') && pathParts.length > 3) {
        const teamId = pathParts[3];
        return teamId.match($39b1e229aed8b0e2$var$TEAM_ID_PATTERN) ? teamId : null;
    }
    return null;
};
const $39b1e229aed8b0e2$var$getTeamIdFromAdfNode = (adfNode)=>{
    let urlString;
    if (adfNode.type == 'inlineCard' || adfNode.type == 'blockCard') urlString = adfNode.attrs?.url;
    else if (adfNode.type == 'link') urlString = adfNode.attrs?.href;
    else if (adfNode.type == 'text') urlString = adfNode.text;
    return $39b1e229aed8b0e2$var$getTeamIdFromUrl(urlString);
};
const $39b1e229aed8b0e2$var$getTeamIdFromAdfTree = (adf)=>{
    const nodes = [
        adf
    ];
    let node;
    while((node = nodes.pop()) !== undefined){
        const teamId = $39b1e229aed8b0e2$var$getTeamIdFromAdfNode(node);
        if (teamId) return teamId;
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
        node.marks?.forEach((n)=>{
            nodes.push(n);
        });
    }
    return null;
};
const $39b1e229aed8b0e2$export$e8f4aa792ae88917 = (adf, delimeterRegex = /\s+/)=>{
    const nodes = [
        adf
    ];
    const array = [];
    let node;
    while((node = nodes.pop()) !== undefined){
        if (node.type == 'text' && node.text) array.push(...node.text.split(delimeterRegex));
        node.content?.forEach((n)=>{
            n && nodes.push(n);
        });
    }
    return array;
};
const $39b1e229aed8b0e2$export$793b299699592cd5 = (fieldType, fieldId, cell, options, fieldMetadata)=>{
    if (!cell) return null;
    const textContent = cell.textContent?.trim();
    const adf = (0, $eqKgz.htmlToADF)(cell.innerHTML);
    let accountIds;
    const dateFromTextContent = textContent ? new Date(textContent) : null;
    const validDateOrNull = dateFromTextContent && !isNaN(dateFromTextContent.getTime()) ? dateFromTextContent : null;
    switch(fieldType){
        case (0, $CbMiC.FieldType).SHORT_TEXT:
            return textContent;
        case (0, $CbMiC.FieldType).PARAGRAPH:
            return adf;
        case (0, $CbMiC.FieldType).NUMBER:
            return Number(textContent);
        case (0, $CbMiC.FieldType).DATE:
            return validDateOrNull ? validDateOrNull.toISOString().split('T')[0] : null;
        case (0, $CbMiC.FieldType).USER:
            accountIds = $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree(adf);
            return accountIds.length > 0 ? {
                id: accountIds[0]
            } : null;
        case (0, $CbMiC.FieldType).PRIORITY:
            const prioritiesAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isIdNameObjectList)(prioritiesAllowedValues)) return null;
            // Priorities cannot have the same name and are case-insensitive, so we can do a lenient match.
            const lenientPriority = $39b1e229aed8b0e2$var$findLenientMatches(textContent, prioritiesAllowedValues);
            return lenientPriority.length > 0 ? {
                name: lenientPriority[0].name,
                id: lenientPriority[0].id
            } : null;
        case (0, $CbMiC.FieldType).COMPONENTS:
            const componentsAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isIdNameObjectList)(componentsAllowedValues)) return null;
            const lenientComponents = $39b1e229aed8b0e2$var$findLenientMatches(textContent, componentsAllowedValues, /\n+/, adf);
            return lenientComponents.length > 0 ? lenientComponents.map((component)=>({
                    id: component.id
                })) : null;
        case (0, $CbMiC.FieldType).VERSIONS:
            const versionsAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isIdNameObjectList)(versionsAllowedValues)) return null;
            const lenientVersions = $39b1e229aed8b0e2$var$findLenientMatches(textContent, versionsAllowedValues, /\n+/, adf);
            return lenientVersions.length > 0 ? lenientVersions.map((version)=>({
                    id: version.id
                })) : null;
        case (0, $CbMiC.FieldType).SINGLE_SELECT:
        case (0, $CbMiC.FieldType).MULTI_SELECT:
            const selectAllowedValues = options.mappingFieldAllowedValues.get(fieldId);
            if (!(0, $2R8mu.isSelectOptionList)(selectAllowedValues)) return null;
            // Convert the allowedValues to the format expected by findLenientMatches
            const lenientOptions = $39b1e229aed8b0e2$var$findLenientMatches(textContent, selectAllowedValues.map((option)=>({
                    name: option.value,
                    id: option.id
                })), /\n+/, adf);
            return lenientOptions.length > 0 ? lenientOptions : null;
        case (0, $CbMiC.FieldType).TIMESTAMP:
            return validDateOrNull ? validDateOrNull.toISOString() : null;
        case (0, $CbMiC.FieldType).PEOPLE:
            accountIds = $39b1e229aed8b0e2$var$getMentionAccountIdsFromAdfTree(adf);
            return accountIds.length > 0 ? accountIds.map((id)=>({
                    id: id
                })) : null;
        case (0, $CbMiC.FieldType).LABELS:
            return $39b1e229aed8b0e2$export$e8f4aa792ae88917(adf);
        case (0, $CbMiC.FieldType).TEAM:
            return $39b1e229aed8b0e2$var$getTeamIdFromAdfTree(adf);
        case (0, $CbMiC.FieldType).PARENT:
            if (textContent == null) return null;
            const trimmedKey = textContent.toUpperCase().trim();
            const mappedType = options.mappingValidParentCandidates?.get(trimmedKey);
            return mappedType ? {
                key: mappedType.key,
                id: mappedType.issueId
            } : undefined;
        default:
            // Check for field-specific allowedValues validation for custom fields
            if (fieldMetadata && fieldMetadata.allowedValues && options.mappingFieldAllowedValues) {
                const fieldValidationResult = $39b1e229aed8b0e2$var$validateFieldWithAllowedValues(textContent, fieldMetadata.fieldId, options);
                if (fieldValidationResult) return fieldValidationResult;
            }
            return textContent;
    }
};
const $39b1e229aed8b0e2$var$findLenientMatches = (textContent, availableItems, delimiterRegex = /\n+/, adf)=>{
    if (!textContent || !availableItems) return [];
    const searchTexts = adf ? $39b1e229aed8b0e2$export$e8f4aa792ae88917(adf, delimiterRegex) : [
        textContent
    ];
    return searchTexts.map((searchText)=>availableItems.find((item)=>item.name.trim().toLowerCase() === searchText.trim().toLowerCase())).filter((item)=>item !== undefined);
};
// Flexible function to find text matches in allowedValues with different structures
// Supports various allowedValues formats:
// - { name: string, id: string } (priorities)
// - { name: string, value: string } (custom dropdowns)
// - { displayName: string, value: string } (some custom fields)
const $39b1e229aed8b0e2$var$findFlexibleMatches = (textContent, allowedValues)=>{
    if (!textContent || !allowedValues) return [];
    const searchText = textContent.trim().toLowerCase();
    return allowedValues.filter((item)=>{
        if (!item || typeof item !== 'object') return false;
        const obj = item;
        // Try different property names that might contain the display text
        // Order matters: more specific names first
        const possibleTextProperties = [
            'name',
            'displayName',
            'value'
        ];
        for (const prop of possibleTextProperties)if (obj[prop] && typeof obj[prop] === 'string') {
            if (obj[prop].trim().toLowerCase() === searchText) return true;
        }
        return false;
    });
};
const $39b1e229aed8b0e2$var$validateFieldWithAllowedValues = (textContent, fieldId, options)=>{
    if (!textContent || !fieldId) return null;
    // Look up field-specific allowedValues
    const fieldAllowedValues = options?.mappingFieldAllowedValues?.get(fieldId);
    if (fieldAllowedValues && Array.isArray(fieldAllowedValues)) {
        const matches = $39b1e229aed8b0e2$var$findFlexibleMatches(textContent, fieldAllowedValues);
        return matches.length > 0 ? matches[0] : null;
    }
    return null;
};
// Empty rows are not included in the issue create list, so we should not include them in the validation
const $39b1e229aed8b0e2$var$rowIsEmpty = (row)=>{
    return Array.from(row.cells).every((cell)=>cell.textContent?.trim() === '');
};
const $39b1e229aed8b0e2$export$aa8024509e414d36 = (cells)=>{
    if (!Array.isArray(cells) || cells.length === 0) return false;
    const first = cells[0];
    // Address HTML table cells
    if (first && typeof first === 'object' && 'tagName' in first) return cells.every((cell)=>cell.tagName?.toLowerCase() === 'th' || cell.classList?.contains('ak-renderer-table-number-column'));
    // Address ADF cell nodes
    return cells.every((c)=>c?.type === 'tableHeader');
};
function $39b1e229aed8b0e2$var$adjustInsertionColumn(rows, targetRows, startIndex = 0) {
    const firstTargetRow = [
        ...targetRows.keys()
    ][0];
    const row = rows[firstTargetRow];
    if (!row || row.type !== 'tableRow' || !row.content) return -1;
    const firstTableCellIndex = row.content.slice(startIndex).findIndex((cell)=>cell?.type === 'tableCell');
    if (firstTableCellIndex < 0) return -1;
    return startIndex + firstTableCellIndex;
}
const $39b1e229aed8b0e2$export$cd6fbae9421c69c7 = (fieldType, fieldId, column, table, validator, options, fieldMetadata)=>{
    const rows = Array.from(table.rows).slice(1);
    // Ignore completely empty rows for validation purposes
    const nonEmptyRows = rows.filter((row)=>!$39b1e229aed8b0e2$var$rowIsEmpty(row));
    const totalRowCount = nonEmptyRows.length;
    if (totalRowCount === 0) return null;
    // Get all field values from non-empty rows (ignore empty rows entirely)
    const allFieldValues = nonEmptyRows.map((row)=>$39b1e229aed8b0e2$export$793b299699592cd5(fieldType, fieldId, row.cells[column.index], options, fieldMetadata));
    // Filter out null values and apply validator for the final fieldValues array
    const fieldValues = allFieldValues.filter((value)=>value !== null && validator(value));
    // Count how many of the ALL original values (including nulls) are valid
    const validValues = allFieldValues.filter(validator);
    // If no valid values, return null
    if (validValues.length === 0) return null;
    return {
        canBeRequired: validValues.length === totalRowCount,
        fieldValues: fieldValues
    };
};
const $39b1e229aed8b0e2$export$dea6de0898ac5b8 = (column, fieldId, table, options)=>{
    const validatedIssueFieldValues = new Map();
    const setIfNotNull = (fieldType, validatedValues)=>{
        if (validatedValues) validatedIssueFieldValues.set(fieldType, validatedValues);
    };
    const dateValidator = (value)=>value != null && !isNaN(new Date(value.toString()).getTime());
    const userValidator = (value)=>value != null;
    const textValidator = (value)=>value != null && typeof value === 'string' && value.trim().length > 0;
    const adfValidator = (value)=>value != null && typeof value === 'object';
    const shortTextResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).SHORT_TEXT, fieldId, column, table, textValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).SHORT_TEXT, shortTextResult);
    const paragraphResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PARAGRAPH, fieldId, column, table, adfValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).PARAGRAPH, paragraphResult);
    const numberResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).NUMBER, fieldId, column, table, (value)=>value != null && !Number.isNaN(Number(value)), options);
    setIfNotNull((0, $CbMiC.FieldType).NUMBER, numberResult);
    const dateResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).DATE, fieldId, column, table, dateValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).DATE, dateResult);
    const timestampResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).TIMESTAMP, fieldId, column, table, dateValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).TIMESTAMP, timestampResult);
    const userResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).USER, fieldId, column, table, userValidator, options);
    setIfNotNull((0, $CbMiC.FieldType).USER, userResult);
    const priorityResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PRIORITY, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).PRIORITY, priorityResult);
    const componentResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).COMPONENTS, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).COMPONENTS, componentResult);
    const versionsResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).VERSIONS, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).VERSIONS, versionsResult);
    const peopleResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PEOPLE, fieldId, column, table, (values)=>Array.isArray(values) && values.every(userValidator), options);
    setIfNotNull((0, $CbMiC.FieldType).PEOPLE, peopleResult);
    const teamResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).TEAM, fieldId, column, table, (value)=>!!value?.toString().match($39b1e229aed8b0e2$var$TEAM_ID_PATTERN), options);
    setIfNotNull((0, $CbMiC.FieldType).TEAM, teamResult);
    const labelsResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).LABELS, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).LABELS, labelsResult);
    const parentResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).PARENT, fieldId, column, table, (value)=>value != null, options);
    setIfNotNull((0, $CbMiC.FieldType).PARENT, parentResult);
    const singleSelectResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).SINGLE_SELECT, fieldId, column, table, (value)=>value != null && Array.isArray(value) && value.length == 1, options);
    setIfNotNull((0, $CbMiC.FieldType).SINGLE_SELECT, singleSelectResult);
    const multiSelectResult = $39b1e229aed8b0e2$export$cd6fbae9421c69c7((0, $CbMiC.FieldType).MULTI_SELECT, fieldId, column, table, (value)=>value != null && Array.isArray(value) && value.length > 0, options);
    setIfNotNull((0, $CbMiC.FieldType).MULTI_SELECT, multiSelectResult);
    return validatedIssueFieldValues;
};
const $39b1e229aed8b0e2$export$90fcb8f3c3f5ab4f = (activeSelection)=>{
    if (activeSelection && activeSelection.rangeCount > 0) {
        // Get the first range from the selection
        const range = activeSelection.getRangeAt(0);
        // Start from the common ancestor container of the range
        let node = range.commonAncestorContainer;
        // If the node is a text node, move up to its parent element
        if (node?.nodeType === Node.TEXT_NODE) node = node.parentElement;
        // Traverse up the DOM tree to find the closest <table> element
        while(node && node.nodeType === Node.ELEMENT_NODE){
            if (node.tagName === 'TABLE') return node;
            node = node.parentElement;
        }
    }
    return null;
};
const $39b1e229aed8b0e2$var$isFirstRowHeader = (rows)=>rows.length > 0 && Array.from(rows[0].cells).every((cell)=>cell.tagName.toLowerCase() === 'th' || cell.classList.contains('ak-renderer-table-number-column'));
const $39b1e229aed8b0e2$export$41999e0c951335f6 = (rows)=>{
    const firstRowHeader = $39b1e229aed8b0e2$var$isFirstRowHeader(rows);
    return Array.from(rows).slice(1).flatMap((row, index)=>{
        const hasContent = Array.from(row.cells).some((cell)=>cell.textContent?.trim() && // Exclude numbered columns when checking for content
            !cell.classList.contains('ak-renderer-table-number-column'));
        return hasContent ? [
            index + (firstRowHeader ? 0 : 1)
        ] : [];
    });
};
const $39b1e229aed8b0e2$export$d050dc64d7b7d275 = (mappings, table, options)=>{
    let issueIndex = 0;
    const rows = table.rows;
    const issues = [];
    const firstRowHeader = $39b1e229aed8b0e2$var$isFirstRowHeader(rows);
    // Starting from the second row as we will be using the first row as the header even if it is not a HTML header row
    for(let i = 1; i < rows.length; i++){
        const issue = {
            id: '',
            summary: '',
            description: undefined,
            issueType: {
                iconUrl: '',
                name: '',
                id: ''
            },
            // Note: the issue insertion API does not count the HTML header row as the first row so we want to shift the index by 1 if the first row is a HTML header row
            rowIndex: i - (firstRowHeader ? 1 : 0)
        };
        let emptySummary = true;
        let emptyDescription = true;
        for (const mapping of mappings){
            const textContent = mapping.column ? rows[i]?.cells[mapping.column.index]?.textContent?.trim() : '';
            if (mapping.field) {
                if (mapping.field.fieldId === 'summary') {
                    issue.summary = textContent || 'Untitled';
                    emptySummary = !textContent;
                } else if (mapping.field.fieldId === 'description') {
                    //The description expects ADF content
                    const cellHTML = mapping.column ? rows[i]?.cells[mapping.column.index]?.innerHTML : '';
                    issue.description = (0, $eqKgz.htmlToADF)(cellHTML);
                    emptyDescription = !textContent;
                } else if (mapping.field.fieldId === 'assignee') {
                    const assigneeValue = $39b1e229aed8b0e2$export$793b299699592cd5((0, $CbMiC.FieldType).USER, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field);
                    if (assigneeValue) issue.assigneeUserId = assigneeValue.id;
                } else if (mapping.field.fieldId === 'labels') issue.labels = $39b1e229aed8b0e2$export$793b299699592cd5((0, $CbMiC.FieldType).LABELS, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field) ?? [];
                else if (mapping.field.fieldId === 'parent') {
                    const parentValue = $39b1e229aed8b0e2$export$793b299699592cd5((0, $CbMiC.FieldType).PARENT, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field);
                    if (parentValue) issue.parent = parentValue;
                } else {
                    const fieldType = $39b1e229aed8b0e2$var$getFieldTypeFromMapping(mapping);
                    const fieldValue = $39b1e229aed8b0e2$export$793b299699592cd5(fieldType, mapping.field.fieldId, mapping.column ? rows[i]?.cells[mapping.column.index] : null, options, mapping.field);
                    if (!issue.additionalFields) issue.additionalFields = [];
                    if (fieldValue !== null) issue.additionalFields.push({
                        field: mapping.field,
                        value: fieldValue
                    });
                }
            }
        }
        if (!emptySummary && !emptyDescription) {
            issue.id = String(issueIndex++);
            issues.push(issue);
        }
    }
    return issues;
};
const $39b1e229aed8b0e2$export$fd730ab37ac74696 = (result, rowIndices)=>{
    const failedElementNumbers = result.errors.map((error)=>error.failedElementNumber);
    const updatedRowIndices = rowIndices.filter((_, elementNumber)=>!failedElementNumbers.includes(elementNumber));
    return result.issues.map((issue, index)=>{
        return {
            ...issue,
            rowIndex: updatedRowIndices[index]
        };
    });
};
const $39b1e229aed8b0e2$var$issueKeyRegex = /^[A-Z][A-Z0-9_]+-[1-9][0-9]*$/;
const $39b1e229aed8b0e2$export$5f391f745ffca1ca = (table)=>{
    const result = new Map();
    // Iterate through each row in the table
    for(let rowIndex = 0; rowIndex < table.rows.length; rowIndex++){
        const row = table.rows[rowIndex];
        // Iterate through each cell in the row
        for(let colIndex = 0; colIndex < row.cells.length; colIndex++){
            const cell = row.cells[colIndex];
            const textContent = cell.textContent || '';
            const matches = textContent.trim().toUpperCase().match($39b1e229aed8b0e2$var$issueKeyRegex);
            if (matches) result.set(colIndex, (result.get(colIndex) ?? []).concat(matches.map((key)=>key.trim().toUpperCase())));
        }
    }
    return result;
};
const $39b1e229aed8b0e2$export$33993da3a44263b8 = (tableCellAdf, workItemUrl)=>{
    try {
        const cellContent = tableCellAdf.content ?? [];
        const workItemNode = {
            type: 'inlineCard',
            attrs: {
                url: workItemUrl
            }
        };
        const updatedContent = [
            ...cellContent,
            {
                type: 'paragraph',
                content: [
                    workItemNode
                ]
            }
        ];
        return {
            type: tableCellAdf.type,
            attrs: tableCellAdf.attrs ?? {},
            content: updatedContent
        };
    } catch  {
        return null;
    }
};
/**
 * Returns updated table rows with work items inserted into the specified column in ADF
 *
 * @param rows - Array of ADF tableRow nodes
 * @param workItemsByRow - Map of row indices to work item URLs
 * @param insertionColumn - Column index to insert the work item into
 * @returns Updated array of tableRow ADF nodes
 */ const $39b1e229aed8b0e2$var$updateRowsWithWorkItems = (rows, workItemsByRow, insertionColumn = 0)=>{
    const tableRows = rows.slice();
    // Find the next insertable tableCell starting from insertionColumn
    const col = $39b1e229aed8b0e2$var$adjustInsertionColumn(tableRows, workItemsByRow, insertionColumn);
    if (col === -1) return null;
    for (const [rowIndex, workItemUrl] of workItemsByRow){
        const row = tableRows[rowIndex];
        if (!row || row.type !== 'tableRow' || !row.content) return null;
        if (col >= row.content.length) return null;
        const targetCellAdf = row.content[col];
        if (!targetCellAdf) return null;
        const updatedCell = $39b1e229aed8b0e2$export$33993da3a44263b8(targetCellAdf, workItemUrl);
        if (!updatedCell) return null;
        // Update the row with the new cell that includes the work item
        tableRows[rowIndex] = {
            ...row,
            content: [
                ...row.content.slice(0, col),
                updatedCell,
                ...row.content.slice(col + 1)
            ]
        };
    }
    return tableRows;
};
const $39b1e229aed8b0e2$export$ed3387feb2643b3c = (tableNode, workItemsByRow, insertionColumn)=>{
    try {
        if (tableNode.type !== 'table' || !Array.isArray(tableNode.content)) return null;
        const rows = tableNode.content.filter((row)=>row !== undefined);
        if (rows.length === 0) return null;
        // Determine if the first row is a header and apply an offset if so
        const firstRow = rows[0];
        const startColumnIndex = 0;
        const hasHeaderRow = Array.isArray(firstRow?.content) && $39b1e229aed8b0e2$export$aa8024509e414d36(firstRow.content.slice(startColumnIndex));
        const rowOffset = hasHeaderRow ? 1 : 0;
        // Apply row offset so rowIndex from issues mapping accounts for header row if present
        const offsetWorkItemsByRow = new Map();
        for (const [rowIndex, url] of workItemsByRow)offsetWorkItemsByRow.set(rowIndex + rowOffset, url);
        // Update applicable rows with matching work items
        const updatedRows = $39b1e229aed8b0e2$var$updateRowsWithWorkItems(rows, offsetWorkItemsByRow, insertionColumn);
        // Failure to update rows should propagate as null to signal failure to callers
        if (!updatedRows) return null;
        // If no updates were applied, abandon insertion entirely
        if (updatedRows === tableNode.content) return null;
        return {
            ...tableNode,
            content: updatedRows
        };
    } catch  {
        return null;
    }
};
module.exports["getFieldTypeFromMetadata"] = $39b1e229aed8b0e2$export$485ff2ccf56b085f;
module.exports["getValidatedIssueFieldValuesForColumn"] = $39b1e229aed8b0e2$export$dea6de0898ac5b8;
module.exports["getClosestTableFromSelection"] = $39b1e229aed8b0e2$export$90fcb8f3c3f5ab4f;
module.exports["getRowIndicesWithContent"] = $39b1e229aed8b0e2$export$41999e0c951335f6;
module.exports["mapTableToIssues"] = $39b1e229aed8b0e2$export$d050dc64d7b7d275;
module.exports["updateIssuesWithRowIndex"] = $39b1e229aed8b0e2$export$fd730ab37ac74696;
module.exports["getJiraWorkItemKeysFromTable"] = $39b1e229aed8b0e2$export$5f391f745ffca1ca;
module.exports["constructTableWithWorkItems"] = $39b1e229aed8b0e2$export$ed3387feb2643b3c;

});

parcelRegister("2ay9q", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

var $d14147b5d5932d8b$export$f06d63e9178daac8 = /*#__PURE__*/ function(ISSUE_CREATE_WITH_AI) {
    ISSUE_CREATE_WITH_AI["enabled"] = "enabled";
    ISSUE_CREATE_WITH_AI["disabled"] = "disabled";
    return ISSUE_CREATE_WITH_AI;
}({});
const $d14147b5d5932d8b$export$1a5b3977e2178dad = (payload)=>{
    if (payload?.selectedCloudId) try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE, payload.selectedCloudId);
    } catch (error) {
        throw new Error('Unable to save cloudId to localStorage');
    }
};
const $d14147b5d5932d8b$export$330363aaebcbbac2 = ()=>(0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE);
const $d14147b5d5932d8b$export$6637741b3a6a9486 = ()=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.removeItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_JIRA_CLOUD_ID_PREFERENCE);
    } catch (error) {
        throw new Error('Unable to clear persisted override cloudId');
    }
};
const $d14147b5d5932d8b$export$a35ab74c98615456 = ()=>{
    const isCreateIssueAiEnabled = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).ISSUE_CREATE_WITH_AI);
    // If the value is not set true should be returned by default
    return isCreateIssueAiEnabled !== "disabled";
};
const $d14147b5d5932d8b$export$14465c2df74f62aa = (enabled)=>{
    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).ISSUE_CREATE_WITH_AI, enabled ? "enabled" : "disabled");
};
const $d14147b5d5932d8b$export$e1a5fce8e4916b90 = ({ selectedSite: selectedSite, selectedProject: selectedProject, selectedIssueType: selectedIssueType })=>{
    try {
        if (selectedSite && selectedProject && selectedIssueType) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER, {
            selectedSite: selectedSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to set bulk create Jira config: ${error instanceof Error ? error.message : String(error)}`);
    }
};
const $d14147b5d5932d8b$export$a231f3bb3ce63ba = ({ selectedSite: selectedSite, selectedProject: selectedProject, selectedIssueType: selectedIssueType })=>{
    try {
        if (selectedSite && selectedProject && selectedIssueType) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER, {
            selectedSite: selectedSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to set single work create Jira config: ${error instanceof Error ? error.message : String(error)}`);
    }
};
const $d14147b5d5932d8b$export$c5b1c13af74bb340 = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to get single work create Jira config: ${error instanceof Error ? error.message : String(error)}`);
        return null;
    }
};
const $d14147b5d5932d8b$export$75a524dafb2d99e6 = (shouldUseEmbed)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SHOULD_USE_GIC_EMBED, String(shouldUseEmbed));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to save shouldUseEmbed to localStorage: ${error instanceof Error ? error.message : String(error)}`);
    }
};
const $d14147b5d5932d8b$export$88676120d0f50696 = ()=>{
    try {
        const value = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SHOULD_USE_GIC_EMBED);
        if (value === null || value === undefined) return null;
        return value === 'true';
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Unable to get shouldUseEmbed from localStorage: ${error instanceof Error ? error.message : String(error)}`);
        return null;
    }
};
module.exports["saveCloudIdToLocalStorage"] = $d14147b5d5932d8b$export$1a5b3977e2178dad;
module.exports["getPersistedOverrideCloudId"] = $d14147b5d5932d8b$export$330363aaebcbbac2;
module.exports["clearPersistedOverrideCloudId"] = $d14147b5d5932d8b$export$6637741b3a6a9486;
module.exports["getIsCreateIssueWithAiEnabledByUser"] = $d14147b5d5932d8b$export$a35ab74c98615456;
module.exports["setCreateIssueWithAiEnabledByUser"] = $d14147b5d5932d8b$export$14465c2df74f62aa;
module.exports["saveJiraConfigDetailsToLocalStorage"] = $d14147b5d5932d8b$export$e1a5fce8e4916b90;

});

parcelRegister("bImpr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $82gXq = parcelRequire("82gXq");


var $6f0Oj = parcelRequire("6f0Oj");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3E5yu = parcelRequire("3E5yu");


var $2ay9q = parcelRequire("2ay9q");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");

const $7bb6117a579cf01b$var$aiToggleContainerStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.250',
    paddingBlockStart: 'space.250'
});
const $7bb6117a579cf01b$var$toggleWrapperStyle = (0, $ecnYn.xcss)({
    flexShrink: 0
});
const $7bb6117a579cf01b$export$47f423704ba03667 = ({ onChange: onChange, isDisabled: isDisabled = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const id = 'issue-create-with-ai-toggle';
    const [isChecked, setIsChecked] = (0, $42omo.useState)((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable, userChoseManualCreation: userChoseManualCreation }] = (0, $hq2Sz.useBulkCreateContext)();
    const setUserChoseManualCreation = (0, $hq2Sz.useSetUserChoseManualCreation)();
    // If the user chose manual creation (following an error state where AI failed to create the issue),
    // or the AI toggle is disabled, these act as "overrides" that set the toggle to off.
    (0, $42omo.useEffect)(()=>{
        const userManualOverride = userChoseManualCreation && (0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows');
        const aiToggleDisabled = isDisabled && (0, $6mKj3.expVal)('confluence-jwc-mark-toggle-as-off-when-disabled', 'isEnabled', false);
        if (isChecked && (userManualOverride || aiToggleDisabled)) setIsChecked(false);
    }, [
        userChoseManualCreation,
        isChecked,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $2ay9q.setCreateIssueWithAiEnabledByUser)(isChecked);
    });
    const onToggleChange = (0, $42omo.useCallback)(async ()=>{
        const newIsChecked = !isChecked;
        setIsChecked(newIsChecked);
        (0, $2ay9q.setCreateIssueWithAiEnabledByUser)(newIsChecked);
        // If user is re-enabling AI, clear the manual creation override
        if (newIsChecked && userChoseManualCreation && (0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows')) setUserChoseManualCreation(false);
        // Wait for the toggle to finish animating before continuing
        await new Promise((resolve)=>setTimeout(resolve, 250));
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'issueCreateSidePanel',
                action: 'toggled',
                actionSubject: 'toggle',
                actionSubjectId: 'issueCreateAiToggle',
                type: 'ui',
                attributes: {
                    newState: newIsChecked ? 'enabled' : 'disabled',
                    aiEnablement: aiIssueCreationEnablement?.enablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    isCreatedFromTable: isCreatedFromTable
                }
            }
        }).fire();
        onChange(newIsChecked);
    }, [
        isChecked,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        pageMode,
        onChange,
        hasEditPermission,
        isCreatedFromActionItems,
        isCreatedFromTable,
        setUserChoseManualCreation,
        userChoseManualCreation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $7bb6117a579cf01b$var$aiToggleContainerStyle,
        alignBlock: "start",
        testId: "issue-create-side-panel.with-ai"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7bb6117a579cf01b$var$toggleWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
        id: id,
        testId: "issue-create-side-panel.with-ai.toggle",
        isChecked: isChecked,
        onChange: onToggleChange,
        isDisabled: isDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
        htmlFor: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).sidePanelIssueCreateAiToggleLabel)));
};
module.exports["IssueCreateWithAiToggle"] = $7bb6117a579cf01b$export$47f423704ba03667;

});

parcelRegister("aXkRG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $3E5yu = parcelRequire("3E5yu");




const $ab2811fc194d3498$export$8d2e6241c5d3a027 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "118",
        height: "97",
        viewBox: "0 0 118 97",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_1257_61439)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.33301 28.3123V96.881L25.1914 79.8548H84.7999V28.3123H5.33301Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.6277 30.3495C40.6277 25.4304 44.553 21.4886 49.4059 21.4886C54.2587 21.4886 58.184 25.4139 58.184 30.3495C58.184 32.8505 57.5877 33.9933 57.0412 34.722C56.3952 35.5667 55.5837 36.1629 54.1593 37.2064C53.9274 37.3886 53.6624 37.5708 53.3809 37.7695C51.6087 39.0779 49.3562 40.8667 47.6668 43.8314C45.9609 46.8126 45.0168 50.5558 45.0168 55.5079H53.7949C53.7949 51.6655 54.5071 49.5289 55.269 48.2205C56.0309 46.8789 57.0743 45.968 58.598 44.8417C58.7802 44.7092 58.979 44.5601 59.1943 44.4111C60.569 43.4173 62.5234 42.0095 63.9974 40.0717C65.9021 37.5873 66.9621 34.4736 66.9621 30.3495C66.9621 20.6439 59.1777 12.7104 49.4059 12.7104C39.634 12.7104 31.8496 20.6439 31.8496 30.3495V34.7386H40.6277V30.3495Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.406 62.1165C46.3751 62.1165 43.9238 64.5677 43.9238 67.5986C43.9238 70.6296 46.3751 73.0808 49.406 73.0808C52.437 73.0808 54.8882 70.6296 54.8882 67.5986C54.8882 64.5677 52.437 62.1165 49.406 62.1165Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.9489 28.3123H40.8596C40.6939 28.9582 40.6111 29.6538 40.6111 30.3494V34.7385H31.833V30.3494C31.833 29.6704 31.8661 28.9913 31.9489 28.3123Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M54.8882 67.5984C54.8882 70.6293 52.4369 73.0972 49.406 73.0972C46.375 73.0972 43.9072 70.6293 43.9072 67.5984C43.9072 64.5675 46.375 62.1162 49.406 62.1162C52.4369 62.1162 54.8882 64.5675 54.8882 67.5984Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M66.9619 30.3494C66.9619 34.4901 65.9019 37.5873 63.9972 40.0716C62.5232 42.0094 60.5688 43.4173 59.1941 44.411C58.9788 44.5766 58.78 44.7091 58.5979 44.8416C57.0741 45.9844 56.0307 46.8954 55.2688 48.2369C54.5069 49.5619 53.7947 51.6985 53.7947 55.5244H45.0166C45.0166 50.5723 45.9441 46.8291 47.65 43.8644C49.356 40.8998 51.6085 39.111 53.3641 37.786C53.6457 37.5873 53.9107 37.4051 54.1425 37.2229C55.5835 36.1629 56.3785 35.5832 57.0244 34.7385C57.5875 33.9932 58.1838 32.8504 58.1838 30.3494C58.1838 29.6538 58.101 28.9582 57.9354 28.3123H66.846C66.9288 28.9913 66.9619 29.6704 66.9619 30.3494Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M80.0122 22.0463C79.6799 22.0789 77.8184 13.4596 78.1559 9.83758C76.9474 9.23678 75.7989 7.52436 75.6751 5.62882C70.5183 2.41068 74.3806 11.5603 75.6468 14.3967C76.2719 12.3407 76.09 17.3947 76.7845 18.0977C76.7063 17.6783 78.3602 26.0497 79.7136 23.5492C79.9391 23.7906 80.3949 21.7647 80.0181 22.0492L80.0122 22.0463Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M97.9714 11.2108C97.4794 9.37567 98.1356 7.71565 99.2924 6.08381C97.9034 -0.291475 93.8658 10.4331 92.9202 13.0451C92.9202 13.0451 91.164 17.598 91.09 17.0666C90.2879 17.4821 86.1799 23.9708 89.259 23.5153C90.0562 22.4885 90.6584 20.094 91.6197 20.0239C93.7172 19.3392 95.6045 13.1619 97.9685 11.2017L97.9714 11.2108Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M114.75 26.5761C115.405 22.4193 108.013 26.2102 105.02 26.6553C105.02 26.6553 101.899 26.945 101.091 27.5785C101.545 27.5379 90.5256 29.2208 96.531 30.806C96.6829 30.737 100.499 30.1605 100.499 30.1605C105.624 30.8975 110.77 28.8288 114.753 26.57L114.75 26.5761Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_1257_61439"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "117",
        height: "97",
        fill: "white",
        transform: "translate(0.5)"
    }))));



var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");

const $b2fad5e9397af553$var$errorTryAgainTestId = 'error-try-again-button';
const $b2fad5e9397af553$var$errorCreateManuallyTestId = 'error-create-manually-button';
const $b2fad5e9397af553$var$errorContainerStyle = (0, $ecnYn.xcss)({
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingInline: 'space.800'
});
const $b2fad5e9397af553$var$errorDescriptionStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.300',
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    color: 'color.text.subtle'
});
const $b2fad5e9397af553$var$buttonLayoutStyle = (0, $ecnYn.xcss)({
    width: '100%',
    paddingBlock: 'space.050'
});
const $b2fad5e9397af553$export$4ab514c5c6944b54 = ({ creationSource: creationSource, errorMessage: errorMessage, errorMessageValues: errorMessageValues, isCreatedWithAi: isCreatedWithAi, onTryAgain: onTryAgain, onCreateManually: onCreateManually })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: isCreatedWithAi ? 'ai creation error screen' : 'creation error screen',
                source: creationSource,
                attributes: {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    isCreatedFromTable: isCreatedFromTable
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        creationSource,
        pageMode,
        isCreatedWithAi,
        hasEditPermission,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2fad5e9397af553$var$errorContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab2811fc194d3498$export$8d2e6241c5d3a027), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "error-description",
        xcss: $b2fad5e9397af553$var$errorDescriptionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...errorMessage,
        values: errorMessageValues
    })), onTryAgain && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2fad5e9397af553$var$buttonLayoutStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: $b2fad5e9397af553$var$errorTryAgainTestId,
        onClick: onTryAgain
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).errorTryAgainButton))), onCreateManually && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2fad5e9397af553$var$buttonLayoutStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: $b2fad5e9397af553$var$errorCreateManuallyTestId,
        onClick: onCreateManually
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).errorCreateManuallyButton))));
};
module.exports["WorkItemCreationError"] = $b2fad5e9397af553$export$4ab514c5c6944b54;

});

parcelRegister("dAg4H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7mpOv = parcelRequire("7mpOv");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");


var $2R8mu = parcelRequire("2R8mu");


var $k9cgj = parcelRequire("k9cgj");

const $3bc657bf57b962b7$export$8e6d40ccfb969320 = ({ contentId: contentId, isBulkCreate: isBulkCreate = false })=>{
    const [{ currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isCreateManuallyPressed: isCreateManuallyPressed, pageMode: pageMode, hasEditPermission: hasEditPermission }, { setAiIssueCreationEnablement: setAiIssueCreationEnablement }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const hasLicensedConfluenceAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    // environment-aware enablement via feature encoding
    // Encoded environments example: commercial-cloud: true, fedramp-moderate: false, isolated-commercial-cloud-ga: true
    const isAIEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const isConfluenceAiEnabled = hasLicensedConfluenceAccess && isAIEnabledForContent && isAIEnvEnabled;
    (0, $42omo.useEffect)(()=>{
        // isCreateManuallyPressed - When there is AI error "Create Manually" button can be pressed by user.
        // We should honour this and create manually.  This will be overriden on refresh.
        if (isCreateManuallyPressed) {
            setAiIssueCreationEnablement({
                isEnabled: false
            });
            return;
        }
        // Short-circuit if Confluence Ai is enabled
        if (isConfluenceAiEnabled) {
            setAiIssueCreationEnablement({
                isEnabled: true,
                enablement: 'confluence'
            });
            return;
        }
        const isJiraAiEnabled = async ()=>{
            /**
       * 1. Cannot call Jira enablement API if site & project are not selected
       * 2. Remove (cloudId !== currentSiteSelection) after Jira AI API supports
       * 	  cross-site scenarios - https://hello.jira.atlassian.cloud/browse/CBT-4995
       */ const bulkJiraNotSelected = !currentJiraSite || !currentJiraProject?.projectTypeKey || cloudId !== currentJiraSite.cloudId;
            const singleJiraNotSelected = !currentSiteSelection || !currentProjectSelection?.selectedProjectType || cloudId !== currentSiteSelection;
            const jiraNotSelected = isBulkCreate && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? bulkJiraNotSelected : singleJiraNotSelected;
            if (jiraNotSelected) {
                setAiIssueCreationEnablement({
                    isEnabled: false
                });
                return;
            }
            try {
                const projectType = isBulkCreate && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? currentJiraProject?.projectTypeKey ?? '' : currentProjectSelection?.selectedProjectType ?? '';
                const jiraEnablement = await (0, $k9cgj.getJiraAiEnablement)(isBulkCreate && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? currentJiraSite?.cloudId ?? '' : currentSiteSelection, (0, $2R8mu.MESSAGE_PROJECT_TYPE_TO_API_PROJECT_TYPE)[projectType]);
                // 	User switches from a Jira AI enabled site to a no AI enabled site
                if (aiIssueCreationEnablement?.enablement == 'jira' && !jiraEnablement?.isEnabled) createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'disabled',
                        actionSubject: 'issueCreationAi',
                        attributes: {
                            pageMode: pageMode,
                            hasEditPermission: hasEditPermission,
                            isCreatedFromActionItems: isCreatedFromActionItems,
                            isCreatedFromTable: isCreatedFromTable
                        }
                    }
                }).fire();
                setAiIssueCreationEnablement({
                    isEnabled: jiraEnablement?.isEnabled ?? false,
                    enablement: jiraEnablement?.isEnabled ? 'jira' : undefined
                });
            } catch  {
                setAiIssueCreationEnablement({
                    isEnabled: false
                });
            }
        };
        isJiraAiEnabled();
    }, [
        currentSiteSelection,
        currentProjectSelection?.selectedProjectType,
        setAiIssueCreationEnablement,
        aiIssueCreationEnablement,
        isConfluenceAiEnabled,
        createAnalyticsEvent,
        isCreateManuallyPressed,
        cloudId,
        pageMode,
        hasEditPermission,
        currentJiraSite,
        currentJiraProject,
        isBulkCreate,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return aiIssueCreationEnablement;
};
module.exports["useIsAIIssueCreationAllowed"] = $3bc657bf57b962b7$export$8e6d40ccfb969320;

});

parcelRegister("74xbC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $dpPtd = parcelRequire("dpPtd");


var $6bd6t = parcelRequire("6bd6t");


var $dchHi = parcelRequire("dchHi");


var $1mDVg = parcelRequire("1mDVg");

const $c5f4da66a3a122b0$var$SOURCE = 'confluenceHighlightIssueCreate';
const $c5f4da66a3a122b0$export$abbdbb6d42a658e9 = ({ contentId: contentId, entrypointId: entrypointId })=>{
    const [{ aiState: aiState, aiAnalyticsContext: aiAnalyticsContext }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const shouldShowFeedbackCollector = aiState !== 'loading';
    const additionalAnalyticsContext = {
        additionalAnalyticsAttributes: aiAnalyticsContext
    };
    return shouldShowFeedbackCollector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
        entrypointId: entrypointId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6bd6t.SmartsFeedbackComponent), {
        analyticsProperties: {
            source: $c5f4da66a3a122b0$var$SOURCE,
            ...additionalAnalyticsContext
        },
        contentId: contentId
    })))) : null;
};
module.exports["IssueCreateAiFeedback"] = $c5f4da66a3a122b0$export$abbdbb6d42a658e9;

});

parcelRegister("hiixe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");


var $dcJ7R = parcelRequire("dcJ7R");


var $ecnYn = parcelRequire("ecnYn");


var $eXmBZ = parcelRequire("eXmBZ");


var $7p4As = parcelRequire("7p4As");


var $lAFHW = parcelRequire("lAFHW");


var $3E5yu = parcelRequire("3E5yu");

const $3e71e815c0c6ec61$var$aiSubFooterWrapperStyle = (0, $ecnYn.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $3e71e815c0c6ec61$var$textColorStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.025',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $3e71e815c0c6ec61$export$85370ea3ee2e18db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3e71e815c0c6ec61$var$aiSubFooterWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                ...iconProps,
                color: "var(--ds-text-subtlest, #6B6E76)",
                spacing: "none"
            }),
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "issue-create-side-panel.ai-footer.disclaimer-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3e71e815c0c6ec61$var$textColorStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).sidePanelFooterDisclaimerText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        spacing: "compact",
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                ...iconProps,
                appearance: "brand",
                size: "xsmall"
            }),
        href: "https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/",
        rel: "noopener",
        target: "_blank",
        testId: "issue-create-side-panel.ai-footer.powered-by-rovo-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3e71e815c0c6ec61$var$textColorStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).sidePanelFooterRovoText)))));
module.exports["AiSubFooter"] = $3e71e815c0c6ec61$export$85370ea3ee2e18db;

});

parcelRegister("cSSgB", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $1mDVg = parcelRequire("1mDVg");

const $49be58ea5500c18e$export$367309a91893a493 = (node)=>{
    return node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
};
const $49be58ea5500c18e$export$d8e52034650aae53 = (node)=>{
    const element = $49be58ea5500c18e$export$367309a91893a493(node);
    return element?.closest('[data-task-local-id]') ?? null;
};
const $49be58ea5500c18e$var$findActionItemElementInEditor = (node)=>{
    const element = $49be58ea5500c18e$export$367309a91893a493(node);
    return element instanceof HTMLDivElement ? element : null;
};
const $49be58ea5500c18e$export$57c04832e4673593 = (selection, pageMode = (0, $1mDVg.PageMode).VIEW)=>{
    if (!selection || selection.rangeCount === 0) return selection;
    const range = selection.getRangeAt(0);
    const { startContainer: startContainer, endContainer: endContainer } = range;
    const startInActionItem = pageMode === (0, $1mDVg.PageMode).VIEW ? $49be58ea5500c18e$export$d8e52034650aae53(startContainer) : $49be58ea5500c18e$var$findActionItemElementInEditor(startContainer);
    const endInActionItem = pageMode === (0, $1mDVg.PageMode).VIEW ? $49be58ea5500c18e$export$d8e52034650aae53(endContainer) : $49be58ea5500c18e$var$findActionItemElementInEditor(endContainer);
    if (startInActionItem) {
        const newRange = document.createRange();
        newRange.selectNodeContents(startInActionItem);
        return newRange;
    }
    if (endInActionItem) {
        const newRange = document.createRange();
        newRange.selectNodeContents(endInActionItem);
        return newRange;
    }
    return range;
};
const $49be58ea5500c18e$export$95b6717a0644653e = (selection, pageMode = (0, $1mDVg.PageMode).VIEW)=>{
    if (!selection || selection.rangeCount === 0) return null;
    const range = selection.getRangeAt(0);
    const container = $49be58ea5500c18e$export$367309a91893a493(range.commonAncestorContainer);
    if (!container) return null;
    const actionItems = Array.from(container.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])'));
    const firstActionItemInSelection = actionItems.find((actionItem)=>range.intersectsNode(actionItem)) ?? null;
    const actionItemListQuerySelector = pageMode === (0, $1mDVg.PageMode).VIEW ? '[aria-label="Action Item List"]' : 'div[data-node-type="actionList"]';
    const allLists = Array.from(document.querySelectorAll(actionItemListQuerySelector));
    return allLists.find((list)=>list.contains(firstActionItemInSelection)) ?? null;
};
const $49be58ea5500c18e$export$2171717a094dd1e7 = (actionList)=>{
    // Skip if any child has data-task-list-local-id -> avoid double counting nested action items
    const actionItems = actionList?.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""]):not(:has([data-task-list-local-id]))');
    const issues = [];
    let issueIndex = 0;
    actionItems.forEach((actionItem)=>{
        if (actionItem.textContent?.trim()) {
            const issue = {
                id: String(issueIndex),
                issueType: {
                    iconUrl: '',
                    name: '',
                    id: ''
                },
                rowIndex: issueIndex,
                summary: actionItem.textContent.trim(),
                description: (0, $eqKgz.htmlToADF)(actionItem.innerHTML)
            };
            issues.push(issue);
        }
        issueIndex++;
    });
    return issues;
};
module.exports["findActionItemElement"] = $49be58ea5500c18e$export$d8e52034650aae53;
module.exports["includeEntireActionItemInSelection"] = $49be58ea5500c18e$export$57c04832e4673593;
module.exports["getClosestActionListFromSelection"] = $49be58ea5500c18e$export$95b6717a0644653e;
module.exports["mapActionItemsToIssues"] = $49be58ea5500c18e$export$2171717a094dd1e7;

});

parcelRegister("9uzSK", function(module, exports) {

var $caRYB = parcelRequire("caRYB");


var $2FFuS = parcelRequire("2FFuS");

const $f093b0f0b5b0aeb7$export$77438d6c10b4e651 = [
    'table',
    'tableRow',
    'tableCell',
    'tableHeader'
];
const $f093b0f0b5b0aeb7$export$e8de71ddb126302c = [
    'taskList',
    'taskItem'
];


const $51e2077cdc43ebd4$var$isTextNode = (node)=>!!node && node.type === 'text' && 'text' in node;
const $51e2077cdc43ebd4$var$INLINE_NODE_TYPES = new Set([
    'inlineCard',
    'mention',
    'emoji',
    'hardBreak',
    'status',
    'date'
]);
const $51e2077cdc43ebd4$var$isInlineNode = (node)=>$51e2077cdc43ebd4$var$isTextNode(node) || $51e2077cdc43ebd4$var$INLINE_NODE_TYPES.has(node.type);
const $51e2077cdc43ebd4$var$extractAllText = (node)=>{
    if (!node) return '';
    if ($51e2077cdc43ebd4$var$isTextNode(node)) return node.text;
    if (Array.isArray(node.content)) {
        const childTexts = node.content.map($51e2077cdc43ebd4$var$extractAllText);
        // Join child texts with a space and then normalise whitespace so we don't end up with merged words
        return childTexts.join(' ').replace(/\s+/g, ' ').trim();
    }
    return '';
};
/**
 * Gets the node by pointer
 * @param root - The root node
 * @param pointer - The pointer
 * @returns The node by pointer
 */ const $51e2077cdc43ebd4$var$getNodeByPointer = (root, pointer)=>{
    const segments = pointer.split('/').filter(Boolean);
    let current = root;
    for(let i = 0; i < segments.length; i += 1){
        const segment = segments[i];
        if (segment === 'content') {
            const index = Number(segments[i + 1]);
            i += 1;
            if (!current) return null;
            const content = current.content;
            if (!Array.isArray(content) || Number.isNaN(index)) return null;
            current = content[index] ?? null;
            continue;
        }
        if (segment === 'text') return current;
    }
    return current;
};
/**
 * Gets the text from the selection range
 * @param selectedNodeAdf - The selected node ADF
 * @param range - The selection range
 * @returns The text from the selection range
 */ const $51e2077cdc43ebd4$var$getTextFromSelectionRange = (selectedNodeAdf, range)=>{
    const { start: start, end: end } = range;
    if (!start?.pointer || !end?.pointer) return null;
    const targetNode = $51e2077cdc43ebd4$var$getNodeByPointer(selectedNodeAdf, start.pointer);
    if (!targetNode) return null;
    const nodeText = $51e2077cdc43ebd4$var$isTextNode(targetNode) ? targetNode.text : $51e2077cdc43ebd4$var$extractAllText(targetNode);
    if (start.position == null && end.position == null) return nodeText;
    const startPos = start.position ?? 0;
    const endPos = end.position ?? nodeText.length;
    if (startPos >= endPos) return '';
    return nodeText.slice(startPos, endPos);
};
/**
 * Extracts the text from the selection ranges
 * @param selectedNodeAdf - The selected node ADF
 * @param selectionRanges - The selection ranges
 * @returns The text from the selection ranges
 */ const $51e2077cdc43ebd4$var$extractTextFromSelectionRanges = (selectedNodeAdf, selectionRanges)=>{
    let firstNonEmpty = null;
    let lastNonEmpty = null;
    const textSegments = [];
    for (const range of selectionRanges){
        const rangeText = $51e2077cdc43ebd4$var$getTextFromSelectionRange(selectedNodeAdf, range);
        if (rangeText === null) return null;
        const trimmed = rangeText.trim();
        if (!trimmed) continue;
        if (firstNonEmpty === null) firstNonEmpty = trimmed;
        lastNonEmpty = trimmed;
        textSegments.push(rangeText);
    }
    const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
    const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
    if (hasActionItems && !hasTable) // If only multiple action items are selected, use the first task's text as selection
    return firstNonEmpty ?? '';
    if (!hasActionItems && !hasTable) {
        // For plain text selections combine all selected ranges
        if (textSegments.length === 0) return '';
        return textSegments.join('').trim();
    }
    // If multiple nodes selected (ex: table and action items), use the last piece of text
    return lastNonEmpty ?? '';
};
/**
 * Clones a text node slice from the start position to the end position
 * @param node - The text node to clone
 * @param from - The start position
 * @param to - The end position
 * @returns The cloned text node slice
 */ const $51e2077cdc43ebd4$var$cloneTextNodeSlice = (node, from, to)=>{
    const slicedText = node.text.slice(from, to);
    if (!slicedText) return null;
    return {
        ...node,
        text: slicedText
    };
};
/**
 * Builds an ADF slice from the selection ranges
 * @param selectedNodeAdf - The selected node ADF
 * @param selectionRanges - The selection ranges
 * @returns The ADF slice
 */ const $51e2077cdc43ebd4$var$buildAdfSliceFromRanges = (selectedNodeAdf, selectionRanges)=>{
    const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
    const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
    const inlineSlices = [];
    for (const range of selectionRanges){
        const { start: start, end: end } = range;
        if (!start?.pointer || !end?.pointer) continue;
        const targetNode = $51e2077cdc43ebd4$var$getNodeByPointer(selectedNodeAdf, start.pointer);
        if (!$51e2077cdc43ebd4$var$isTextNode(targetNode)) continue;
        const fullTextLength = targetNode.text.length;
        const startPos = start.position ?? 0;
        const endPos = end.position ?? fullTextLength;
        if (startPos >= endPos) continue;
        const sliced = $51e2077cdc43ebd4$var$cloneTextNodeSlice(targetNode, startPos, endPos);
        if (!sliced) continue;
        inlineSlices.push(sliced);
    }
    if (inlineSlices.length === 0) return undefined;
    let content;
    if (hasActionItems && !hasTable) content = [
        inlineSlices[0]
    ];
    else if (!hasActionItems && !hasTable) content = inlineSlices;
    else content = [
        inlineSlices[inlineSlices.length - 1]
    ];
    return {
        type: 'paragraph',
        content: content
    };
};
const $51e2077cdc43ebd4$export$9c1aa4b084b580d = (selectionAdfResult)=>{
    const selectedNodeAdf = selectionAdfResult?.selectedNodeAdf;
    if (!selectedNodeAdf) return '';
    const { selectionRanges: selectionRanges } = selectionAdfResult ?? {};
    if (!selectionRanges || selectionRanges.length === 0) {
        const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
        const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
        // Case for multiple action items selection without a selectionRange, only take the first action item text
        if (hasActionItems && !hasTable) {
            const firstActionItemText = $51e2077cdc43ebd4$var$extractAllText($51e2077cdc43ebd4$var$findFirstActionItemNode(selectedNodeAdf));
            if (firstActionItemText) return firstActionItemText;
        }
        return $51e2077cdc43ebd4$var$extractAllText(selectedNodeAdf);
    }
    return $51e2077cdc43ebd4$var$extractTextFromSelectionRanges(selectedNodeAdf, selectionRanges) ?? $51e2077cdc43ebd4$var$extractAllText(selectedNodeAdf);
};
const $51e2077cdc43ebd4$export$3c73e23a024e29a3 = (selectionAdfResult)=>{
    const selectedNodeAdf = selectionAdfResult?.selectedNodeAdf;
    if (!selectedNodeAdf) return undefined;
    const { selectionRanges: selectionRanges } = selectionAdfResult ?? {};
    if (!selectionRanges || selectionRanges.length === 0) {
        const hasActionItems = $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
        const hasTable = $51e2077cdc43ebd4$var$containsTableType(selectedNodeAdf);
        // Case for multiple action items selection without a selectionRange, only take the first action item text
        if (hasActionItems && !hasTable) {
            const firstActionItemText = $51e2077cdc43ebd4$var$extractAllText($51e2077cdc43ebd4$var$findFirstActionItemNode(selectedNodeAdf));
            if (firstActionItemText) return (0, $caRYB.doc)((0, $2FFuS.paragraph)(firstActionItemText));
        }
        return selectedNodeAdf;
    }
    // Try to build a slice that preserves formatting from original ADF
    const adfSlice = $51e2077cdc43ebd4$var$buildAdfSliceFromRanges(selectedNodeAdf, selectionRanges);
    if (adfSlice) return adfSlice;
    // Fallback is to just use a plain-text slice when we can't construct a ADF slice from the ranges
    const selectionText = $51e2077cdc43ebd4$export$9c1aa4b084b580d(selectionAdfResult);
    return selectionText ? (0, $caRYB.doc)((0, $2FFuS.paragraph)(selectionText)) : selectedNodeAdf;
};
const $51e2077cdc43ebd4$export$a66ab8faf71a3c88 = (adf)=>{
    if (!adf) return (0, $caRYB.doc)((0, $2FFuS.paragraph)(''));
    if (adf.type === 'doc') return adf;
    if ($51e2077cdc43ebd4$var$isInlineNode(adf)) return (0, $caRYB.doc)((0, $2FFuS.paragraph)(adf));
    return {
        type: 'doc',
        version: 1,
        content: [
            adf
        ]
    };
};
/**
 * Splits the text into a summary and a description
 * @param text - The text to split
 * @param maxLength - The maximum length of the summary
 * @returns The summary and the description
 */ const $51e2077cdc43ebd4$var$extractSummary = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $51e2077cdc43ebd4$export$4ab5d7d08a482714 = (selectionAdfResult, maxLength)=>{
    const selectionText = $51e2077cdc43ebd4$export$9c1aa4b084b580d(selectionAdfResult);
    const selectionAdf = $51e2077cdc43ebd4$export$3c73e23a024e29a3(selectionAdfResult) ?? selectionAdfResult?.selectedNodeAdf;
    const [summary] = $51e2077cdc43ebd4$var$extractSummary(selectionText, maxLength);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    return [
        summaryWithoutFormatting,
        $51e2077cdc43ebd4$export$a66ab8faf71a3c88(selectionAdf)
    ];
};
const $51e2077cdc43ebd4$var$TABLE_TYPES = new Set((0, $f093b0f0b5b0aeb7$export$77438d6c10b4e651));
/**
 * Checks if the node contains a table type
 * @param node - The node to check
 * @returns True if the node contains a table type, false otherwise
 */ const $51e2077cdc43ebd4$var$containsTableType = (node)=>{
    if (!node) return false;
    if ($51e2077cdc43ebd4$var$TABLE_TYPES.has(node.type)) return true;
    const content = node.content;
    if (!content) return false;
    return content.some($51e2077cdc43ebd4$var$containsTableType);
};
/**
 * Finds the first task item node within an ADF tree.
 * @param node - The root node to search from
 * @returns The first encountered taskItem node, or null if none is found
 */ const $51e2077cdc43ebd4$var$findFirstActionItemNode = (node)=>{
    if (!node) return null;
    const nodesToVisit = [
        node
    ];
    for(let i = 0; i < nodesToVisit.length; i += 1){
        const current = nodesToVisit[i];
        if (current.type === 'taskItem') return current;
        const content = current.content;
        if (Array.isArray(content) && content.length > 0) nodesToVisit.push(...content);
    }
    return null;
};
const $51e2077cdc43ebd4$export$513b701e17971c9f = (selectionAdfResult)=>selectionAdfResult?.selectedNodeAdf?.type === 'table' && !!selectionAdfResult.selectionRanges && selectionAdfResult.selectionRanges.length > 1;
const $51e2077cdc43ebd4$var$ACTION_ITEM_TYPES = new Set((0, $f093b0f0b5b0aeb7$export$e8de71ddb126302c));
/**
 * Checks if the node contains an action item type
 * @param node - The node to check
 * @returns True if the node contains an action item type, false otherwise
 */ const $51e2077cdc43ebd4$var$containsActionItemType = (node)=>{
    if (!node) return false;
    if ($51e2077cdc43ebd4$var$ACTION_ITEM_TYPES.has(node.type)) return true;
    const content = node.content;
    return Array.isArray(content) && content.some($51e2077cdc43ebd4$var$containsActionItemType);
};
const $51e2077cdc43ebd4$export$86049b93219a615c = (selectionAdfResult)=>{
    const selectedNodeAdf = selectionAdfResult?.selectedNodeAdf;
    if (!selectedNodeAdf) return false;
    return $51e2077cdc43ebd4$var$containsActionItemType(selectedNodeAdf);
};
module.exports["extractSelectedAdfSlice"] = $51e2077cdc43ebd4$export$3c73e23a024e29a3;
module.exports["normalizeToDocNode"] = $51e2077cdc43ebd4$export$a66ab8faf71a3c88;
module.exports["getSummaryAndDescriptionFromSelectionAdfResult"] = $51e2077cdc43ebd4$export$4ab5d7d08a482714;
module.exports["isTableSelectionAdf"] = $51e2077cdc43ebd4$export$513b701e17971c9f;
module.exports["isActionItemsSelectionAdf"] = $51e2077cdc43ebd4$export$86049b93219a615c;

});

parcelRegister("2ViZo", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $cSSgB = parcelRequire("cSSgB");


var $euVTc = parcelRequire("euVTc");


var $9uzSK = parcelRequire("9uzSK");

var $2f9600f9f25e1b5c$export$fdc86e92bb21a7 = /*#__PURE__*/ function(BulkSelectionResult) {
    BulkSelectionResult["None"] = "none";
    BulkSelectionResult["Table"] = "table";
    BulkSelectionResult["ActionItems"] = "actionItems";
    return BulkSelectionResult;
}({});
const $2f9600f9f25e1b5c$export$37727a36204b884e = ({ actions: actions, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, pageMode: pageMode, hasEditPermission: hasEditPermission, container: container, lastModified: lastModified, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const selectedActionList = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageMode);
    const selectedTable = (0, $euVTc.getClosestTableFromSelection)(activeSelection);
    const shouldUseSelectionAdf = pageMode !== (0, $1mDVg.PageMode).VIEW && !!selectionAdfResult?.selectedNodeAdf;
    const hasTableSelection = shouldUseSelectionAdf ? (0, $9uzSK.isTableSelectionAdf)(selectionAdfResult) && !!selectedTable : !!selectedTable;
    const hasActionItemsSelection = shouldUseSelectionAdf ? (0, $9uzSK.isActionItemsSelectionAdf)(selectionAdfResult) && !!selectedActionList : !!selectedActionList;
    if (!hasTableSelection && (!hasActionItemsSelection || !(0, $9wGTI.fg)('confluence-create-work-items-from-action-items'))) // If the selection is not for a table or action items, we shouldn't set any state and return none
    return "none";
    actions.setContentId(contentId);
    actions.setPageMode(pageMode);
    actions.setHasEditPermission(hasEditPermission);
    if (hasTableSelection && selectedTable) return $2f9600f9f25e1b5c$var$prepareFromTableSelection({
        actions: actions,
        selectedTable: selectedTable,
        activeSelection: activeSelection,
        contentId: contentId,
        container: container,
        lastModified: lastModified,
        setIsCreatedFromTable: setIsCreatedFromTable,
        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
        convertSelectionToLegacyFormat: convertSelectionToLegacyFormat
    });
    if (hasActionItemsSelection && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) return $2f9600f9f25e1b5c$var$prepareFromActionItemsSelection({
        actions: actions,
        selectedActionList: selectedActionList,
        contentId: contentId,
        container: container,
        lastModified: lastModified,
        setIsCreatedFromTable: setIsCreatedFromTable,
        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
        convertSelectionToLegacyFormat: convertSelectionToLegacyFormat
    });
    return "none";
};
const $2f9600f9f25e1b5c$var$prepareFromTableSelection = ({ actions: actions, selectedTable: selectedTable, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    actions.setSelectedTable(selectedTable);
    const insertStorageColumnTableRequestPayload = (0, $1Q0l6.constructInsertStorageColumnTableRequestPayload)(contentId, convertSelectionToLegacyFormat, (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
    actions.setInsertStorageColumnTableRequestPayload(insertStorageColumnTableRequestPayload);
    setIsCreatedFromTable(true);
    setIsCreatedFromActionItems(false);
    actions.setSelectedActionItems(undefined);
    actions.setInsertMultipleStorageFragmentsRequestPayload(undefined);
    return "table";
};
const $2f9600f9f25e1b5c$var$prepareFromActionItemsSelection = ({ actions: actions, selectedActionList: selectedActionList, contentId: contentId, container: container, lastModified: lastModified, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    actions.setSelectedActionItems(selectedActionList);
    // Skip if any child has data-task-list-local-id -> avoid double counting nested action items
    const actionItems = selectedActionList.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""]):not(:has([data-task-list-local-id]))');
    const ranges = [];
    actionItems.forEach((actionItem)=>{
        const range = new Range();
        range.selectNodeContents(actionItem);
        const validRange = (0, $1Q0l6.getValidRangeForActionItem)(range);
        if (validRange) ranges.push(validRange);
    });
    const insertMultipleStorageFragmentsRequestPayload = (0, $1Q0l6.constructInsertMultipleStorageFragmentsRequestPayload)(contentId, convertSelectionToLegacyFormat, ranges, container, lastModified);
    actions.setInsertMultipleStorageFragmentsRequestPayload(insertMultipleStorageFragmentsRequestPayload);
    setIsCreatedFromActionItems(true);
    setIsCreatedFromTable(false);
    actions.setSelectedTable(undefined);
    actions.setInsertStorageColumnTableRequestPayload(undefined);
    return "actionItems";
};
const $2f9600f9f25e1b5c$export$6ff73f32211bfd03 = (isCreatedFromTable, isCreatedFromActionItems, selectedTable, selectedActionItems)=>{
    if (isCreatedFromTable && selectedTable) return (0, $euVTc.getRowIndicesWithContent)(selectedTable.rows);
    if (isCreatedFromActionItems && selectedActionItems) return (0, $cSSgB.mapActionItemsToIssues)(selectedActionItems).map((issue)=>issue.rowIndex ?? -1);
    return [];
};
module.exports["BulkSelectionResult"] = $2f9600f9f25e1b5c$export$fdc86e92bb21a7;
module.exports["prepareBulkCreateFromSelection"] = $2f9600f9f25e1b5c$export$37727a36204b884e;
module.exports["calculateExpectedIssueIndices"] = $2f9600f9f25e1b5c$export$6ff73f32211bfd03;

});

parcelRegister("UNr39", function(module, exports) {
$parcel$export(module.exports, "BULK_ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("3Fkx6")).BULK_ISSUE_CREATE_SIDE_PANEL_ID);
$parcel$export(module.exports, "BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH", () => (parcelRequire("3Fkx6")).BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH);
$parcel$export(module.exports, "ROVO_BULK_CREATE_SIDE_PANEL_WIDTH", () => (parcelRequire("3Fkx6")).ROVO_BULK_CREATE_SIDE_PANEL_WIDTH);

var $jmjWc = parcelRequire("jmjWc");


var $3Fkx6 = parcelRequire("3Fkx6");


const $1fb0451ad8e6948f$export$b46ccdf5c201a7ce = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vnJZq",
    name: "BulkCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("3Fkx6")))).BulkCreateSidePanel
});
module.exports["BulkCreateSidePanel"] = $1fb0451ad8e6948f$export$b46ccdf5c201a7ce;

});

parcelRegister("3Fkx6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Rith = parcelRequire("2Rith");


var $6mKj3 = parcelRequire("6mKj3");


var $hq2Sz = parcelRequire("hq2Sz");








var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");


var $1GzhS = parcelRequire("1GzhS");


var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");


var $hiixe = parcelRequire("hiixe");


var $aMxFD = parcelRequire("aMxFD");





var $inPa6 = parcelRequire("inPa6");


var $cfwlu = parcelRequire("cfwlu");


var $bQm3c = parcelRequire("bQm3c");


var $2ay9q = parcelRequire("2ay9q");


var $1mDVg = parcelRequire("1mDVg");

const $1cfc86eef024eecc$var$noop = ()=>{};
const $1cfc86eef024eecc$export$3177b460ca1a5743 = ({ onClose: onClose, onSuccess: onSuccess, onFailure: onFailure, analyticsSource: analyticsSource, summary: summary, descriptionAdf: descriptionAdf, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, isCreatedFromActionItems: isCreatedFromActionItems, issueTypeId: issueTypeId, projectId: projectId, assigneeId: assigneeId, configuration: configuration, cloudId: cloudId, additionalMappedFields: additionalMappedFields })=>{
    const { cloudId: sessionCloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const overrideCloudIdForSitePicker = persistedOverrideCloudId !== sessionCloudId ? persistedOverrideCloudId : undefined;
    const currentCloudId = overrideCloudIdForSitePicker || cloudId;
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission
                },
                source: analyticsSource
            }
        }).fire();
    }, [
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        createAnalyticsEvent,
        analyticsSource,
        pageMode,
        hasEditPermission
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: currentCloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: $1cfc86eef024eecc$var$noop,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        issueTypeId: issueTypeId,
        projectId: projectId,
        assignee: assigneeId,
        isPayloadReady: true,
        configuration: configuration,
        additionalMappedFields: additionalMappedFields
    });
};















var $auNCB = parcelRequire("auNCB");


var $kfIha = parcelRequire("kfIha");








var $3E5yu = parcelRequire("3E5yu");








var $1Q0l6 = parcelRequire("1Q0l6");

const $512ab0a436635a50$export$fd734339a42971bc = ()=>{
    const [{ currentJiraSite: currentJiraSite }] = (0, $hq2Sz.useBulkCreateContext)();
    return (0, $42omo.useCallback)((issues)=>{
        const currentSiteUrl = currentJiraSite?.url;
        if (issues.length > 1) {
            const issueKeys = issues.map((issue)=>issue.key).join(',');
            const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
            return `${currentSiteUrl}/issues/?jql=${jqlSearch}`;
        }
        return (0, $1Q0l6.constructJiraIssueUrl)(currentSiteUrl, issues[0].key);
    }, [
        currentJiraSite
    ]);
};


const $9a1f5308e6e530ee$export$aff298770ebd2dda = 'bulk-issue-create--single-issue-created-flag';
const $9a1f5308e6e530ee$export$ba0b5c0cfc28f547 = 'bulk-issue-create--multiple-issues-created-flag';
const $9a1f5308e6e530ee$export$db06b037c240fa26 = 'bulk-issue-create--single-issue-insert-link-failure-flag';
const $9a1f5308e6e530ee$export$a625c427f2ed7356 = 'bulk-issue-create--multiple-issues-insert-link-failure-flag';
const $9a1f5308e6e530ee$export$a1331a3465266712 = 'bulk-issue-create--document-modified-after-selection-single-insert-failure-flag';
const $9a1f5308e6e530ee$export$3106a4e520795663 = 'bulk-issue-create--document-modified-after-selection-multiple-issues-insert-failure-flag';
const $9a1f5308e6e530ee$export$89914132e011d9d2 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const flags = (0, $aMxFD.useBulkCreateFlagsContainer)();
    const getJiraIssuesLink = (0, $512ab0a436635a50$export$fd734339a42971bc)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const triggerSingleIssueCreatedFlag = (0, $42omo.useCallback)((payload)=>{
        const link = getJiraIssuesLink([
            {
                key: payload.issueKey
            }
        ]);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$aff298770ebd2dda,
            type: 'success-circle',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle, {
                issueKey: payload.issueKey,
                issueSummary: payload.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                        href: link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerMultipleIssuesCreatedFlag = (0, $42omo.useCallback)((payload, reloadOnClick, showReloadAction)=>{
        const href = getJiraIssuesLink(payload);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$ba0b5c0cfc28f547,
            type: 'success-circle',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelMultipleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelMultipleIssueCreateSuccessFlagTitle, {
                issueCount: payload.length
            }),
            actions: [
                ...showReloadAction ? [
                    {
                        content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagReloadToSeeLinks),
                        onClick: reloadOnClick
                    }
                ] : [],
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagViewIssue, {
                        issueCount: payload.length
                    }),
                    href: href,
                    target: '_blank'
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerSingleIssueInsertLinkFailureFlag = (0, $42omo.useCallback)((payload)=>{
        const link = getJiraIssuesLink([
            {
                key: payload.issueKey
            }
        ]);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$db06b037c240fa26,
            type: 'error',
            title: formatMessage((0, $3E5yu.messages).sidePanelSingleIssueInsertLinkFailureFlagTitle, {
                issueKey: payload.issueKey,
                issueSummary: payload.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                        href: link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerMultipleIssuesInsertLinkFailureFlag = (0, $42omo.useCallback)((payload)=>{
        const href = getJiraIssuesLink(payload);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$a625c427f2ed7356,
            type: 'error',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelMultipleIssuesInsertLinkFailureFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelMultipleIssuesInsertLinkFailureFlagTitle, {
                issueCount: payload.length
            }),
            close: 'auto',
            actions: [
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagViewIssue, {
                        issueCount: payload.length
                    }),
                    href: href,
                    target: '_blank'
                },
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagCopyLink),
                    onClick: ()=>void copyToClipboard(href)
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink,
        copyToClipboard
    ]);
    const triggerDocumentModifiedSingleIssueInsertLinkFailureFlag = (0, $42omo.useCallback)((payload)=>{
        const link = getJiraIssuesLink([
            {
                key: payload.issueKey
            }
        ]);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$a1331a3465266712,
            type: 'error',
            title: formatMessage((0, $3E5yu.messages).documentModifiedSingleIssueInsertLinkFailureFlagTitle, {
                issueKey: payload.issueKey,
                issueSummary: payload.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                        href: link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink
    ]);
    const triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag = (0, $42omo.useCallback)((payload)=>{
        const href = getJiraIssuesLink(payload);
        flags?.showFlag({
            id: $9a1f5308e6e530ee$export$3106a4e520795663,
            type: 'error',
            title: formatMessage((0, $3E5yu.messages).documentModifiedMultipleIssuesInsertLinkFailureFlagTitle, {
                issueCount: payload.length
            }),
            close: 'auto',
            actions: [
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagViewIssue, {
                        issueCount: payload.length
                    }),
                    href: href,
                    target: '_blank'
                },
                {
                    content: formatMessage((0, $3E5yu.messages).sidePanelMultipleIssueCreateFlagCopyLink),
                    onClick: ()=>void copyToClipboard(href)
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        getJiraIssuesLink,
        copyToClipboard
    ]);
    return {
        triggerSingleIssueCreatedFlag: triggerSingleIssueCreatedFlag,
        triggerMultipleIssuesCreatedFlag: triggerMultipleIssuesCreatedFlag,
        triggerSingleIssueInsertLinkFailureFlag: triggerSingleIssueInsertLinkFailureFlag,
        triggerMultipleIssuesInsertLinkFailureFlag: triggerMultipleIssuesInsertLinkFailureFlag,
        triggerDocumentModifiedSingleIssueInsertLinkFailureFlag: triggerDocumentModifiedSingleIssueInsertLinkFailureFlag,
        triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag: triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag
    };
};



var $5Ew1A = parcelRequire("5Ew1A");


var $26Yin = parcelRequire("26Yin");





var $k9cgj = parcelRequire("k9cgj");





var $bUlM5 = parcelRequire("bUlM5");








var $cO1el = parcelRequire("cO1el");


var $bPdpL = parcelRequire("bPdpL");


var $1qfLF = parcelRequire("1qfLF");




const $ac64a6e53786764f$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $ac64a6e53786764f$export$96d57f6ccda50ec9 = ({ children: children, onClose: onClose })=>{
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                label: "back-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: onClose,
        isDisabled: isMissingColumnMappingError,
        testId: "close-bulk-issue-create-panel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac64a6e53786764f$var$headerMessageStyle
    }, children))));
};


const $e6b2e07d107802c1$var$bulkEditContentWrapper = (0, $ecnYn.xcss)({
    flexGrow: '1'
});
const $e6b2e07d107802c1$export$bfc1d0fcda79c38d = ({ isAiIssue: isAiIssue = false })=>{
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const setSingleIssuesCreated = (0, $hq2Sz.useSetSingleIssuesCreated)();
    const setNextIssueToEdit = (0, $hq2Sz.useSetNextIssueToEdit)();
    const currentPage = (0, $aMxFD.useAiBulkNavigationCurrentPage)();
    const { logSingleIssueCreateSuccess: logSingleIssueCreateSuccess, logSingleIssueCreateFailure: logSingleIssueCreateFailure, logCreateSingleIssueClick: logCreateSingleIssueClick } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const [{ currentIssueId: currentIssueId, currentJiraProject: currentJiraProject, currentJiraSite: currentJiraSite, bulkIssuesList: bulkIssuesList, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, isCreatedFromActionItems: isCreatedFromActionItems }] = (0, $hq2Sz.useBulkCreateContext)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const currentIssue = bulkIssuesList.find((issue)=>issue.id === currentIssueId);
    const { triggerSingleIssueCreatedFlag: triggerSingleIssueCreatedFlag } = (0, $9a1f5308e6e530ee$export$89914132e011d9d2)();
    const onDismiss = (0, $42omo.useCallback)(()=>{
        goToPage('default');
    }, [
        goToPage
    ]);
    const onClose = (0, $42omo.useCallback)((isCreateSuccess)=>{
        if (!isCreateSuccess) goToPage('default');
    }, [
        goToPage
    ]);
    const isOpen = currentPage === 'edit_issue';
    const onFailure = (0, $42omo.useCallback)((error)=>{
        logSingleIssueCreateFailure(error);
    }, [
        logSingleIssueCreateFailure
    ]);
    const onSuccess = (0, $42omo.useCallback)((payload)=>{
        logSingleIssueCreateSuccess();
        logCreateSingleIssueClick(payload?.issueId?.toString());
        triggerSingleIssueCreatedFlag(payload);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        const response = (0, $k9cgj.mapGICPayloadToCreateIssueResponse)(payload);
        const issueCreated = {
            ...response,
            summary: response.summary,
            rowIndex: currentIssue?.rowIndex
        };
        setSingleIssuesCreated(issueCreated);
        setNextIssueToEdit();
    }, [
        triggerSingleIssueCreatedFlag,
        logSingleIssueCreateSuccess,
        setSingleIssuesCreated,
        setNextIssueToEdit,
        logCreateSingleIssueClick,
        currentIssue
    ]);
    if (!currentIssue || !currentJiraProject || !issueType || !currentJiraSite) // TODO return error screen component
    return null;
    const { summary: summary, description: description, id: issueId, assigneeUserId: assigneeUserId, labels: labels, parent: parent } = currentIssue;
    const additionalMappedFields = {
        ...labels?.length && {
            labels: labels
        },
        ...parent?.id && {
            parent: parent.id
        },
        ...currentIssue.additionalFields?.reduce((acc, field)=>{
            acc[field.field.fieldId] = (0, $k9cgj.convertToGICFieldValue)(field);
            return acc;
        }, {})
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWrapper), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        testId: "bulk-edit-content-wrapper",
        xcss: $e6b2e07d107802c1$var$bulkEditContentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac64a6e53786764f$export$96d57f6ccda50ec9), {
        onClose: onDismiss
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateEditHeaderTextIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateEditHeaderText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1cfc86eef024eecc$export$3177b460ca1a5743), {
        key: `issue-id-${issueId}`,
        cloudId: currentJiraSite.cloudId,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        analyticsSource: (0, $26Yin.getSource)(isCreatedFromTable, isCreatedFromActionItems),
        summary: summary,
        descriptionAdf: description,
        issueTypeId: issueType.id,
        configuration: {
            disableProjectDropdown: true,
            displaySitePicker: false
        },
        projectId: currentJiraProject.id,
        assigneeId: assigneeUserId,
        isCreatedWithAi: isCreatedWithAi,
        isCreatedFromTable: isCreatedFromTable,
        ...Object.keys(additionalMappedFields).length > 0 && {
            additionalMappedFields: {
                ...additionalMappedFields,
                pid: currentJiraProject.id,
                issuetype: issueType.id,
                ...description && {
                    description: description
                }
            }
        }
    }), isAiIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiixe.AiSubFooter), null)));
};












var $fzqvY = parcelRequire("fzqvY");








var $5dK2X = parcelRequire("5dK2X");





var $aoVih = parcelRequire("aoVih");

















var $CbMiC = parcelRequire("CbMiC");












var $fb3kw = parcelRequire("fb3kw");


var $6T8v4 = parcelRequire("6T8v4");


var $3hOY6 = parcelRequire("3hOY6");


var $bYRk6 = parcelRequire("bYRk6");








var $f0BVO = parcelRequire("f0BVO");








var $esRft = parcelRequire("esRft");


var $u9agA = parcelRequire("u9agA");


var $iXCQx = parcelRequire("iXCQx");

const $889600fbced24328$export$f4d12280b3fb5f60 = ({ label: label, avatarUrl: avatarUrl })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium"
    }, label));
};


const $52e9bc47e2ec1c07$var$mapIssueTypeToOption = (issueType)=>{
    return {
        label: issueType.name,
        value: issueType,
        avatarUrl: (0, $f0BVO.transformStargateUrl)(issueType.iconUrl)
    };
};
const $52e9bc47e2ec1c07$var$IssueTypeOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $889600fbced24328$export$f4d12280b3fb5f60), {
        label: props.label,
        avatarUrl: props.data.avatarUrl
    }));
const $52e9bc47e2ec1c07$var$IssueTypeSingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $889600fbced24328$export$f4d12280b3fb5f60), {
        label: props.data.label,
        avatarUrl: props.data.avatarUrl
    }));
const $52e9bc47e2ec1c07$export$aa04298ab6db90d8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { selectedIssueType: selectedIssueType, optionsIssueTypes: issueTypes } = (0, $CbMiC.useIssueTypesState)();
    const { setSelectedIssueType: setSelectedIssueType } = (0, $CbMiC.useIssueTypesActions)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    // Old Sweet State logic
    const optionsSweetState = (0, $42omo.useMemo)(()=>{
        return issueTypes?.map($52e9bc47e2ec1c07$var$mapIssueTypeToOption);
    }, [
        issueTypes
    ]);
    const onChangeSweetState = (0, $42omo.useCallback)((selectedOption)=>{
        if (selectedOption && selectedOption.value !== selectedIssueType) setSelectedIssueType(selectedOption.value);
    }, [
        selectedIssueType,
        setSelectedIssueType
    ]);
    const selectedValueSweetState = selectedIssueType ? $52e9bc47e2ec1c07$var$mapIssueTypeToOption(selectedIssueType) : null;
    // New decoupled logic (props/local state)
    const { optionsIssueTypes: optionsIssueTypes = [], value: controlledValue, onChange: onChange, isLoading: isLoading = false, isDisabled: isDisabled = false, label: label } = props;
    const [localValue, setLocalValue] = (0, $42omo.useState)(controlledValue ?? null);
    (0, $42omo.useEffect)(()=>{
        if (controlledValue !== undefined) setLocalValue(controlledValue);
    }, [
        controlledValue
    ]);
    const mappedOptions = (0, $42omo.useMemo)(()=>optionsIssueTypes.map($52e9bc47e2ec1c07$var$mapIssueTypeToOption), [
        optionsIssueTypes
    ]);
    if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) // Old Sweet State logic
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "defaultIssueTypes",
        label: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType),
        testId: "work-create-issue-type-field"
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            options: optionsSweetState,
            isDisabled: isConfigureLoading || !selectedValueSweetState,
            isLoading: isConfigureLoading,
            value: selectedValueSweetState,
            onChange: onChangeSweetState,
            components: {
                Option: $52e9bc47e2ec1c07$var$IssueTypeOption,
                SingleValue: $52e9bc47e2ec1c07$var$IssueTypeSingleValue
            }
        })));
    const handleChange = (selectedOption)=>{
        if (!selectedOption || !selectedOption.value) return;
        if (selectedOption.value === localValue) return;
        setLocalValue(selectedOption.value);
        onChange?.(selectedOption.value);
    };
    const selectedValue = localValue ? $52e9bc47e2ec1c07$var$mapIssueTypeToOption(localValue) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "defaultIssueTypes",
        // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
        label: label ?? formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType),
        testId: "work-create-issue-type-field",
        isRequired: props.isRequired ?? false
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: {
                attributes: {
                    fieldName: 'workCreateFormIssueTypeSelector'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            value: selectedValue,
            options: mappedOptions,
            onChange: handleChange,
            isLoading: isLoading,
            isDisabled: isLoading || isDisabled || !selectedValue,
            components: {
                Option: $52e9bc47e2ec1c07$var$IssueTypeOption,
                SingleValue: $52e9bc47e2ec1c07$var$IssueTypeSingleValue
            }
        })));
};



































const $46689f7fc671df97$var$mapProjectToOption = (project)=>{
    return {
        label: project.name,
        value: project,
        avatarUrl: (0, $f0BVO.transformStargateUrl)(project.avatarUrls['48x48'])
    };
};
const $46689f7fc671df97$var$ProjectTypeOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $889600fbced24328$export$f4d12280b3fb5f60), {
        label: props.label,
        avatarUrl: props.data.avatarUrl
    }));
const $46689f7fc671df97$var$ProjectTypeSingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $889600fbced24328$export$f4d12280b3fb5f60), {
        label: props.data.label,
        avatarUrl: props.data.avatarUrl
    }));
const $46689f7fc671df97$export$a764642e4b725728 = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { selectedProject: selectedProject, optionsRecentProjects: recentProjects, optionsAllProjects: allProjects } = (0, $CbMiC.useProjectsState)();
    const { setSelectedProject: setSelectedProject, setProjectSelectorQuery: setProjectSelectorQuery } = (0, $CbMiC.useProjectsActions)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    // Old Sweet State logic
    const optionsSweetState = (0, $42omo.useMemo)(()=>{
        if (recentProjects && recentProjects.length > 0) return [
            {
                label: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
                options: recentProjects.map($46689f7fc671df97$var$mapProjectToOption)
            },
            {
                label: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects),
                options: allProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
        return [
            {
                options: allProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
    }, [
        recentProjects,
        allProjects,
        formatMessage
    ]);
    const onChangeSweetState = (0, $42omo.useCallback)((selectedOption)=>{
        if (selectedOption && selectedOption.value !== selectedProject) setSelectedProject(selectedOption.value);
    }, [
        selectedProject,
        setSelectedProject
    ]);
    const debounceTimeoutSweetStateRef = (0, $42omo.useRef)(null);
    const onInputChangeSweetState = (0, $42omo.useCallback)((query)=>{
        if (debounceTimeoutSweetStateRef.current) clearTimeout(debounceTimeoutSweetStateRef.current);
        debounceTimeoutSweetStateRef.current = setTimeout(()=>{
            setProjectSelectorQuery(query);
        }, 300);
    }, [
        setProjectSelectorQuery
    ]);
    const selectedValueSweetState = selectedProject ? $46689f7fc671df97$var$mapProjectToOption(selectedProject) : null;
    // New decoupled logic (props/local state)
    const { optionsAllProjects: optionsAllProjects = [], optionsRecentProjects: optionsRecentProjects = [], value: controlledValue, onChange: onChange, isLoading: isLoading = false, isDisabled: isDisabled = false, onInputChange: onInputChange, labelProjectSelectorRecentProjects: labelProjectSelectorRecentProjects, labelProjectSelectorProjects: labelProjectSelectorProjects } = props;
    const [localValue, setLocalValue] = (0, $42omo.useState)(controlledValue ?? null);
    const selectedValue = localValue ? $46689f7fc671df97$var$mapProjectToOption(localValue) : null;
    const groupedOptions = (0, $42omo.useMemo)(()=>{
        if (optionsRecentProjects && optionsRecentProjects.length > 0) return [
            {
                // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
                label: labelProjectSelectorRecentProjects ?? formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
                options: optionsRecentProjects.map($46689f7fc671df97$var$mapProjectToOption)
            },
            {
                // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
                label: labelProjectSelectorProjects ?? formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects),
                options: optionsAllProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
        return [
            {
                options: optionsAllProjects?.map($46689f7fc671df97$var$mapProjectToOption) || []
            }
        ];
    }, [
        optionsRecentProjects,
        optionsAllProjects,
        formatMessage,
        labelProjectSelectorRecentProjects,
        labelProjectSelectorProjects
    ]);
    // Keep local state in sync with controlled value
    (0, $42omo.useEffect)(()=>{
        if (controlledValue !== undefined && controlledValue !== localValue) setLocalValue(controlledValue);
    }, [
        controlledValue,
        localValue
    ]);
    const handleChange = (selectedOption)=>{
        if (!selectedOption || !selectedOption.value) return;
        if (selectedOption.value === localValue) return;
        const newValue = selectedOption ? selectedOption.value : null;
        setLocalValue(newValue);
        onChange?.(newValue);
    };
    // Debounce input change and let consumer set the state
    const debounceTimeoutRef = (0, $42omo.useRef)(null);
    const handleInputChange = (0, $42omo.useCallback)((query)=>{
        if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = setTimeout(()=>{
            onInputChange?.(query);
        }, 300);
    }, [
        onInputChange
    ]);
    if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) // Old Sweet State logic
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "projects",
        // TODO: Remove formatMessage once we cleanup jira_ai_decouple_issue_create_fields FF
        label: props.label ?? formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectGalaxia : (0, $3E5yu.messages).bulkConfigureFormProject),
        testId: "work-create-project-field"
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            isDisabled: isConfigureLoading || !selectedValueSweetState,
            isLoading: isConfigureLoading,
            onInputChange: onInputChangeSweetState,
            value: selectedValueSweetState,
            options: optionsSweetState,
            onChange: onChangeSweetState,
            components: {
                Option: $46689f7fc671df97$var$ProjectTypeOption,
                SingleValue: $46689f7fc671df97$var$ProjectTypeSingleValue
            }
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "projects",
        label: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectGalaxia : (0, $3E5yu.messages).bulkConfigureFormProject),
        testId: "work-create-project-field",
        isRequired: props.isRequired ?? false
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: {
                attributes: {
                    fieldName: 'workCreateFormProjectSelector'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            value: selectedValue,
            options: groupedOptions,
            onInputChange: handleInputChange,
            onChange: handleChange,
            isLoading: isLoading,
            isDisabled: isDisabled || isLoading || !selectedValue,
            components: {
                Option: $46689f7fc671df97$var$ProjectTypeOption,
                SingleValue: $46689f7fc671df97$var$ProjectTypeSingleValue
            }
        })));
};

























const $445bd7561410e232$export$24eb759d590e7556 = (site)=>({
        label: site.displayName,
        value: site
    });
const $445bd7561410e232$export$515237fa9c64c5dc = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    // Old Sweet State logic
    const { selectedAvailableSite: selectedAvailableSite, optionsAvailableSites: optionsAvailableSites } = (0, $CbMiC.useAvailableSitesState)();
    const { setSelectedAvailableSite: setSelectedAvailableSite } = (0, $CbMiC.useAvailableSitesActions)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    const optionsSweetState = (0, $42omo.useMemo)(()=>{
        return optionsAvailableSites?.map($445bd7561410e232$export$24eb759d590e7556);
    }, [
        optionsAvailableSites
    ]);
    const onChangeSweetState = (0, $42omo.useCallback)((selectedOptionSweetState)=>{
        if (selectedOptionSweetState && selectedOptionSweetState.value !== selectedAvailableSite) setSelectedAvailableSite(selectedOptionSweetState.value);
    }, [
        selectedAvailableSite,
        setSelectedAvailableSite
    ]);
    // New decoupled logic (props/local state)
    const { options: options = [], value: controlledValue, onChange: onChange, isLoading: isLoading = false, isDisabled: isDisabled = false, label: label } = props;
    const [localValue, setLocalValue] = (0, $42omo.useState)(controlledValue ?? null);
    const mappedOptions = (0, $42omo.useMemo)(()=>options?.map($445bd7561410e232$export$24eb759d590e7556), [
        options
    ]);
    const selectedValue = localValue ? $445bd7561410e232$export$24eb759d590e7556(localValue) : null;
    // Keep local state in sync with controlled value
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) return;
        if (controlledValue !== undefined) setLocalValue(controlledValue);
    }, [
        controlledValue,
        setLocalValue
    ]);
    if (!(0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "sites",
        label: formatMessage((0, $3E5yu.messages).bulkConfigureFormSite),
        testId: "work-create-site-field"
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: {
                attributes: {
                    fieldName: 'workCreateFormSiteSelector'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            value: selectedAvailableSite ? $445bd7561410e232$export$24eb759d590e7556(selectedAvailableSite) : null,
            options: optionsSweetState,
            onChange: onChangeSweetState,
            isLoading: isConfigureLoading,
            isDisabled: isConfigureLoading
        }))));
    const handleChange = (selectedOption)=>{
        if (!selectedOption || !selectedOption.value) return;
        if (selectedOption.value === localValue) return;
        const newValue = selectedOption ? selectedOption.value : null;
        setLocalValue(newValue);
        onChange?.(newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "sites",
        // TODO: Remove formatMessage(messages.bulkConfigureFormSite) once we cleanup jira_ai_decouple_issue_create_fields FF
        label: label ?? formatMessage((0, $3E5yu.messages).bulkConfigureFormSite),
        testId: "work-create-site-field",
        isRequired: props.isRequired ?? false
    }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: {
                attributes: {
                    fieldName: 'workCreateFormSiteSelector'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
            inputId: id,
            ...rest,
            value: selectedValue,
            options: mappedOptions,
            onChange: handleChange,
            isLoading: isLoading,
            isDisabled: isDisabled || isLoading
        }))));
};









var $g5gZt = parcelRequire("g5gZt");


var $ccHMk = parcelRequire("ccHMk");


var $gdv5Z = parcelRequire("gdv5Z");


var $eyWa4 = parcelRequire("eyWa4");



































var $fVjjG = parcelRequire("fVjjG");


var $bfgIy = parcelRequire("bfgIy");





var $gKvd9 = parcelRequire("gKvd9");











var $2R8mu = parcelRequire("2R8mu");








var $euVTc = parcelRequire("euVTc");

const $e629f20933f2b7aa$export$e4d267d65a03b8ba = 'table-column-select';
const $e629f20933f2b7aa$export$8083937ff4fc332a = 'issue-field-select';
const $e629f20933f2b7aa$export$6d5add497b2ba4ca = {
    fieldId: 'components',
    hasDefaultValue: false,
    key: 'components',
    name: 'Components',
    operations: [],
    schema: {
        type: (0, $2R8mu.FieldMetadataSchemaType).COMPONENTS
    },
    // We will only show the Components field if the entire column is valid.
    required: true
};
const $e629f20933f2b7aa$export$1cb34fe05cdad9ea = ({ index: index, mapping: mapping, tableColumnOptions: tableColumnOptions, issueFieldOptions: issueFieldOptions, onMappingChange: onMappingChange, isLoading: isLoading, isDisabled: isDisabled, onAutoScrollOnMenuOpen: onAutoScrollOnMenuOpen })=>{
    const { deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping } = (0, $CbMiC.useMappingsActions)();
    const handleMenuOpen = (0, $42omo.useCallback)(()=>{
        onAutoScrollOnMenuOpen?.();
    }, [
        onAutoScrollOnMenuOpen
    ]);
    const handleSelectChange = (0, $42omo.useCallback)((idx, key, newValue)=>{
        if (newValue) onMappingChange(idx, {
            ...mapping,
            [key]: newValue.value
        });
    }, [
        mapping,
        onMappingChange
    ]);
    const { logDeleteMappingClicked: logDeleteMappingClicked } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const deleteMapping = (0, $42omo.useCallback)((idx)=>{
        if (isLoading) return;
        deleteUnsavedColumnToFieldMapping(idx);
    }, [
        isLoading,
        deleteUnsavedColumnToFieldMapping
    ]);
    const [{ selectedTable: selectedTable }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { mappingWorkItemTypes: mappingWorkItemTypes, mappingValidParentCandidates: mappingValidParentCandidates, mappingFieldAllowedValues: mappingFieldAllowedValues, mappingAvailableComponents: mappingAvailableComponents } = (0, $CbMiC.useMappingsState)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableIssueFieldOptions = (0, $42omo.useMemo)(()=>{
        const allIssueFieldOptions = [
            ...issueFieldOptions
        ];
        if (mappingAvailableComponents && mappingAvailableComponents.length > 0) allIssueFieldOptions.push({
            label: formatMessage((0, $3E5yu.messages).bulkCreateConfigureBodyWorkFieldMappingsComponentsFieldOption),
            value: $e629f20933f2b7aa$export$6d5add497b2ba4ca
        });
        return allIssueFieldOptions;
    }, [
        issueFieldOptions,
        mappingAvailableComponents,
        formatMessage
    ]);
    // Includes the components allowed values if they are available.
    const fullMappingFieldAllowedValues = (0, $42omo.useMemo)(()=>{
        const map = new Map(mappingFieldAllowedValues ?? []);
        if (mappingAvailableComponents && mappingAvailableComponents.length > 0) map.set('components', mappingAvailableComponents);
        return map;
    }, [
        mappingFieldAllowedValues,
        mappingAvailableComponents
    ]);
    const validatedIssueFieldOptions = (0, $42omo.useMemo)(()=>{
        return availableIssueFieldOptions.filter((option)=>{
            if (!mapping.column) return false;
            const validatedIssueFieldValues = (0, $euVTc.getValidatedIssueFieldValuesForColumn)(mapping.column, option.value.fieldId, selectedTable ?? new HTMLTableElement(), {
                mappingWorkItemTypes: mappingWorkItemTypes ?? new Map(),
                selectedIssueType: selectedIssueType,
                mappingValidParentCandidates: mappingValidParentCandidates ?? new (0, $2R8mu.SimpleJiraIssuesSet)(),
                mappingFieldAllowedValues: fullMappingFieldAllowedValues
            });
            const checkedType = (0, $euVTc.getFieldTypeFromMetadata)(option.value);
            const validatedValues = validatedIssueFieldValues?.get(checkedType);
            // If the field is required, it must be canBeRequired. Otherwise, it must have at least one validated value.
            return validatedValues != null && (option.value.required ? validatedValues.canBeRequired : validatedValues.fieldValues.length > 0);
        });
    }, [
        mapping,
        mappingWorkItemTypes,
        mappingValidParentCandidates,
        fullMappingFieldAllowedValues,
        selectedIssueType,
        selectedTable,
        availableIssueFieldOptions
    ]);
    const handleDeleteMappingClick = (0, $42omo.useCallback)((idx)=>{
        logDeleteMappingClicked();
        deleteMapping(idx);
    }, [
        logDeleteMappingClicked,
        deleteMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: "table-column-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueTableColumn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: $e629f20933f2b7aa$export$e4d267d65a03b8ba,
        classNamePrefix: $e629f20933f2b7aa$export$e4d267d65a03b8ba,
        appearance: "default",
        options: tableColumnOptions,
        defaultValue: tableColumnOptions.find((option)=>option.value === mapping.column),
        onChange: (newValue)=>handleSelectChange(index, 'column', newValue),
        onMenuOpen: handleMenuOpen,
        isLoading: isLoading,
        isDisabled: isDisabled
    })), mapping.errors.column && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, " ", mapping.errors.column.message, " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfgIy.Label), {
        htmlFor: "issue-field-select"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueIssueFieldIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueIssueField)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: $e629f20933f2b7aa$export$8083937ff4fc332a,
        classNamePrefix: $e629f20933f2b7aa$export$8083937ff4fc332a,
        appearance: "default",
        options: validatedIssueFieldOptions,
        defaultValue: validatedIssueFieldOptions.find((option)=>option.value === mapping.field),
        onChange: (newValue)=>handleSelectChange(index, 'field', newValue),
        onMenuOpen: handleMenuOpen,
        isLoading: isLoading,
        isDisabled: isDisabled || mapping.isDefaultMapping
    })), mapping.errors.field && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, " ", mapping.errors.field.message, " ")), !mapping.isDefaultMapping && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onClick: ()=>handleDeleteMappingClick(index),
        isDisabled: isDisabled,
        label: "delete",
        testId: "delete-additional-mapping"
    })));
};


const $18b3c33293d9759e$var$mapFieldsToOptions = (fields)=>{
    return fields.map((field)=>({
            label: field.name,
            value: field
        }));
};
const $18b3c33293d9759e$var$createIssueFieldMappingKey = (mapping, index)=>{
    return `${index}-${mapping.column?.index ?? 'null'}-${mapping.field?.fieldId ?? 'null'}`;
};
const $18b3c33293d9759e$export$aab6883e3d0e5f63 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onAutoScrollOnMenuOpen: onAutoScrollOnMenuOpen }, ref)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ pageMode: pageMode }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { isLoading: isConfigureLoading } = (0, $CbMiC.useIsConfigureLoading)();
    const { optionsColumns: optionsColumns, optionsIssueTypeFields: optionsIssueTypeFields, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, loadingIssueTypeFields: loadingIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    const { setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping } = (0, $CbMiC.useMappingsActions)();
    const tableColumnOptions = optionsColumns ? optionsColumns.map((column)=>({
            label: column.header,
            value: column
        })) : [];
    const issueFieldOptions = optionsIssueTypeFields ? $18b3c33293d9759e$var$mapFieldsToOptions(optionsIssueTypeFields) : [];
    const isLoading = isConfigureLoading || loadingIssueTypeFields;
    const { logAddMappingClicked: logAddMappingClicked } = (0, $26Yin.useBulkCreateLoggingEvents)();
    // Get mappings with updated column references - compute this synchronously to avoid double renders
    const mappingsWithUpdatedColumns = (0, $42omo.useMemo)(()=>{
        if (!unsavedColumnToFieldMappings || !optionsColumns) return unsavedColumnToFieldMappings;
        // Create a map of column index to current column objects for efficient lookup
        const columnsMap = new Map(optionsColumns.map((col)=>[
                col.index,
                col
            ]));
        return unsavedColumnToFieldMappings.map((mapping)=>{
            if (mapping.column) {
                const updatedColumn = columnsMap.get(mapping.column.index);
                if (updatedColumn) return {
                    ...mapping,
                    column: updatedColumn
                };
            }
            return mapping;
        });
    }, [
        unsavedColumnToFieldMappings,
        optionsColumns
    ]);
    const handleMappingChange = (0, $42omo.useCallback)((index, newMapping)=>{
        if (unsavedColumnToFieldMappings) {
            const updatedMappings = unsavedColumnToFieldMappings.map((mapping, idx)=>idx === index ? newMapping : mapping);
            setUnsavedColumnToFieldMappings(updatedMappings);
        }
    }, [
        unsavedColumnToFieldMappings,
        setUnsavedColumnToFieldMappings
    ]);
    // Create a Set of mapped column indices for quick lookup
    const mappedColumnIndices = (0, $42omo.useMemo)(()=>{
        if (!mappingsWithUpdatedColumns) return new Set();
        return new Set(mappingsWithUpdatedColumns.map((mapping)=>mapping.column?.index).filter((index)=>index !== undefined));
    }, [
        mappingsWithUpdatedColumns
    ]);
    // Find the next available column that is not already mapped (or undefined if none exists)
    const nextAvailableColumn = (0, $42omo.useMemo)(()=>{
        if (!optionsColumns) return undefined;
        // Find the first unmapped column starting from index 0
        for (const column of optionsColumns){
            if (!mappedColumnIndices.has(column.index)) return column;
        }
        return undefined; // No available column found
    }, [
        optionsColumns,
        mappedColumnIndices
    ]);
    const addMapping = (0, $42omo.useCallback)(()=>{
        if (isLoading) return;
        const newMapping = {
            column: nextAvailableColumn,
            field: undefined,
            errors: {},
            isDefaultMapping: false
        };
        addUnsavedColumnToFieldMapping(newMapping);
        onAutoScrollOnMenuOpen?.();
    }, [
        isLoading,
        addUnsavedColumnToFieldMapping,
        nextAvailableColumn,
        onAutoScrollOnMenuOpen
    ]);
    const handleAddMappingClick = (0, $42omo.useCallback)(()=>{
        logAddMappingClicked();
        addMapping();
        onAutoScrollOnMenuOpen?.();
    }, [
        logAddMappingClicked,
        addMapping,
        onAutoScrollOnMenuOpen
    ]);
    // TODO: Please update the messages and ensure they are internationalized once the content design has been finalized.
    const validateMappings = ()=>{
        if (!mappingsWithUpdatedColumns) return false;
        let isValid = true;
        const mappedField = new Set();
        const updatedMappings = mappingsWithUpdatedColumns.map((mapping)=>{
            const { column: column, field: field } = mapping;
            const errors = {};
            if (!column) {
                errors.column = {
                    message: formatMessage((0, $3E5yu.messages).bulkConfigureMapTableToIssueErrorColumnNotSelected)
                };
                isValid = false;
            }
            if (!field) {
                errors.field = {
                    message: formatMessage((0, $3E5yu.messages).bulkConfigureMapTableToIssueErrorFieldNotSelected)
                };
                isValid = false;
            } else {
                const fieldId = field.fieldId;
                if (mappedField.has(fieldId)) {
                    errors.field = {
                        message: formatMessage((0, $3E5yu.messages).bulkConfigureMapTableToIssueErrorFieldAlreadyMapped)
                    };
                    isValid = false;
                } else mappedField.add(fieldId);
            }
            return {
                ...mapping,
                errors: errors
            };
        });
        setUnsavedColumnToFieldMappings(updatedMappings);
        return isValid;
    };
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            validateMappings: validateMappings
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueTitleIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.300"
    }, mappingsWithUpdatedColumns?.map((mapping, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e629f20933f2b7aa$export$1cb34fe05cdad9ea), {
            key: $18b3c33293d9759e$var$createIssueFieldMappingKey(mapping, index),
            index: index,
            mapping: mapping,
            tableColumnOptions: tableColumnOptions,
            issueFieldOptions: issueFieldOptions,
            onMappingChange: handleMappingChange,
            isLoading: loadingIssueTypeFields || isLoading,
            isDisabled: loadingIssueTypeFields || isLoading,
            pageMode: pageMode,
            onAutoScrollOnMenuOpen: onAutoScrollOnMenuOpen
        });
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.0",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), iconProps),
        onClick: handleAddMappingClick,
        isDisabled: loadingIssueTypeFields || isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMapTableToIssueAddMapping)))));
});















var $dcJ7R = parcelRequire("dcJ7R");










const $37a527a75d28e217$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    position: 'relative',
    flexShrink: 0,
    bottom: 'space.0',
    width: '100%',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $37a527a75d28e217$export$a11e7c1ace4beba4 = ({ onClose: onClose, closePanel: closePanel, isSaveDisabled: isSaveDisabled })=>{
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    // We are directly navigating the user to the configure page if there are no issues to mapped.
    // Since the configure page doesn't have a way to close the side panel, we are changing the cancel button to allow the user to close the side panel in case they don't want to proceed.
    const onCancel = isMissingColumnMappingError ? closePanel : onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInline: "space.300",
        xcss: $37a527a75d28e217$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        testId: "configure-cancel-button",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureFooterCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        type: "submit",
        form: "configureForm",
        appearance: "primary",
        testId: "configure-save-button",
        isDisabled: isSaveDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureFooterSave))));
};


const $d923f05cd22225af$var$bulkConfigureViewStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    overflowY: 'auto'
});
const $d923f05cd22225af$var$ATLAS_KIT_SELECT_OPEN_CLASS = '[class*="select__menu"]';
const $d923f05cd22225af$export$ee2807e678386f7a = ({ closePanel: closePanel = ()=>{} })=>{
    const [{ isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType }, { setCurrentJiraSite: setCurrentJiraSite, setCurrentJiraProject: setCurrentJiraProject, setCurrentDefaultIssueType: setCurrentDefaultIssueType }] = (0, $hq2Sz.useBulkCreateContext)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { optionsAvailableSites: optionsAvailableSites, selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { setSelectedAvailableSite: setSelectedAvailableSite } = (0, $CbMiC.useAvailableSitesActions)();
    const { selectedProject: selectedProject, optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects } = (0, $CbMiC.useProjectsState)();
    const { setSelectedProject: setSelectedProject, setProjectSelectorQuery: setProjectSelectorQuery } = (0, $CbMiC.useProjectsActions)();
    const { selectedIssueType: selectedIssueType, optionsIssueTypes: optionsIssueTypes } = (0, $CbMiC.useIssueTypesState)();
    const { setSelectedIssueType: setSelectedIssueType } = (0, $CbMiC.useIssueTypesActions)();
    const { isLoading: isLoading, isJiraError: isJiraError } = (0, $CbMiC.useIsConfigureLoading)();
    const resetConfigureState = (0, $CbMiC.useResetConfigureState)();
    const { setIsJiraError: setIsJiraError } = (0, $CbMiC.useProjectsActions)();
    const { setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings, saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping } = (0, $CbMiC.useMappingsActions)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const currentPage = (0, $aMxFD.useAiBulkNavigationCurrentPage)();
    const isOpen = currentPage === 'configure';
    const isMissingColumnMappingError = (0, $hq2Sz.useGetIsMissingColumnMappingError)();
    const mappingViewRef = (0, $42omo.useRef)(null);
    const scrollableContainerRef = (0, $42omo.useRef)(null);
    const handleAutoScrollOnMenuOpen = (0, $42omo.useCallback)(()=>{
        if (scrollableContainerRef.current) // Add a delay to allow the dropdown to render
        setTimeout(()=>{
            const container = scrollableContainerRef.current;
            if (!container) return;
            // Find any open dropdown menu
            const openDropdown = container.querySelector($d923f05cd22225af$var$ATLAS_KIT_SELECT_OPEN_CLASS);
            if (openDropdown) {
                const containerRect = container.getBoundingClientRect();
                const dropdownRect = openDropdown.getBoundingClientRect();
                const dropdownBottom = dropdownRect.bottom;
                const containerBottom = containerRect.bottom;
                // If the dropdown extends beyond the container's visible area, scroll to show it
                if (dropdownBottom > containerBottom) {
                    const scrollAmount = dropdownBottom - containerBottom;
                    container.scrollTo({
                        top: container.scrollTop + scrollAmount,
                        behavior: 'smooth'
                    });
                }
            } else {
                // Called e.g. when the user clicks the "Add mapping" button (and therefore there is no open dropdown)
                const currentHeight = container.scrollHeight;
                const visibleHeight = container.clientHeight;
                const currentScroll = container.scrollTop;
                // Only scroll if content extends beyond current view
                if (currentHeight > visibleHeight + currentScroll) container.scrollTo({
                    top: currentHeight - visibleHeight,
                    behavior: 'smooth'
                });
            }
        }, 0); // Ensure this runs after the dropdown is rendered
    }, []);
    const onSubmit = (0, $42omo.useCallback)(()=>{
        if (!isCreatedWithAi) {
            if (mappingViewRef.current?.validateMappings()) saveUnsavedColumnToFieldMapping();
            else if (isCreatedFromTable) return;
        }
        selectedAvailableSite && setCurrentJiraSite(selectedAvailableSite);
        selectedProject && setCurrentJiraProject(selectedProject);
        selectedIssueType && setCurrentDefaultIssueType(selectedIssueType);
        (0, $2ay9q.saveJiraConfigDetailsToLocalStorage)({
            selectedSite: selectedAvailableSite,
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType
        });
        goToPage('default');
    }, [
        isCreatedWithAi,
        selectedAvailableSite,
        setCurrentJiraSite,
        selectedProject,
        setCurrentJiraProject,
        selectedIssueType,
        setCurrentDefaultIssueType,
        goToPage,
        isCreatedFromTable,
        saveUnsavedColumnToFieldMapping
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        if (currentJiraSite && currentJiraProject && currentDefaultIssueType) resetConfigureState(currentJiraSite, currentJiraProject, currentDefaultIssueType);
        if (!isCreatedWithAi) {
            setUnsavedColumnToFieldMappings(null);
            initUnsavedColumnToFieldMappings();
        }
        setIsJiraError(false);
        goToPage('default');
    }, [
        currentDefaultIssueType,
        currentJiraProject,
        currentJiraSite,
        goToPage,
        resetConfigureState,
        setIsJiraError,
        isCreatedWithAi,
        setUnsavedColumnToFieldMappings,
        initUnsavedColumnToFieldMappings
    ]);
    const isSaveDisabled = isLoading || !selectedAvailableSite || !selectedProject || !selectedIssueType;
    const bulkCreateConfigureBodyText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkCreateConfigureBodyTextIssueTermRefresh : (0, $3E5yu.messages).bulkCreateConfigureBodyText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWrapper), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        xcss: $d923f05cd22225af$var$bulkConfigureViewStyles,
        ref: scrollableContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac64a6e53786764f$export$96d57f6ccda50ec9), {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureHeaderText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), bulkCreateConfigureBodyText)), isJiraError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "bulkCreateErrorSectionMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureJiraErrorTextGalaxia : (0, $3E5yu.messages).bulkConfigureJiraErrorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.300"
    }, (0, $9wGTI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit,
        id: "configureForm"
    }, (0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $445bd7561410e232$export$515237fa9c64c5dc), {
        options: optionsAvailableSites ?? [],
        value: selectedAvailableSite,
        onChange: (site)=>site && setSelectedAvailableSite(site),
        isLoading: isLoading,
        isDisabled: isLoading,
        label: formatMessage((0, $3E5yu.messages).bulkConfigureFormSite)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46689f7fc671df97$export$a764642e4b725728), {
        optionsAllProjects: optionsAllProjects ?? [],
        optionsRecentProjects: optionsRecentProjects ?? [],
        value: selectedProject,
        onChange: (project)=>project && setSelectedProject(project),
        isLoading: isLoading,
        isDisabled: isLoading,
        onInputChange: (query)=>setProjectSelectorQuery(query),
        label: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectGalaxia : (0, $3E5yu.messages).bulkConfigureFormProject),
        labelProjectSelectorRecentProjects: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
        labelProjectSelectorProjects: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52e9bc47e2ec1c07$export$aa04298ab6db90d8), {
        optionsIssueTypes: optionsIssueTypes ?? [],
        value: selectedIssueType,
        onChange: (issueType)=>issueType && setSelectedIssueType(issueType),
        isLoading: isLoading,
        isDisabled: isLoading,
        label: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $445bd7561410e232$export$515237fa9c64c5dc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46689f7fc671df97$export$a764642e4b725728), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52e9bc47e2ec1c07$export$aa04298ab6db90d8), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            id: "configureForm",
            ...formProps
        }, (0, $9wGTI.fg)('jira_ai_decouple_issue_create_fields') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $445bd7561410e232$export$515237fa9c64c5dc), {
            options: optionsAvailableSites ?? [],
            value: selectedAvailableSite,
            onChange: (site)=>site && setSelectedAvailableSite(site),
            isLoading: isLoading,
            isDisabled: isLoading,
            label: formatMessage((0, $3E5yu.messages).bulkConfigureFormSite)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46689f7fc671df97$export$a764642e4b725728), {
            optionsAllProjects: optionsAllProjects ?? [],
            optionsRecentProjects: optionsRecentProjects ?? [],
            value: selectedProject,
            onChange: (project)=>project && setSelectedProject(project),
            isLoading: isLoading,
            isDisabled: isLoading,
            onInputChange: (query)=>setProjectSelectorQuery(query),
            label: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectGalaxia : (0, $3E5yu.messages).bulkConfigureFormProject),
            labelProjectSelectorRecentProjects: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorRecentProjects),
            labelProjectSelectorProjects: formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjectsGalaxia : (0, $3E5yu.messages).bulkConfigureFormProjectSelectorProjects)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52e9bc47e2ec1c07$export$aa04298ab6db90d8), {
            optionsIssueTypes: optionsIssueTypes ?? [],
            value: selectedIssueType,
            onChange: (issueType)=>issueType && setSelectedIssueType(issueType),
            isLoading: isLoading,
            isDisabled: isLoading,
            label: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkConfigureFormDefaultIssueTypeIssueTermRefresh : (0, $3E5yu.messages).bulkConfigureFormDefaultIssueType)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $445bd7561410e232$export$515237fa9c64c5dc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46689f7fc671df97$export$a764642e4b725728), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52e9bc47e2ec1c07$export$aa04298ab6db90d8), null)))), isMissingColumnMappingError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "information",
        title: (0, $3E5yu.messages).bulkConfigureMissingTableCoulumnMappingErrorHeaderText.defaultMessage,
        testId: "bulkCreateWarningSectionMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkConfigureMissingTableCoulumnMappingErrorText)), !isCreatedWithAi && (isCreatedFromTable || !(0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18b3c33293d9759e$export$aab6883e3d0e5f63), {
        ref: mappingViewRef,
        onAutoScrollOnMenuOpen: handleAutoScrollOnMenuOpen
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $37a527a75d28e217$export$a11e7c1ace4beba4), {
        onClose: onClose,
        closePanel: closePanel,
        isSaveDisabled: isSaveDisabled
    }));
};











/**
 * @generated SignedSource<<c1bd31a4f130ce33613666df27efd3ad>>
 * @relayHash d9a50c42bd4eb5ed009db6000aba2ac3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44b73680cb37925a01797244c9097d033e589ecf159e0e9d8efce0662d88e552
const $d1f4ab0a8e07c567$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAIAgentStreamingDataBulkIssueADFQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAIAgentStreamingDataBulkIssueADFQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d9a50c42bd4eb5ed009db6000aba2ac3",
            "id": "44b73680cb37925a01797244c9097d033e589ecf159e0e9d8efce0662d88e552",
            "metadata": {},
            "name": "useAIAgentStreamingDataBulkIssueADFQuery",
            "operationKind": "query",
            "text": "query useAIAgentStreamingDataBulkIssueADFQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{value}}}}"
        }
    };
}();
$d1f4ab0a8e07c567$var$node.hash = "4db4ab1be0ce872d643140ef39690974";
var $d1f4ab0a8e07c567$export$2e2bcd8739ae039 = $d1f4ab0a8e07c567$var$node;






var $kAaxz = parcelRequire("kAaxz");


var $d3UlG = parcelRequire("d3UlG");


var $4sbrV = parcelRequire("4sbrV");


var $7pE6f = parcelRequire("7pE6f");


var $3j1mV = parcelRequire("3j1mV");


var $ep3mz = parcelRequire("ep3mz");





var $jMyy4 = parcelRequire("jMyy4");



















const $ddb2e468e1b4e3e7$var$getSelectedContent = (isCreatedFromActionItems, isCreatedFromTable, selectedActionItems, selectedTable)=>{
    if (isCreatedFromActionItems) return selectedActionItems;
    if (isCreatedFromTable && selectedTable) {
        // Remove the first row from the table to avoid including the header row in the primary text
        const clonedTable = selectedTable.cloneNode(true);
        clonedTable.deleteRow(0);
        return clonedTable;
    }
    return null;
};
const $ddb2e468e1b4e3e7$export$239edaa576654342 = (markdownPlusContent, pageAri, isConvoAIMigrationEnabled, overrideXProduct)=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable, expectedIssueIndices: expectedIssueIndices }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ selectedActionItems: selectedActionItems, selectedTable: selectedTable }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const isUserSelectedCreation = (isCreatedFromActionItems || isCreatedFromTable) && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    return (0, $42omo.useMemo)(()=>{
        const content = $ddb2e468e1b4e3e7$var$getSelectedContent(isCreatedFromActionItems, isCreatedFromTable, selectedActionItems, selectedTable);
        const selectedContentHtml = content?.innerHTML;
        return [
            {
                ai_feature_input: {
                    context: {
                        primary_text: isUserSelectedCreation ? ' ' : markdownPlusContent,
                        ...isUserSelectedCreation ? {
                            highlighted_text: selectedContentHtml
                        } : {},
                        input_mime_type: 'text/markdown',
                        source_ari: pageAri
                    },
                    source: 'CONFLUENCE',
                    locale: locale,
                    suggested_issues_config: {
                        max_issues: isUserSelectedCreation ? expectedIssueIndices.length : 10,
                        suggested_issue_field_types: [
                            {
                                issue_type: 'Task',
                                fields: [
                                    {
                                        field_name: 'Summary',
                                        field_type: 'Short-Text'
                                    },
                                    {
                                        field_name: 'Description',
                                        field_type: 'Paragraph'
                                    }
                                ]
                            }
                        ]
                    },
                    sourceType: 'string'
                }
            },
            {
                apiPath: 'v2/ai-feature/jira/issue/source-type/documentation/suggestions/stream',
                enablePartialJson: false,
                skip: !markdownPlusContent || !isConvoAIMigrationEnabled,
                headers: {
                    'x-experience-id': 'ai-issue-create-confluence-bulk',
                    'x-product': overrideXProduct && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? overrideXProduct : 'confluence'
                }
            }
        ];
    }, [
        isCreatedFromActionItems,
        isCreatedFromTable,
        selectedActionItems,
        selectedTable,
        markdownPlusContent,
        pageAri,
        isConvoAIMigrationEnabled,
        overrideXProduct,
        locale,
        isUserSelectedCreation,
        expectedIssueIndices.length
    ]);
};











const $92dbb54084f9d413$export$97b2d370f34c4fd9 = ()=>{
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable, expectedIssueIndices: expectedIssueIndices, aiState: aiState }, { setBulkIssuesList: setBulkIssuesList }] = (0, $hq2Sz.useBulkCreateContext)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const [markdownPlusContent, setMarkdownPlusContent] = (0, $42omo.useState)('');
    const [pageIdMap, setPageIdMap] = (0, $42omo.useState)(undefined);
    const [currentAiState, setCurrentAiState] = (0, $42omo.useState)((0, $hq2Sz.AiStates).LOADING);
    const { logAiStreamingBackendFailed: logAiStreamingBackendFailed, logAiNoResultsGenerated: logAiNoResultsGenerated, logAiInvalidResultsGenerated: logAiInvalidResultsGenerated } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageId = contentId ?? '';
    const pageType = contentType ?? '';
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, pageId, pageType);
    const isUserSelectedCreation = (isCreatedFromActionItems || isCreatedFromTable) && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    // Used to keep track of the issues that have been added to the list and give a unique id
    const issueIndex = (0, $42omo.useRef)(0);
    const isRefetched = (0, $42omo.useRef)(false);
    const prevAiStateRef = (0, $42omo.useRef)(aiState);
    // Reset internal state when parent sets aiState to loading (e.g., on retry)
    // Using synchronous state update during render to avoid flickering
    if (aiState === (0, $hq2Sz.AiStates).LOADING && prevAiStateRef.current === (0, $hq2Sz.AiStates).ERROR && currentAiState === (0, $hq2Sz.AiStates).ERROR && (0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows')) {
        setCurrentAiState((0, $hq2Sz.AiStates).LOADING);
        setMarkdownPlusContent('');
        setPageIdMap(undefined);
        isRefetched.current = false;
    }
    prevAiStateRef.current = aiState;
    // Needed to convert confluence content into MD+ format for the ai request
    (0, $jMyy4.useQueryInterop)((0, $d1f4ab0a8e07c567$export$2e2bcd8739ae039), {
        variables: {
            contentId: pageId
        },
        onError: (_adfError)=>{
            setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
        },
        fetchPolicy: 'network-only',
        onCompleted: (adfData)=>{
            const adf = adfData?.singleContent?.body?.atlas_doc_format?.value;
            if (adf) try {
                const parsedAdf = JSON.parse(adf);
                const { markdown: markdownPlus, idMap: idMap } = (0, $7pE6f.adfToMarkdownPlus)(parsedAdf);
                // Handle pages that don't have any content
                if (!markdownPlus) {
                    setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    return;
                }
                setMarkdownPlusContent(markdownPlus);
                setPageIdMap(idMap);
            } catch  {
                setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
            }
        },
        skip: currentAiState !== (0, $hq2Sz.AiStates).LOADING,
        __callerPackage__: "@confluence/issue-create-side-panel"
    });
    const [request, config] = (0, $ddb2e468e1b4e3e7$export$239edaa576654342)(markdownPlusContent, pageAri ?? '', true, ...(0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? [
        aiIssueCreationEnablement?.enablement
    ] : []);
    const [{ content: content, responseState: responseState, error: error }, refetch] = (0, $d3UlG.useConvoAIStreaming)(request, config);
    (0, $42omo.useEffect)(()=>{
        if (markdownPlusContent && responseState !== (0, $kAaxz.ConvoAIResponseState).FinalResponse && !isRefetched.current) {
            refetch();
            isRefetched.current = true;
        }
    }, [
        markdownPlusContent,
        responseState,
        refetch
    ]);
    const issues = (0, $42omo.useMemo)(()=>{
        try {
            return content ? JSON.parse(content) : {
                suggested_issues: []
            };
        } catch  {
            return {
                suggested_issues: []
            };
        }
    }, [
        content
    ]);
    (0, $42omo.useEffect)(()=>{
        const getIssueDetails = ()=>{
            return {
                iconUrl: '',
                name: '',
                id: ''
            };
        };
        // Temp add issues until we can handle partial responses
        const addIssues = (issueList)=>{
            let rowIdx = 0;
            const newIssues = issueList.map((issue)=>({
                    rowIndex: isUserSelectedCreation ? expectedIssueIndices[rowIdx++] : undefined,
                    id: String(issueIndex.current++),
                    summary: issue.field_values.Summary,
                    description: (0, $4sbrV.markdownPlusToAdf)({
                        markdown: issue.field_values.Description,
                        idMap: pageIdMap
                    }),
                    issueType: getIssueDetails()
                }));
            setBulkIssuesList(newIssues);
        };
        // Switch statement to handle the different response states
        switch(responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                // Not needed really just want to track all the states
                if ((0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) setCurrentAiState((0, $hq2Sz.AiStates).LOADING);
                setBulkIssuesList([]);
                break;
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                try {
                    if (issues?.suggested_issues?.length === 0) {
                        logAiNoResultsGenerated();
                        setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    } else if (issues?.suggested_issues?.length !== expectedIssueIndices.length && isUserSelectedCreation) {
                        // Unable to create a 1:1 mapping of action items to issues
                        logAiInvalidResultsGenerated();
                        setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    } else {
                        // Setting list when all issues are returned for now, will update to handle partial responses
                        addIssues(issues?.suggested_issues);
                        setCurrentAiState((0, $hq2Sz.AiStates).IDLE);
                    }
                } catch (e) {
                    setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                    logAiStreamingBackendFailed(e);
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                setCurrentAiState((0, $hq2Sz.AiStates).ERROR);
                logAiStreamingBackendFailed(error);
                break;
            default:
                break;
        }
    }, [
        issues,
        pageIdMap,
        responseState,
        issueIndex,
        error,
        content,
        isCreatedFromActionItems,
        isCreatedFromTable,
        expectedIssueIndices,
        isUserSelectedCreation,
        logAiInvalidResultsGenerated,
        logAiStreamingBackendFailed,
        logAiNoResultsGenerated,
        setBulkIssuesList
    ]);
    return {
        currentAiState: currentAiState,
        responseState: responseState
    };
};


const $442da57a5d0af441$export$aeed5882f513d26a = ()=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, { setAiState: setAiState }] = (0, $hq2Sz.useBulkCreateContext)();
    const { currentAiState: currentAiState } = (0, $92dbb54084f9d413$export$97b2d370f34c4fd9)();
    const { isLoading: isLoading } = (0, $CbMiC.useIsConfigureLoading)();
    (0, $42omo.useEffect)(()=>{
        if (currentAiState === (0, $hq2Sz.AiStates).IDLE && isLoading) return;
        setAiState(currentAiState);
    }, [
        currentAiState,
        setAiState,
        isLoading
    ]);
};






var $7aRa9 = parcelRequire("7aRa9");




const $394c97495ccb97e6$var$BulkCreateFlagsContainerComponent = ({ flags: flags })=>{
    const setFlags = (0, $aMxFD.useSetBulkCreateFlagsContainer)();
    (0, $42omo.useEffect)(()=>{
        setFlags(flags);
    }, [
        flags,
        setFlags
    ]);
    return null;
};
const $394c97495ccb97e6$export$faba4facebe8b231 = (0, $7aRa9.withFlags)($394c97495ccb97e6$var$BulkCreateFlagsContainerComponent);

















const $5acf347b59010cba$export$329fec8b4c580586 = ()=>{
    const setIssueTypeFields = (0, $hq2Sz.useSetIssueTypeFields)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const { setOptionsIssueTypeFields: setOptionsIssueTypeFields, setLoadingIssueTypeFields: setLoadingIssueTypeFields, setFieldAllowedValues: setFieldAllowedValues } = (0, $CbMiC.useMappingsActions)();
    (0, $42omo.useEffect)(()=>{
        const fetchIssueMetadata = async ()=>{
            if (!selectedAvailableSite || !selectedProject || !selectedIssueType) return;
            setIsLoading(true);
            setLoadingIssueTypeFields(true);
            try {
                const data = await (0, $k9cgj.fetchIssuesMetadata)({
                    cloudId: selectedAvailableSite.cloudId,
                    projectId: selectedProject.id,
                    issueTypeId: selectedIssueType.id
                });
                const mappingFieldAllowedValues = new Map();
                if (data) {
                    const requiredFields = [];
                    const optionalFields = [];
                    for (const field of data.fields){
                        if (field.required) requiredFields.push(field);
                        else optionalFields.push(field);
                        // Store allowedValues for any field that has them
                        if (field.allowedValues && Array.isArray(field.allowedValues)) mappingFieldAllowedValues.set(field.fieldId, field.allowedValues);
                    }
                    setIssueTypeFields({
                        requiredFields: requiredFields,
                        optionalFields: optionalFields
                    });
                    setOptionsIssueTypeFields([
                        ...requiredFields,
                        ...optionalFields
                    ]);
                    setFieldAllowedValues(mappingFieldAllowedValues);
                }
            } catch (e) {
                if ($5acf347b59010cba$var$isError(e)) setError(e.message);
            } finally{
                setIsLoading(false);
                setLoadingIssueTypeFields(false);
            }
        };
        fetchIssueMetadata();
    }, [
        selectedAvailableSite,
        selectedProject,
        selectedIssueType,
        setIssueTypeFields,
        setOptionsIssueTypeFields,
        setLoadingIssueTypeFields,
        setFieldAllowedValues
    ]);
    return {
        isLoading: isLoading,
        error: error
    };
};
const $5acf347b59010cba$var$isError = (error)=>{
    return error instanceof Error;
};















var $dPJCf = parcelRequire("dPJCf");


























const $ed2929b91c73486c$var$JIRA_SINGLE_ISSUE_LINK_INSERTION = 'jiraSingleIssueLinkInsertion';
const $ed2929b91c73486c$var$JIRA_MULTIPLE_ISSUE_LINK_INSERTION = 'jiraMultipleIssueLinkInsertion';
const $ed2929b91c73486c$export$d58e5870a6e92835 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ currentJiraSite: currentJiraSite, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, singleIssuesCreated: singleIssuesCreated, isCreatedWithAi: isCreatedWithAi, isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable, selectedTableAdf: selectedTableAdf }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ insertMultipleStorageFragmentsRequestPayload: insertMultipleStorageFragmentsRequestPayload, insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload, pageMode: pageMode, hasEditPermission: hasEditPermission, editorAPI: editorAPI }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { columnToFieldMappings: columnToFieldMappings } = (0, $CbMiC.useMappingsState)();
    const { triggerSingleIssueInsertLinkFailureFlag: triggerSingleIssueInsertLinkFailureFlag, triggerMultipleIssuesInsertLinkFailureFlag: triggerMultipleIssuesInsertLinkFailureFlag, triggerMultipleIssuesCreatedFlag: triggerMultipleIssuesCreatedFlag, triggerDocumentModifiedSingleIssueInsertLinkFailureFlag: triggerDocumentModifiedSingleIssueInsertLinkFailureFlag, triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag: triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag } = (0, $9a1f5308e6e530ee$export$89914132e011d9d2)();
    const resetSingleIssuesCreated = (0, $hq2Sz.useResetSingleIssuesCreated)();
    const { logRequestFailed: logRequestFailed, logIssueInsertionFailure: logIssueInsertionFailure } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const headingString = formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).bulkCreateIssueInsertionHeadingIssueTermRefresh : (0, $3E5yu.messages).bulkCreateIssueInsertionHeading);
    const currentUrl = (0, $dPJCf.useRouteDataRef)().current?.href;
    const constructXmlModification = (0, $42omo.useCallback)((createdIssues, insertStorageFragmentRequestPayload)=>{
        const smartlinkTags = (0, $1Q0l6.bulkConstructSmartlinkTags)(createdIssues.map((issue)=>(0, $1Q0l6.constructJiraIssueUrl)(currentJiraSite?.url, issue.key)));
        return insertStorageFragmentRequestPayload?.selectedText !== headingString ? `${(0, $1Q0l6.constructHeading)(headingString)}<br/>${smartlinkTags}` : `<p>${smartlinkTags}</p>`;
    }, [
        currentJiraSite?.url,
        headingString
    ]);
    const constructXmlModifications = (0, $42omo.useCallback)((createdIssues, fragments)=>{
        if ((0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
            const issuesByRowIndex = new Map(createdIssues.filter((issue)=>issue.rowIndex !== undefined).map((issue)=>[
                    String(issue.rowIndex),
                    issue
                ]));
            return fragments.filter((fragment)=>issuesByRowIndex.has(fragment.rowIndex)).map((fragment)=>{
                const issue = issuesByRowIndex.get(fragment.rowIndex);
                return {
                    ...fragment,
                    xmlModification: (0, $1Q0l6.constructBreakContainerTag)((0, $1Q0l6.constructSmartlinkTag)((0, $1Q0l6.constructJiraIssueUrl)(currentJiraSite?.url, issue.key)))
                };
            });
        }
        // TO DO: remove when cleaning up confluence-create-work-items-from-action-items
        const createdIssueRowIds = new Set(createdIssues.map((issue)=>String(issue.rowIndex)));
        return fragments.filter((fragment)=>createdIssueRowIds.has(fragment.rowIndex)).map((fragment, index)=>({
                ...fragment,
                xmlModification: (0, $1Q0l6.constructBreakContainerTag)((0, $1Q0l6.constructSmartlinkTag)((0, $1Q0l6.constructJiraIssueUrl)(currentJiraSite?.url, createdIssues[index].key)))
            }));
    }, [
        currentJiraSite?.url
    ]);
    const constructCellModifications = (0, $42omo.useCallback)((createdIssues)=>{
        return createdIssues.filter((issue)=>issue.rowIndex !== undefined).map((issue)=>{
            const xmlInsertion = (0, $1Q0l6.constructSmartlinkTag)((0, $1Q0l6.constructJiraIssueUrl)(currentJiraSite?.url, issue.key));
            return {
                rowIndex: Number(issue.rowIndex),
                xmlInsertion: xmlInsertion
            };
        });
    }, [
        currentJiraSite?.url
    ]);
    const constructAnchorLinkToHeading = (0, $42omo.useCallback)(()=>{
        const formattedHeading = headingString.split(' ').join('-');
        const [baseUrl, existingHash] = (currentUrl ?? '').split('#');
        return existingHash ? `${baseUrl}#${formattedHeading}` : `${currentUrl}#${formattedHeading}`;
    }, [
        currentUrl,
        headingString
    ]);
    const reloadOnClick = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = constructAnchorLinkToHeading();
        window.location.reload();
    }, [
        constructAnchorLinkToHeading
    ]);
    const isUserSelectedCreation = (isCreatedFromTable || isCreatedFromActionItems) && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const handleInsertionError = (0, $42omo.useCallback)((_error, createdIssues)=>{
        const isDocumentChangedError = _error.message === 'document-changed';
        if (isDocumentChangedError) {
            if (createdIssues.length === 1) triggerDocumentModifiedSingleIssueInsertLinkFailureFlag({
                issueKey: createdIssues[0].key,
                summary: createdIssues[0].summary
            });
            else triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag(createdIssues);
        } else if (createdIssues.length === 1) {
            triggerSingleIssueInsertLinkFailureFlag({
                issueKey: createdIssues[0].key,
                summary: createdIssues[0].summary
            });
            logRequestFailed({
                requestName: $ed2929b91c73486c$var$JIRA_SINGLE_ISSUE_LINK_INSERTION,
                errorMessage: _error.message
            });
        } else {
            triggerMultipleIssuesInsertLinkFailureFlag(createdIssues);
            logRequestFailed({
                requestName: $ed2929b91c73486c$var$JIRA_MULTIPLE_ISSUE_LINK_INSERTION,
                errorMessage: _error.message
            });
        }
        if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) logIssueInsertionFailure(createdIssues.length, _error);
    }, [
        logIssueInsertionFailure,
        logRequestFailed,
        triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag,
        triggerDocumentModifiedSingleIssueInsertLinkFailureFlag,
        triggerMultipleIssuesInsertLinkFailureFlag,
        triggerSingleIssueInsertLinkFailureFlag
    ]);
    const handleStorageInsertion = (0, $42omo.useCallback)((createdIssues, payload)=>{
        let showReloadAction = false;
        (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(payload, pageMode);
        let insertPromise = Promise.resolve(false);
        if (isCreatedWithAi && !isUserSelectedCreation) insertPromise = (0, $1Q0l6.insertContentAtSelectionEnd)(payload);
        else if (isCreatedFromActionItems) insertPromise = (0, $1Q0l6.insertMultipleContentAtSelectionEnd)(payload);
        else if (isCreatedFromTable) {
            const summaryInsertionColumn = (0, $1Q0l6.getSummaryInsertionColumn)(columnToFieldMappings, isCreatedWithAi);
            insertPromise = (0, $1Q0l6.insertWorkItemsIntoTable)({
                createdIssues: createdIssues,
                currentJiraSiteUrl: currentJiraSite?.url,
                pageMode: pageMode,
                selectedTableAdf: selectedTableAdf,
                editorAPI: editorAPI,
                payload: payload,
                summaryInsertionColumn: summaryInsertionColumn
            });
        }
        insertPromise.then((data)=>{
            // There is a case where the API response is OK, but the response data is false.
            // When this happens, the backend has trouble inserting the ticket to the page (likely due to a payload error) and we should show an error toast.
            if (data === false) throw new Error('Failed to insert storage');
        }).then(()=>{
            showReloadAction = (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? pageMode === 'view' : true;
            if (!(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) resetSingleIssuesCreated();
        }).catch((_error)=>{
            handleInsertionError(_error, createdIssues);
        }).finally(()=>{
            if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) resetSingleIssuesCreated();
            triggerMultipleIssuesCreatedFlag(createdIssues, reloadOnClick, showReloadAction);
        });
    }, [
        isCreatedFromActionItems,
        isCreatedFromTable,
        isCreatedWithAi,
        isUserSelectedCreation,
        pageMode,
        reloadOnClick,
        resetSingleIssuesCreated,
        triggerMultipleIssuesCreatedFlag,
        handleInsertionError,
        currentJiraSite?.url,
        editorAPI,
        columnToFieldMappings,
        selectedTableAdf
    ]);
    const addSingleIssuesToPage = (0, $42omo.useCallback)(()=>{
        //If the user doesn't have edit permissions on the page, we shouldn't attempt to insert the issues.
        if (singleIssuesCreated.length > 0 && !hasEditPermission) {
            triggerMultipleIssuesCreatedFlag(singleIssuesCreated, reloadOnClick, false);
            resetSingleIssuesCreated();
        } else if (insertStorageFragmentRequestPayload && isCreatedWithAi && singleIssuesCreated.length > 0) {
            insertStorageFragmentRequestPayload.xmlModification = constructXmlModification(singleIssuesCreated, insertStorageFragmentRequestPayload);
            handleStorageInsertion(singleIssuesCreated, insertStorageFragmentRequestPayload);
        } else if (insertStorageColumnTableRequestPayload && (!isCreatedWithAi || (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) && singleIssuesCreated.length > 0) {
            insertStorageColumnTableRequestPayload.cellModifications = constructCellModifications(singleIssuesCreated);
            handleStorageInsertion(singleIssuesCreated, insertStorageColumnTableRequestPayload);
        } else if (!isCreatedFromTable && isCreatedFromActionItems && singleIssuesCreated.length > 0 && insertMultipleStorageFragmentsRequestPayload && (!isCreatedWithAi || (0, $9wGTI.fg)('confluence-create-work-items-from-action-items'))) handleStorageInsertion(singleIssuesCreated, {
            pageId: insertMultipleStorageFragmentsRequestPayload.pageId,
            lastFetchTime: insertMultipleStorageFragmentsRequestPayload.lastFetchTime,
            fragments: constructXmlModifications(singleIssuesCreated, insertMultipleStorageFragmentsRequestPayload.fragments)
        });
    }, [
        singleIssuesCreated,
        hasEditPermission,
        insertStorageFragmentRequestPayload,
        isCreatedWithAi,
        insertStorageColumnTableRequestPayload,
        isCreatedFromTable,
        isCreatedFromActionItems,
        insertMultipleStorageFragmentsRequestPayload,
        triggerMultipleIssuesCreatedFlag,
        reloadOnClick,
        resetSingleIssuesCreated,
        constructXmlModification,
        handleStorageInsertion,
        constructCellModifications,
        constructXmlModifications
    ]);
    return {
        constructAnchorLinkToHeading: constructAnchorLinkToHeading,
        constructXmlModification: constructXmlModification,
        constructXmlModifications: constructXmlModifications,
        constructCellModifications: constructCellModifications,
        addSingleIssuesToPage: addSingleIssuesToPage
    };
};


const $b087aae42cea54f5$export$fcc44dd45d1185f8 = (onClose)=>{
    const shouldClose = (0, $hq2Sz.useCloseAndAddIssuesToPage)();
    const { addSingleIssuesToPage: addSingleIssuesToPage } = (0, $ed2929b91c73486c$export$d58e5870a6e92835)();
    const resetCloseAndAddIssuesToPage = (0, $hq2Sz.useResetCloseAndAddIssuesToPage)();
    (0, $42omo.useEffect)(()=>{
        if (shouldClose) {
            addSingleIssuesToPage();
            onClose();
            // Reset the state after closing
            resetCloseAndAddIssuesToPage();
        }
    }, [
        shouldClose,
        onClose,
        addSingleIssuesToPage,
        resetCloseAndAddIssuesToPage
    ]);
};














const $fa4d76143b144d29$export$9177fed431f1b8dd = 'fetch-workflow-validators';
const $fa4d76143b144d29$export$5cfa116e87f44d8b = ()=>{
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType } = (0, $hq2Sz.useGetJiraConfig)();
    const setWorkflowValidators = (0, $hq2Sz.useSetWorkflowValidators)();
    (0, $42omo.useEffect)(()=>{
        const cloudId = currentJiraSite?.cloudId;
        const projectId = currentJiraProject?.id;
        const issueTypeId = currentDefaultIssueType?.id;
        if (!cloudId || !projectId || !issueTypeId) return;
        const getValidators = async ()=>{
            try {
                const data = await (0, $k9cgj.fetchWorkflowValidators)({
                    cloudId: cloudId,
                    projectId: projectId,
                    issueTypeId: issueTypeId
                });
                setWorkflowValidators(data ?? null);
            } catch (error) {
                logRequestFailed({
                    requestName: $fa4d76143b144d29$export$9177fed431f1b8dd,
                    errorMessage: error.message
                });
            }
        };
        getValidators();
    }, [
        currentJiraSite,
        currentJiraProject,
        currentDefaultIssueType,
        logRequestFailed,
        setWorkflowValidators
    ]);
};













































var $fYQcF = parcelRequire("fYQcF");


































const $9cfc11ac0e778c90$export$4cc6cce5c43c90e6 = ()=>{
    const errorMessage = (0, $aMxFD.useErrorMessage)();
    if (!errorMessage) return null;
    const { createdCount: createdCount, failedCount: failedCount } = errorMessage;
    const partialCreateErrorMessageText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelIssueCreatePartialErrorMessageIssueTermRefresh : (0, $3E5yu.messages).sidePanelIssueCreatePartialErrorMessage;
    const errorMessageText = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelIssueCreateErrorMessageIssueTermRefresh : (0, $3E5yu.messages).sidePanelIssueCreateErrorMessage;
    const formattedMessage = createdCount !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), partialCreateErrorMessageText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...errorMessageText,
        values: {
            issuesCount: failedCount
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "bulkCreateErrorSectionMessage"
    }, formattedMessage);
};











const $c0b8f909c395e6e3$export$8704aba2771cf253 = [
    'description',
    'issuetype',
    'project',
    'summary',
    'reporter'
];
const $c0b8f909c395e6e3$export$876dfd9141389905 = ()=>{
    const { columnToFieldMappings: columnToFieldMappings, optionsIssueTypeFields: optionsIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    return (0, $42omo.useMemo)(()=>{
        const mappedFieldIds = new Set(columnToFieldMappings?.map((mapping)=>mapping.field?.fieldId).filter((fieldId)=>fieldId !== undefined));
        return (optionsIssueTypeFields ?? []).filter((field)=>field.required && !mappedFieldIds.has(field.fieldId) && !$c0b8f909c395e6e3$export$8704aba2771cf253.includes(field.key));
    }, [
        columnToFieldMappings,
        optionsIssueTypeFields
    ]);
};



var $dAg4H = parcelRequire("dAg4H");





var $2ViZo = parcelRequire("2ViZo");





var $bImpr = parcelRequire("bImpr");


var $5FJ5W = parcelRequire("5FJ5W");


var $aXkRG = parcelRequire("aXkRG");











const $8b7adc462e4351d1$export$48d760b64ec96f11 = ()=>{
    const { columnToFieldMappings: columnToFieldMappings, optionsIssueTypeFields: optionsIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    const workflowValidators = (0, $hq2Sz.useGetWorkflowValidators)();
    return (0, $42omo.useMemo)(()=>{
        if (!workflowValidators || !optionsIssueTypeFields) return [];
        const hasValidators = workflowValidators.some((v)=>v.hasValidators);
        // Check if workFlowValidators.validations,fieldValidations.fields is not empty
        const hasFieldValidations = workflowValidators.some((v)=>v.validations?.some((validation)=>validation.fieldValidations?.some((fv)=>(fv.fields?.length ?? 0) > 0)));
        if (!hasValidators) return [];
        // Since `validations` can legitimately be empty or malformed even when `hasValidators = true`,
        // we rely on the `hasValidators` property to determine if there are any validators.
        if (!hasFieldValidations) return [
            ''
        ];
        const mappedFieldIds = new Set(columnToFieldMappings?.map((mapping)=>mapping.field?.fieldId).filter((fieldId)=>fieldId !== undefined) ?? []);
        const fieldIdToNameMap = new Map(optionsIssueTypeFields.map((field)=>[
                field.fieldId,
                field.name
            ]));
        const requiredFieldIds = workflowValidators.flatMap((validator)=>validator.validations ?? []).flatMap((validation)=>validation.fieldValidations ?? []).flatMap((fieldValidation)=>fieldValidation.fields ?? []);
        // Filter and deduplicate using Set
        const unmappedFieldIds = new Set(requiredFieldIds.filter((fieldId)=>!mappedFieldIds.has(fieldId) && !(0, $c0b8f909c395e6e3$export$8704aba2771cf253).includes(fieldId)));
        // Convert to names and use fieldId as a fallback
        return Array.from(unmappedFieldIds).map((fieldId)=>fieldIdToNameMap.get(fieldId) ?? fieldId);
    }, [
        columnToFieldMappings,
        workflowValidators,
        optionsIssueTypeFields
    ]);
};





















var $2W0qg = parcelRequire("2W0qg");


var $6bJyJ = parcelRequire("6bJyJ");




















var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");


var $1Zr9M = parcelRequire("1Zr9M");




























const $301f3e9a767797da$export$c508f13f509a9be = 'create-bulk-issues';
const $301f3e9a767797da$export$57078a0bf3b22549 = ()=>{
    const [{ currentJiraSite: currentJiraSite }] = (0, $hq2Sz.useBulkCreateContext)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [response, setResponse] = (0, $42omo.useState)(null);
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    const createBulkIssuesHandler = (0, $42omo.useCallback)(async ({ issueBody: issueBody, onComplete: onComplete, onFailure: onFailure, rowIndices: rowIndices })=>{
        if (!currentJiraSite || !currentJiraSite.cloudId) return;
        setLoading(true);
        setResponse(null);
        try {
            const result = await (0, $k9cgj.createBulkIssues)({
                cloudId: currentJiraSite.cloudId,
                issueBody: issueBody
            });
            if (!result) {
                onFailure('Empty response');
                logRequestFailed({
                    requestName: $301f3e9a767797da$export$c508f13f509a9be,
                    errorMessage: 'Failed to create issue: Empty from response call to bulk create'
                });
                setError((0, $hq2Sz.ErrorStates).BULK_CREATION);
            } else {
                if (rowIndices && rowIndices.length > 0) result.issues = (0, $euVTc.updateIssuesWithRowIndex)(result, rowIndices);
                setResponse(result);
                onComplete(result);
            }
        } catch (err) {
            onFailure(err);
            logRequestFailed({
                requestName: $301f3e9a767797da$export$c508f13f509a9be,
                errorMessage: `Failed to create issue ${err.message}`
            });
            setError((0, $hq2Sz.ErrorStates).BULK_CREATION);
        } finally{
            setLoading(false);
        }
    }, [
        currentJiraSite,
        logRequestFailed,
        setError
    ]);
    return {
        createBulkIssuesHandler: createBulkIssuesHandler,
        loading: loading,
        response: response
    };
};


const $4aaacc433cc366e2$export$5836991e34b151c3 = ({ issue: issue, issueType: issueType, project: project })=>{
    const createFields = {
        description: issue.description,
        issuetype: {
            id: issueType.id
        },
        project: {
            id: project.id
        },
        summary: issue.summary,
        ...issue.assigneeUserId && {
            assignee: {
                id: issue.assigneeUserId
            }
        },
        ...issue.parentIssueLink && {
            parent: {
                key: issue.parentIssueLink,
                id: issue.parentIssueLink
            }
        },
        ...issue.labels && {
            labels: issue.labels
        },
        ...issue.parent && {
            parent: {
                key: issue.parent.key,
                id: issue.parent.id
            }
        }
    };
    if (issue.additionalFields) issue.additionalFields.forEach((f)=>{
        createFields[f.field.fieldId] = f.value;
    });
    return createFields;
};


const $c2d3778a4a421c09$export$8af2d18142c8506c = ()=>{
    const [{ bulkIssuesList: bulkIssuesList, currentJiraProject: currentJiraProject }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createBulkIssuesHandler: createBulkIssuesHandler, loading: loading, response: response } = (0, $301f3e9a767797da$export$57078a0bf3b22549)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const setSingleIssuesCreated = (0, $hq2Sz.useSetSingleIssuesCreated)();
    const createIssueHandler = (0, $42omo.useCallback)(async ({ issueId: issueId, onComplete: onComplete, onFailure: onFailure })=>{
        const issue = bulkIssuesList.find((item)=>item.id === issueId);
        if (!issue || !currentJiraProject) return;
        createBulkIssuesHandler({
            issueBody: {
                issueUpdates: [
                    {
                        fields: (0, $4aaacc433cc366e2$export$5836991e34b151c3)({
                            issue: issue,
                            issueType: issueType,
                            project: currentJiraProject
                        })
                    }
                ]
            },
            onComplete: (bulkCreateResponse)=>{
                const result = bulkCreateResponse.issues?.[0];
                if (result) {
                    const issueCreated = {
                        ...result,
                        summary: issue.summary,
                        rowIndex: issue.rowIndex
                    };
                    setSingleIssuesCreated(issueCreated);
                    onComplete(issueCreated);
                }
            },
            onFailure: onFailure
        });
    }, [
        bulkIssuesList,
        currentJiraProject,
        createBulkIssuesHandler,
        issueType,
        setSingleIssuesCreated
    ]);
    return {
        createIssueHandler: createIssueHandler,
        loading: loading,
        response: response
    };
};










const $32fa0430959c80d0$export$adeb5a38caa83ee3 = ({ issueId: issueId })=>{
    const setCurrentIssueId = (0, $hq2Sz.useSetCurrentIssueId)();
    const removeBulkIssue = (0, $hq2Sz.useRemoveBulkIssue)();
    const unmappedRequiredFields = (0, $c0b8f909c395e6e3$export$876dfd9141389905)();
    const hasUnmappedRequiredFields = unmappedRequiredFields.length > 0;
    const { createIssueHandler: createIssueHandler, loading: isCreateLoading } = (0, $c2d3778a4a421c09$export$8af2d18142c8506c)();
    const { triggerSingleIssueCreatedFlag: triggerSingleIssueCreatedFlag } = (0, $9a1f5308e6e530ee$export$89914132e011d9d2)();
    const setErrorMessage = (0, $aMxFD.useSetErrorMessage)();
    const { logCreateSingleIssueClick: logCreateSingleIssueClick, logSingleIssueCreateSuccess: logSingleIssueCreateSuccess, logIssueCreationFailed: logIssueCreationFailed, logSidePanelIssueRemoved: logSidePanelIssueRemoved } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const isCreateDisabled = hasUnmappedRequiredFields || isCreateLoading;
    const onAcceptClick = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setErrorMessage(null);
        let createdIssueId;
        createIssueHandler({
            issueId: issueId,
            onComplete: ({ key: issueKey, summary: summary, id: id })=>{
                logSingleIssueCreateSuccess();
                removeBulkIssue(issueId);
                createdIssueId = id;
                triggerSingleIssueCreatedFlag({
                    issueKey: issueKey,
                    summary: summary
                });
            },
            onFailure: (error)=>{
                logIssueCreationFailed(1, error);
                setErrorMessage({
                    createdCount: 0,
                    failedCount: 1
                });
            }
        });
        logCreateSingleIssueClick(createdIssueId);
    }, [
        issueId,
        removeBulkIssue,
        createIssueHandler,
        triggerSingleIssueCreatedFlag,
        setErrorMessage,
        logCreateSingleIssueClick,
        logSingleIssueCreateSuccess,
        logIssueCreationFailed
    ]);
    const onDiscardClick = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        logSidePanelIssueRemoved();
        setErrorMessage(null);
        removeBulkIssue(issueId);
    }, [
        issueId,
        removeBulkIssue,
        setErrorMessage,
        logSidePanelIssueRemoved
    ]);
    const onEditClick = (0, $42omo.useCallback)(()=>{
        setErrorMessage(null);
        setCurrentIssueId(issueId);
    }, [
        issueId,
        setCurrentIssueId,
        setErrorMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                spacing: "none"
            }),
        isDisabled: isCreateDisabled,
        label: "Accept",
        onClick: onAcceptClick,
        testId: "bulk-create-issue-card-accept-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                spacing: "none"
            }),
        isDisabled: isCreateLoading,
        label: "Discard",
        onClick: onDiscardClick,
        testId: "bulk-create-issue-card-discard-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)",
                spacing: "none"
            }),
        isDisabled: isCreateLoading,
        label: "Edit",
        onClick: onEditClick,
        testId: "bulk-create-issue-card-edit-action"
    }));
};


const $3477a14ae2c81903$var$cardStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'radius.small',
    cursor: 'pointer',
    padding: 'space.100',
    margin: 'space.025'
});
const $3477a14ae2c81903$var$stackStyles = (0, $ecnYn.xcss)({
    minHeight: '80px'
});
const $3477a14ae2c81903$var$issueTypeInlineStyles = (0, $ecnYn.xcss)({
    minHeight: '32px'
});
// temporary component for isolating feature gated changes
// use Pressable directly when cleaning up FG
const $3477a14ae2c81903$var$FlaggedPressableWrapper = ({ children: children, onIssueClick: onIssueClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $3477a14ae2c81903$var$cardStyles,
        onClick: onIssueClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, children);
};
const $3477a14ae2c81903$export$56ffef98c4eef3d4 = ({ issue: { id: issueId, summary: summary, description: description }, issueType: issueType })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const setCurrentIssueId = (0, $hq2Sz.useSetCurrentIssueId)();
    const [showToolBar, setShowToolBar] = (0, $42omo.useState)(false);
    const onIssueClick = (0, $42omo.useCallback)(()=>{
        goToPage('edit_issue');
        setCurrentIssueId(issueId);
    }, [
        goToPage,
        issueId,
        setCurrentIssueId
    ]);
    const onMouseEnter = (0, $42omo.useCallback)(()=>void setShowToolBar(true), [
        setShowToolBar
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>void setShowToolBar(false), [
        setShowToolBar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3477a14ae2c81903$var$FlaggedPressableWrapper, {
        onIssueClick: onIssueClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $3477a14ae2c81903$var$stackStyles,
        space: "space.200",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        maxLines: 2
    }, summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $3477a14ae2c81903$var$issueTypeInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: "xsmall",
        src: issueType.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "medium",
        size: "small"
    }, issueType.name)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
        label: formatMessage((0, $3E5yu.messages).issueCardDescriptionIconLabel),
        color: "var(--ds-icon, #292A2E)",
        testId: "bulk-create-issue-card-description-icon"
    })), showToolBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32fa0430959c80d0$export$adeb5a38caa83ee3), {
        issueId: issueId
    }))));
};


const $832bf07ce05f7f94$var$bodyStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    overflowY: 'auto'
});
const $832bf07ce05f7f94$export$a9383f5eed4e0adc = ()=>{
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const [{ bulkIssuesList: bulkIssuesList, currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, isCreatedFromActionItems: isCreatedFromActionItems, aiResultViewedFiredOnce: aiResultViewedFiredOnce, aiState: aiState, expectedIssueIndices: expectedIssueIndices, error: error, userChoseManualCreation: userChoseManualCreation }, { setAiResultViewedFiredOnce: setAiResultViewedFiredOnce, setIsCreatedWithAi: setIsCreatedWithAi, setAiState: setAiState, setExpectedIssueIndices: setExpectedIssueIndices, setError: setError, setBulkIssuesList: setBulkIssuesList }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission, contentId: contentId, selectedTable: selectedTable, selectedActionItems: selectedActionItems }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { logAiResultViewed: logAiResultViewed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const unmappedRequiredFields = (0, $c0b8f909c395e6e3$export$876dfd9141389905)();
    const hasUnmappedRequiredFields = unmappedRequiredFields.length > 0;
    const unmappedWorkflowValidatorFields = (0, $8b7adc462e4351d1$export$48d760b64ec96f11)();
    const hasUnmappedWorkflowValidatorFields = unmappedWorkflowValidatorFields.length > 0;
    // Sometimes the API will not return the list of required fields despite having workflow validators
    // In this case, we show a more generic error message.
    const hasGenericValidations = hasUnmappedWorkflowValidatorFields && unmappedWorkflowValidatorFields.length === 1 && !unmappedWorkflowValidatorFields[0];
    const [showCreateWithAiToggle, setShowCreateWithAiToggle] = (0, $42omo.useState)(false);
    const setUserChoseManualCreation = (0, $hq2Sz.useSetUserChoseManualCreation)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiLoading = aiState === 'loading';
    const isAiIssueGenerationError = aiState === 'error' && error === (0, $hq2Sz.ErrorStates).ISSUE_GENERATION;
    const issueType = (0, $hq2Sz.useGetIssueType)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId,
        isBulkCreate: true
    });
    (0, $42omo.useEffect)(()=>{
        /*
     * When ConfluenceAI=OFF & JiraAI=ON this component will manually create the issue first until
     * selected site & project info is available to check Jira's AI enablement.  If JiraAI=ON then
     * we can setIsCreatedWithAi to what the user's personal AI enablement to trigger a rerender.
     */ if (aiIssueCreationEnablement?.isEnabled && (isCreatedFromActionItems || isCreatedFromTable) && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
            const issueIndices = (0, $2ViZo.calculateExpectedIssueIndices)(isCreatedFromTable, isCreatedFromActionItems, selectedTable, selectedActionItems);
            setExpectedIssueIndices(issueIndices);
            setShowCreateWithAiToggle(true);
            // Keep toggle unchecked despite enablement if user chose manual creation
            if (userChoseManualCreation && (0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows')) {
                setIsCreatedWithAi(false);
                setAiState('idle');
            } else {
                // We can only create 1-10 issues with AI at a time
                const newIsCreatedWithAi = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)() && issueIndices.length > 0 && issueIndices.length <= 10;
                setIsCreatedWithAi(newIsCreatedWithAi);
                if (!newIsCreatedWithAi) setAiState('idle');
            }
        } else setShowCreateWithAiToggle(false);
    }, [
        isCreatedFromActionItems,
        isCreatedFromTable,
        aiIssueCreationEnablement?.isEnabled,
        setIsCreatedWithAi,
        setAiState,
        setExpectedIssueIndices,
        selectedTable,
        selectedActionItems,
        userChoseManualCreation
    ]);
    const onConfigureClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        goToPage('configure');
    }, [
        goToPage
    ]);
    (0, $42omo.useEffect)(()=>{
        // TODO: Change this before rolling out confluence_ai_bulk_issue_creation_handle_chunks.
        if (isCreatedWithAi && bulkIssuesList.length > 0 && !aiResultViewedFiredOnce) {
            logAiResultViewed(bulkIssuesList.length);
            setAiResultViewedFiredOnce(true);
        }
    }, [
        isCreatedWithAi,
        bulkIssuesList,
        logAiResultViewed,
        aiResultViewedFiredOnce,
        setAiResultViewedFiredOnce
    ]);
    const resetIssueCreationErrorStates = (0, $42omo.useCallback)((manualCreationChosen)=>{
        setError((0, $hq2Sz.ErrorStates).EMPTY);
        setBulkIssuesList([]);
        setUserChoseManualCreation(manualCreationChosen);
    }, [
        setError,
        setBulkIssuesList,
        setUserChoseManualCreation
    ]);
    const handleCreateManually = (0, $42omo.useCallback)((afterIssueCreationError = false)=>{
        if (afterIssueCreationError) resetIssueCreationErrorStates(true);
        setIsCreatedWithAi(false);
        setAiState('idle');
        setShowCreateWithAiToggle(false);
    }, [
        setIsCreatedWithAi,
        setAiState,
        resetIssueCreationErrorStates
    ]);
    const handleCreateWithAi = (0, $42omo.useCallback)((afterIssueCreationError = false)=>{
        if (afterIssueCreationError) resetIssueCreationErrorStates(false);
        setIsCreatedWithAi(true);
        setAiState('loading');
        setShowCreateWithAiToggle(false);
    }, [
        setIsCreatedWithAi,
        setAiState,
        resetIssueCreationErrorStates
    ]);
    const onAiToggleChange = (0, $42omo.useCallback)((enabled)=>{
        if (enabled) {
            trackAIInteractionInit({
                attributes: {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            });
            handleCreateWithAi();
        } else handleCreateManually();
    }, [
        handleCreateWithAi,
        handleCreateManually,
        pageMode,
        hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        trackAIInteractionInit
    ]);
    const creationContext = ()=>{
        if (isCreatedFromTable) return 'table';
        if (isCreatedFromActionItems) return 'list';
        return 'other';
    };
    const manualCreationDisabled = bulkIssuesList.length > 50;
    const aiCreationDisabled = expectedIssueIndices.length > 10;
    if ((0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows')) {
        // Early return to display loading screen. Nothing else should be displayed until the loading state is complete.
        if (isAiLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.200",
            paddingBlockStart: "space.100",
            xcss: $832bf07ce05f7f94$var$bodyStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FJ5W.IssueCreateAiLoading), {
            loadingType: "bulk"
        })));
        // Early return to display "try again" error screen
        if (isAiIssueGenerationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXkRG.WorkItemCreationError), {
            creationSource: (0, $26Yin.BULK_ISSUE_CREATE_SOURCE),
            errorMessage: (0, $hq2Sz.ErrorMessageMap)[error](),
            onTryAgain: ()=>handleCreateWithAi(true),
            onCreateManually: ()=>handleCreateManually(true),
            isCreatedWithAi: true
        });
        const showConfigAndCards = !!currentJiraSite && !!currentJiraProject && bulkIssuesList.length > 0;
        // AI bulk creation is disabled if there are more than 10 issues in the selection
        // The user workaround is to create the issues manually, or delete items from the table or action item list
        // Approving or deleting items individually will not work, as we cannot create AI issues using incomplete portions of the selected content
        const aiLimitWarningMessage = showCreateWithAiToggle && aiCreationDisabled && !manualCreationDisabled && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: (0, $3E5yu.messages).moreThanTenAIWorkItemsSectionMessageTitle.defaultMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $3E5yu.messages).moreThanTenAIWorkItemsSectionMessageDescription,
            values: {
                context: creationContext()
            }
        }))) : null;
        const aiToggle = showCreateWithAiToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
            onChange: onAiToggleChange,
            isDisabled: expectedIssueIndices.length > 10 && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')
        }) : null;
        const jiraSiteInfo = showConfigAndCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            weight: "semibold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).jiraSiteHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest"
        }, currentJiraSite.displayName)) : null;
        const jiraProjectInfo = showConfigAndCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            weight: "semibold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).jiraProjectHeadingGalaxia : (0, $3E5yu.messages).jiraProjectHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest"
        }, currentJiraProject.name)) : null;
        const configureButton = showConfigAndCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            spacing: "compact",
            testId: "bulk-create-configure-button",
            onClick: onConfigureClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateConfigureButtonText))) : null;
        const requiredFieldsWarning = hasUnmappedRequiredFields ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: (0, $3E5yu.messages).requiredFieldsSectionMessageTitle.defaultMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).requiredFieldsSectionMessageDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).requiredFieldsSectionMessageDescription))) : null;
        const workflowValidatorFieldsWarning = hasUnmappedWorkflowValidatorFields && !hasUnmappedRequiredFields ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: (0, $3E5yu.messages).workflowValidatorFieldsSectionMessageTitle.defaultMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, hasGenericValidations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).requiredFieldsSectionMessageDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).workflowValidatorFieldsSectionMessageDescriptionIssueTermRefresh)), !hasGenericValidations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "ul"
        }, unmappedWorkflowValidatorFields.map((fieldName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                as: "li",
                key: fieldName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, fieldName)))))) : null;
        const manualCreationLimitWarning = (isCreatedFromTable || isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) && manualCreationDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            title: (0, $3E5yu.messages).moreThanFiftyWorkItemsSectionMessageTitle.defaultMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $3E5yu.messages).moreThanFiftyWorkItemsSectionMessageDescription,
            values: {
                context: creationContext()
            }
        }))) : null;
        const issueCards = showConfigAndCards ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, bulkIssuesList.map((issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3477a14ae2c81903$export$56ffef98c4eef3d4), {
                key: issue.id,
                issue: issue,
                issueType: issueType
            }))) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.200",
            paddingBlockStart: "space.100",
            xcss: $832bf07ce05f7f94$var$bodyStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, aiLimitWarningMessage, aiToggle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cfc11ac0e778c90$export$4cc6cce5c43c90e6), null), jiraSiteInfo, jiraProjectInfo, configureButton, requiredFieldsWarning, workflowValidatorFieldsWarning, manualCreationLimitWarning), issueCards));
    }
    // Old implementation - remove when cleaning up confluence-ai-jira-work-create-fast-follows
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        paddingBlockStart: "space.100",
        xcss: $832bf07ce05f7f94$var$bodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.200"
    }, !isAiLoading && showCreateWithAiToggle && aiCreationDisabled && !manualCreationDisabled && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: (0, $3E5yu.messages).moreThanTenAIWorkItemsSectionMessageTitle.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $3E5yu.messages).moreThanTenAIWorkItemsSectionMessageDescription,
        values: {
            context: creationContext()
        }
    }))), !isAiLoading && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange,
        // AI creation is disabled if there are more than 10 issues in the selection
        isDisabled: expectedIssueIndices.length > 10 && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')
    }), isAiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FJ5W.IssueCreateAiLoading), {
        loadingType: "bulk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cfc11ac0e778c90$export$4cc6cce5c43c90e6), null), currentJiraSite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).jiraSiteHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, currentJiraSite.displayName)), currentJiraProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).jiraProjectHeadingGalaxia : (0, $3E5yu.messages).jiraProjectHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, currentJiraProject.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        spacing: "compact",
        testId: "bulk-create-configure-button",
        onClick: onConfigureClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateConfigureButtonText))), hasUnmappedRequiredFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: (0, $3E5yu.messages).requiredFieldsSectionMessageTitle.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).requiredFieldsSectionMessageDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).requiredFieldsSectionMessageDescription))), hasUnmappedWorkflowValidatorFields && !hasUnmappedRequiredFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: (0, $3E5yu.messages).workflowValidatorFieldsSectionMessageTitle.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, hasGenericValidations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).requiredFieldsSectionMessageDescriptionIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).workflowValidatorFieldsSectionMessageDescriptionIssueTermRefresh)), !hasGenericValidations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "ul"
    }, unmappedWorkflowValidatorFields.map((fieldName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "li",
            key: fieldName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, fieldName)))))), (isCreatedFromTable || isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) && manualCreationDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: (0, $3E5yu.messages).moreThanFiftyWorkItemsSectionMessageTitle.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $3E5yu.messages).moreThanFiftyWorkItemsSectionMessageDescription,
        values: {
            context: creationContext()
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, bulkIssuesList.map((issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3477a14ae2c81903$export$56ffef98c4eef3d4), {
            key: issue.id,
            issue: issue,
            issueType: issueType
        })))));
};



























var $lAFHW = parcelRequire("lAFHW");







const $ea94463cb9b948e3$var$headerStyles = (0, $ecnYn.xcss)({
    flexShrink: 0
});
const $ea94463cb9b948e3$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $ea94463cb9b948e3$export$fe6406b062c20dac = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.200",
        paddingBlockEnd: "space.100",
        paddingInlineStart: "space.300",
        xcss: $ea94463cb9b948e3$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ea94463cb9b948e3$var$headerMessageStyle
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateHeaderTextIssueTermRefresh) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateHeaderText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: "close-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: onClose,
        testId: "close-issue-create-panel-button"
    })));
};




















































const $7387aac0bbb24193$export$e714d12ec594ed0a = ()=>{
    const [{ bulkIssuesList: bulkIssuesList, currentJiraProject: currentJiraProject }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createBulkIssuesHandler: createBulkIssuesHandler, loading: loading, response: response } = (0, $301f3e9a767797da$export$57078a0bf3b22549)();
    const issueType = (0, $hq2Sz.useGetIssueType)();
    const createAllIssuesHandler = (0, $42omo.useCallback)(async ({ onComplete: onComplete, onFailure: onFailure })=>{
        if (!currentJiraProject || bulkIssuesList.length === 0) return;
        const issueUpdates = bulkIssuesList.map((issue)=>({
                fields: (0, $4aaacc433cc366e2$export$5836991e34b151c3)({
                    issue: issue,
                    issueType: issueType,
                    project: currentJiraProject
                })
            }));
        const rowIndices = bulkIssuesList.filter((issue)=>issue.rowIndex !== undefined).map((issue)=>Number(issue.rowIndex));
        createBulkIssuesHandler({
            issueBody: {
                issueUpdates: issueUpdates
            },
            onComplete: ({ issues: createdIssues, errors: failedIssuesResponse })=>{
                const failedIssueIDs = failedIssuesResponse.map((errorItem)=>bulkIssuesList?.[errorItem.failedElementNumber]?.id);
                const createdIssueIDs = bulkIssuesList.filter((issue)=>!failedIssueIDs.includes(issue.id)).map((issue)=>issue.id);
                onComplete({
                    createdIssueIDs: createdIssueIDs,
                    createdIssues: createdIssues,
                    failedIssueIDs: failedIssueIDs
                });
            },
            onFailure: onFailure,
            rowIndices: rowIndices
        });
    }, [
        currentJiraProject,
        bulkIssuesList,
        createBulkIssuesHandler,
        issueType
    ]);
    return {
        createAllIssuesHandler: createAllIssuesHandler,
        loading: loading,
        response: response
    };
};
























const $2fd9480bca9d7e8f$var$buttonGroupStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050'
});
const $2fd9480bca9d7e8f$export$1926ccc813f04882 = ({ onClose: onClose, onCreateAll: onCreateAll })=>{
    const { createAllIssuesHandler: createAllIssuesHandler, loading: isCreateAllLoading } = (0, $7387aac0bbb24193$export$e714d12ec594ed0a)();
    const [{ currentJiraSite: currentJiraSite, bulkIssuesList: bulkIssuesList, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, singleIssuesCreated: singleIssuesCreated, selectedTableAdf: selectedTableAdf, isCreatedWithAi: isCreatedWithAi, isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }, { removeBulkIssueList: removeBulkIssueList }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ insertMultipleStorageFragmentsRequestPayload: insertMultipleStorageFragmentsRequestPayload, insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload, pageMode: pageMode, hasEditPermission: hasEditPermission, editorAPI: editorAPI }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { triggerMultipleIssuesCreatedFlag: triggerMultipleIssuesCreatedFlag, triggerSingleIssueInsertLinkFailureFlag: triggerSingleIssueInsertLinkFailureFlag, triggerMultipleIssuesInsertLinkFailureFlag: triggerMultipleIssuesInsertLinkFailureFlag, triggerDocumentModifiedSingleIssueInsertLinkFailureFlag: triggerDocumentModifiedSingleIssueInsertLinkFailureFlag, triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag: triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag } = (0, $9a1f5308e6e530ee$export$89914132e011d9d2)();
    const { columnToFieldMappings: columnToFieldMappings } = (0, $CbMiC.useMappingsState)();
    const setErrorMessage = (0, $aMxFD.useSetErrorMessage)();
    const { logCreateAllClick: logCreateAllClick, logMultipleIssueCreateSuccess: logMultipleIssueCreateSuccess, logIssueCreationFailed: logIssueCreationFailed, logIssueInsertionFailure: logIssueInsertionFailure } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { constructAnchorLinkToHeading: constructAnchorLinkToHeading, constructXmlModification: constructXmlModification, constructXmlModifications: constructXmlModifications, constructCellModifications: constructCellModifications } = (0, $ed2929b91c73486c$export$d58e5870a6e92835)();
    const resetSingleIssuesCreated = (0, $hq2Sz.useResetSingleIssuesCreated)();
    const reloadOnClick = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = constructAnchorLinkToHeading();
        window.location.reload();
    }, [
        constructAnchorLinkToHeading
    ]);
    const unmappedRequiredFields = (0, $c0b8f909c395e6e3$export$876dfd9141389905)();
    const hasUnmappedRequiredFields = unmappedRequiredFields.length > 0;
    const unmappedWorkflowValidatorFields = (0, $8b7adc462e4351d1$export$48d760b64ec96f11)();
    const hasUnmappedWorkflowValidatorFields = unmappedWorkflowValidatorFields.length > 0;
    const isCreateAllDisabled = bulkIssuesList.length === 0 || hasUnmappedRequiredFields || hasUnmappedWorkflowValidatorFields || (isCreatedFromTable || isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) && bulkIssuesList.length > 50;
    const handleInsertionError = (0, $42omo.useCallback)((_error, createdIssues)=>{
        const isDocumentChangedError = _error?.message === 'document-changed';
        if (isDocumentChangedError) {
            if (createdIssues.length === 1) triggerDocumentModifiedSingleIssueInsertLinkFailureFlag({
                issueKey: createdIssues[0].key,
                summary: createdIssues[0].summary
            });
            else triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag(createdIssues);
        } else if (createdIssues.length === 1) triggerSingleIssueInsertLinkFailureFlag({
            issueKey: createdIssues[0].key,
            summary: createdIssues[0].summary
        });
        else triggerMultipleIssuesInsertLinkFailureFlag(createdIssues);
        if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) logIssueInsertionFailure(createdIssues.length, _error);
    }, [
        logIssueInsertionFailure,
        triggerDocumentModifiedMultipleIssuesInsertLinkFailureFlag,
        triggerDocumentModifiedSingleIssueInsertLinkFailureFlag,
        triggerMultipleIssuesInsertLinkFailureFlag,
        triggerSingleIssueInsertLinkFailureFlag
    ]);
    const handleStorageInsertion = (0, $42omo.useCallback)((createdIssues, payload)=>{
        let showReloadAction = false;
        (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(payload, pageMode);
        let insertPromise = Promise.resolve(false);
        // insert content at selection end if the user uses AI creation without selecting any content
        if (isCreatedWithAi && (!isCreatedFromTable && !isCreatedFromActionItems || !(0, $9wGTI.fg)('confluence-create-work-items-from-action-items'))) insertPromise = (0, $1Q0l6.insertContentAtSelectionEnd)(payload);
        else if (isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) insertPromise = (0, $1Q0l6.insertMultipleContentAtSelectionEnd)(payload);
        else if (isCreatedFromTable) {
            const summaryInsertionColumn = (0, $1Q0l6.getSummaryInsertionColumn)(columnToFieldMappings, isCreatedWithAi);
            insertPromise = (0, $1Q0l6.insertWorkItemsIntoTable)({
                createdIssues: createdIssues,
                currentJiraSiteUrl: currentJiraSite?.url,
                pageMode: pageMode,
                selectedTableAdf: selectedTableAdf,
                editorAPI: editorAPI,
                payload: payload,
                summaryInsertionColumn: summaryInsertionColumn
            });
        }
        insertPromise.then((data)=>{
            // There is a case where the API response is OK, but the response data is false.
            // When this happens, the backend has trouble inserting the ticket to the page (likely due to a payload error) and we should show an error toast.
            if (data === false) throw new Error('Failed to insert storage');
        }).then(()=>{
            showReloadAction = (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? pageMode === 'view' : true;
        }).catch((_error)=>{
            handleInsertionError(_error, createdIssues);
        }).finally(()=>{
            if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) resetSingleIssuesCreated();
            triggerMultipleIssuesCreatedFlag(createdIssues, reloadOnClick, showReloadAction);
        });
    }, [
        isCreatedFromActionItems,
        isCreatedFromTable,
        isCreatedWithAi,
        pageMode,
        reloadOnClick,
        triggerMultipleIssuesCreatedFlag,
        selectedTableAdf,
        currentJiraSite?.url,
        editorAPI,
        columnToFieldMappings,
        resetSingleIssuesCreated,
        handleInsertionError
    ]);
    const onCreateAllClick = (0, $42omo.useCallback)(()=>{
        logCreateAllClick();
        setErrorMessage(null);
        createAllIssuesHandler({
            onComplete: ({ createdIssues: createdIssues, createdIssueIDs: createdIssueIDs, failedIssueIDs: failedIssueIDs })=>{
                logMultipleIssueCreateSuccess(createdIssueIDs.length);
                if (isCreatedWithAi && insertStorageFragmentRequestPayload && hasEditPermission) {
                    insertStorageFragmentRequestPayload.xmlModification = constructXmlModification([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ], insertStorageFragmentRequestPayload);
                    handleStorageInsertion([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ], insertStorageFragmentRequestPayload);
                } else if ((!isCreatedWithAi || (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) && isCreatedFromTable && insertStorageColumnTableRequestPayload && hasEditPermission) {
                    insertStorageColumnTableRequestPayload.cellModifications = constructCellModifications([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ]);
                    handleStorageInsertion([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ], insertStorageColumnTableRequestPayload);
                } else if (!isCreatedFromTable && isCreatedFromActionItems && insertMultipleStorageFragmentsRequestPayload && hasEditPermission && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) handleStorageInsertion([
                    ...createdIssues,
                    ...singleIssuesCreated
                ], {
                    pageId: insertMultipleStorageFragmentsRequestPayload.pageId,
                    lastFetchTime: insertMultipleStorageFragmentsRequestPayload.lastFetchTime,
                    fragments: constructXmlModifications([
                        ...createdIssues,
                        ...singleIssuesCreated
                    ], insertMultipleStorageFragmentsRequestPayload.fragments)
                });
                else triggerMultipleIssuesCreatedFlag([
                    ...createdIssues,
                    ...singleIssuesCreated
                ], reloadOnClick, false);
                removeBulkIssueList(createdIssueIDs);
                if (failedIssueIDs.length !== 0) {
                    logIssueCreationFailed(failedIssueIDs.length);
                    setErrorMessage({
                        createdCount: createdIssueIDs.length,
                        failedCount: failedIssueIDs.length
                    });
                } else onCreateAll();
            },
            onFailure: (error)=>{
                logIssueCreationFailed(bulkIssuesList.length, error);
                setErrorMessage({
                    createdCount: 0,
                    failedCount: bulkIssuesList.length
                });
            }
        });
    }, [
        logCreateAllClick,
        setErrorMessage,
        createAllIssuesHandler,
        logMultipleIssueCreateSuccess,
        hasEditPermission,
        isCreatedFromActionItems,
        insertMultipleStorageFragmentsRequestPayload,
        insertStorageColumnTableRequestPayload,
        isCreatedWithAi,
        insertStorageFragmentRequestPayload,
        isCreatedFromTable,
        removeBulkIssueList,
        constructXmlModification,
        singleIssuesCreated,
        handleStorageInsertion,
        constructCellModifications,
        constructXmlModifications,
        triggerMultipleIssuesCreatedFlag,
        reloadOnClick,
        logIssueCreationFailed,
        onCreateAll,
        bulkIssuesList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        xcss: $2fd9480bca9d7e8f$var$buttonGroupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "bulk-create-button-group-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateCancelFooterButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: isCreateAllDisabled,
        isLoading: isCreateAllLoading,
        onClick: onCreateAllClick,
        testId: "bulk-create-button-group-create-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3E5yu.messages).bulkCreateCreateAllFooterButton)));
};



var $74xbC = parcelRequire("74xbC");

const $f2e2bf93bb67f77b$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    flexShrink: 0,
    position: 'relative',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $f2e2bf93bb67f77b$var$footerTopStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $f2e2bf93bb67f77b$var$AI_BULK_CREATE_FEEDBACK_ENTRYPOINT_ID = 'bfca508d-e2bb-4436-a060-3fa27bdce78f';
const $f2e2bf93bb67f77b$export$68f1231a891ae47c = ({ onClose: onClose, onCreateAll: onCreateAll })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $f2e2bf93bb67f77b$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $f2e2bf93bb67f77b$var$footerTopStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId ?? '',
        entrypointId: $f2e2bf93bb67f77b$var$AI_BULK_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2fd9480bca9d7e8f$export$1926ccc813f04882), {
        onClose: onClose,
        onCreateAll: onCreateAll
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiixe.AiSubFooter), null));
};



















var $1uJpg = parcelRequire("1uJpg");

const $e31d70bedca4a367$var$contentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap'
});
const $e31d70bedca4a367$export$94a6c19356438095 = ({ onClose: onClose })=>{
    const { logCancelAiPanel: logCancelAiPanel } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { addSingleIssuesToPage: addSingleIssuesToPage } = (0, $ed2929b91c73486c$export$d58e5870a6e92835)();
    const [{ aiState: aiState, error: error }, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const onPanelClose = (0, $42omo.useCallback)(()=>{
        logCancelAiPanel();
        addSingleIssuesToPage();
        /*
    	Once the confluence-bulk-work-create-editor experiment is enabled we'll be resetting
    	the bulk create state in BulkCreateSidePanel's handleOnClose method instead of here.
    	We should clean up this code when cleaning up the experiment.
    */ if (!(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) actions.resetAIBulkCreateState();
        onClose();
    }, [
        logCancelAiPanel,
        onClose,
        addSingleIssuesToPage,
        actions
    ]);
    const isLoading = aiState === (0, $hq2Sz.AiStates).LOADING;
    const isError = error !== (0, $hq2Sz.ErrorStates).EMPTY;
    const isAiIssueGenerationError = error === (0, $hq2Sz.ErrorStates).ISSUE_GENERATION;
    const isComplete = !isLoading && !isError;
    // When gate is ON: show error screen if not loading & error is not with AI issue generation
    // When gate is OFF: all errors shown here
    // Will rename variable during FG cleanup - logic currently differs between fg ON and OFF
    const shouldShowError = isError && ((0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows') ? !isLoading && !isAiIssueGenerationError : true);
    // When gate is ON: show BulkCreateBody if not loading & error screen is not shown
    // We separate the logic for showing the body and footer as we do not want to show the footer if the
    // AI issue generation error is shown, even though the body is shown.
    // When gate is OFF: only show BulkCreateBody if not loading & there is no error
    // Will rename variable during FG cleanup - logic currently differs between fg ON and OFF
    const shouldShowBody = (0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows') ? !isLoading && !shouldShowError : isComplete;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $e31d70bedca4a367$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea94463cb9b948e3$export$fe6406b062c20dac), {
        onClose: onPanelClose
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FJ5W.IssueCreateAiLoading), {
        loadingType: "bulk"
    }), shouldShowError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: (0, $26Yin.BULK_ISSUE_CREATE_SOURCE),
        errorMessage: (0, $hq2Sz.ErrorMessageMap)[error](),
        isCreatedWithAi: true
    }), shouldShowBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $832bf07ce05f7f94$export$a9383f5eed4e0adc), null), isComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2e2bf93bb67f77b$export$68f1231a891ae47c), {
        onClose: onPanelClose,
        onCreateAll: onClose
    }))));
};


const $74a1b2d516d51f88$export$7d780be885e5d51a = ({ onClose: onClose })=>{
    const { logAiInteractionInitiated: logAiInteractionInitiated } = (0, $26Yin.useBulkCreateLoggingEvents)();
    (0, $5acf347b59010cba$export$329fec8b4c580586)();
    (0, $fa4d76143b144d29$export$5cfa116e87f44d8b)();
    (0, $42omo.useEffect)(()=>{
        logAiInteractionInitiated();
    }, [
        logAiInteractionInitiated
    ]);
    (0, $442da57a5d0af441$export$aeed5882f513d26a)();
    (0, $b087aae42cea54f5$export$fcc44dd45d1185f8)(onClose);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e31d70bedca4a367$export$94a6c19356438095), {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d923f05cd22225af$export$ee2807e678386f7a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6b2e07d107802c1$export$bfc1d0fcda79c38d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $394c97495ccb97e6$export$faba4facebe8b231), null));
};














const $a7c6d6705668316e$export$8415879aba634d17 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hq2Sz.BulkCreateContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aMxFD.AiBulkNavigationContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CbMiC.BulkConfigureContextContainer), null, children)));
};















var $g5o3i = parcelRequire("g5o3i");






















const $5d10bb9dbc732385$export$eb7aae190047eab2 = ()=>{
    const { setSelectedAvailableSite: setSelectedAvailableSite, setOptionsAvailableSites: setOptionsAvailableSites } = (0, $CbMiC.useAvailableSitesActions)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { cloudId: sessionCloudId } = (0, $bQm3c.useSessionData)();
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    // Use the persisted cloudId preference if available, otherwise fall back to the current
    // Confluence session cloudId. Note: sessionCloudId is the Confluence site's cloud ID and
    // may not have a Jira license — the onComplete callback validates this against available
    // Jira sites and falls back to the first valid Jira site if needed.
    const overrideCloudIdForSitePicker = persistedOverrideCloudId || sessionCloudId;
    const { logRequestFailed: logRequestFailed, logDefaultJiraSiteNotFound: logDefaultJiraSiteNotFound } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setCurrentJiraSite = (0, $hq2Sz.useSetCurrentJiraSite)();
    const setError = (0, $hq2Sz.useSetError)();
    const setManualCreateState = (0, $hq2Sz.useSetManualCreateState)();
    const selectedAvailableSiteRef = (0, $42omo.useRef)(selectedAvailableSite);
    selectedAvailableSiteRef.current = selectedAvailableSite;
    (0, $g5o3i.useGetFirstAvailableSiteDomain)({
        preferredCloudId: overrideCloudIdForSitePicker,
        onComplete: (0, $42omo.useCallback)(({ availableSites: availableSites })=>{
            if (availableSites.length === 0 && (0, $6mKj3.expVal)('confluence-jwc-remove-sites-without-jira-exp', 'isEnabled', false)) {
                logRequestFailed({
                    requestName: 'fetch-jira-site',
                    errorMessage: 'No available Jira sites'
                });
                setError((0, $hq2Sz.ErrorStates).SITE_RETRIEVAL);
                setManualCreateState('error');
                return;
            }
            const firstSite = availableSites[0];
            const preferredSite = availableSites.find((site)=>site.cloudId === overrideCloudIdForSitePicker);
            // If the preferred cloudId (persisted or session) is not found in the list of
            // Jira-licensed sites, clear the persisted preference so it is not reused on
            // subsequent opens, and fall back to the first available Jira site.
            if (!preferredSite) {
                logDefaultJiraSiteNotFound({
                    persistedCloudId: persistedOverrideCloudId,
                    fallbackCloudId: firstSite?.cloudId
                });
                if (persistedOverrideCloudId && (0, $6mKj3.expVal)('confluence-jwc-remove-sites-without-jira-exp', 'isEnabled', false)) (0, $2ay9q.clearPersistedOverrideCloudId)();
            }
            const newSite = preferredSite || firstSite;
            // Only update the selected site if it has changed to avoid resetting downstream selections
            if (selectedAvailableSiteRef.current?.cloudId !== newSite?.cloudId || !(0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
                // selectedAvailableSite (from BulkConfigureContext) is the "draft" site in the configure view,
                // whereas currentJiraSite (from BulkCreateContext) is the "confirmed" site displayed on the panel.
                // This hook was originally scoped to BulkConfigureContext only, and the selectedAvailableSite/currentJiraSite
                // sync was mainly handled in the BulkConfigureView component. There is also a selectedAvailableSite/currentJiraSite sync
                // when the panel is initially opened and currentJiraSite has not been set yet (useGetInitialDataForBulkIssueCreateForm).
                // If the previous site is no longer valid, we need to update the currentJiraSite in addition to the selectedAvailableSite.
                // Since the state change in useGetInitialDataForBulkIssueCreateForm only happens when the panel is initially opened,
                // we need to update the currentJiraSite here.
                setSelectedAvailableSite(newSite);
                if ((0, $6mKj3.expVal)('confluence-jwc-remove-sites-without-jira-exp', 'isEnabled', false)) setCurrentJiraSite(newSite);
            }
            setOptionsAvailableSites(availableSites);
        }, [
            setSelectedAvailableSite,
            setOptionsAvailableSites,
            setCurrentJiraSite,
            overrideCloudIdForSitePicker,
            persistedOverrideCloudId,
            logDefaultJiraSiteNotFound,
            logRequestFailed,
            setError,
            setManualCreateState
        ]),
        onError: (0, $42omo.useCallback)((error)=>{
            logRequestFailed({
                requestName: 'fetch-jira-site',
                errorMessage: error.message
            });
            setError((0, $hq2Sz.ErrorStates).SITE_RETRIEVAL);
            setManualCreateState('error');
        }, [
            logRequestFailed,
            setError,
            setManualCreateState
        ])
    });
};

















const $3fb376e27e7792bc$export$423c192d1714471e = 'fetch-jira-projects';
const $3fb376e27e7792bc$export$903912d141558556 = 'fetch-recent-jira-projects';
const $3fb376e27e7792bc$export$beaf2a819f4720da = ()=>{
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    const setManualCreateState = (0, $hq2Sz.useSetManualCreateState)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { setSelectedProjectIfEmpty: setSelectedProjectIfEmpty, setOptionsRecentProjects: setOptionsRecentProjects, setOptionsAllProjects: setOptionsAllProjects, setLoadingProjects: setLoadingProjects, setIsJiraError: setIsJiraError } = (0, $CbMiC.useProjectsActions)();
    const { projectSelectorQuery: query } = (0, $CbMiC.useProjectsState)();
    (0, $42omo.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        if (!selectedAvailableSite || query && query.trim().length > 0) return;
        const fetchProjects = async ()=>{
            setLoadingProjects(true);
            const [recentProjectsPromise, allProjectsPromise] = await Promise.allSettled([
                fetchRecentProjects(),
                fetchAllProjects()
            ]);
            const firstProject = getFirstFromPromise(recentProjectsPromise) || getFirstFromPromise(allProjectsPromise);
            if (firstProject) setSelectedProjectIfEmpty(firstProject);
            else setIsJiraError(true);
            setLoadingProjects(false);
        };
        const getFirstFromPromise = (result)=>{
            return result.status === 'fulfilled' ? result.value?.[0] : undefined;
        };
        const fetchAllProjects = async ()=>{
            try {
                const allProjects = await (0, $k9cgj.fetchJiraProjects)({
                    cloudId: cloudId
                });
                if (allProjects) setOptionsAllProjects(allProjects);
                return allProjects;
            } catch (e) {
                logRequestFailed({
                    requestName: $3fb376e27e7792bc$export$423c192d1714471e,
                    errorMessage: `Failed to fetch projects: ${e.message}`
                });
                setError((0, $hq2Sz.ErrorStates).PROJECT_RETRIEVAL);
                setManualCreateState('error');
            }
        };
        const fetchRecentProjects = async ()=>{
            try {
                const recentProjects = await (0, $k9cgj.fetchRecentJiraProjects)({
                    cloudId: cloudId
                });
                const recentProjectIds = recentProjects?.map((project)=>project.id);
                if (!recentProjectIds || recentProjectIds.length === 0) return;
                const recentProjectsWithIssueCreatePermissionData = await (0, $k9cgj.fetchJiraProjects)({
                    cloudId: cloudId,
                    projectIds: recentProjectIds
                });
                if (recentProjectsWithIssueCreatePermissionData) setOptionsRecentProjects(recentProjectsWithIssueCreatePermissionData);
                return recentProjectsWithIssueCreatePermissionData;
            } catch (e) {
                logRequestFailed({
                    requestName: $3fb376e27e7792bc$export$903912d141558556,
                    errorMessage: `Failed to fetch recent projects with issue create permission: ${e.message}`
                });
                setError((0, $hq2Sz.ErrorStates).PROJECT_RETRIEVAL);
                setManualCreateState('error');
            }
        };
        fetchProjects();
    }, [
        selectedAvailableSite,
        setLoadingProjects,
        setOptionsAllProjects,
        logRequestFailed,
        setError,
        setOptionsRecentProjects,
        setSelectedProjectIfEmpty,
        query,
        setIsJiraError,
        setManualCreateState
    ]);
    (0, $42omo.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        if (!selectedAvailableSite || !query || query.trim().length === 0) return;
        const fetchProjects = async ()=>{
            try {
                const allProjects = await (0, $k9cgj.fetchJiraProjects)({
                    cloudId: cloudId,
                    query: query
                });
                if (allProjects) {
                    setOptionsRecentProjects([]);
                    setOptionsAllProjects(allProjects);
                }
                return allProjects;
            } catch (e) {
                logRequestFailed({
                    requestName: $3fb376e27e7792bc$export$423c192d1714471e,
                    errorMessage: `Failed to fetch query projects: ${e.message}`
                });
            }
        };
        fetchProjects();
    }, [
        selectedAvailableSite,
        setOptionsAllProjects,
        logRequestFailed,
        setOptionsRecentProjects,
        query
    ]);
};

















const $bc7180254427c083$export$34eff5686aa81020 = 'fetch-issue-types';
const $bc7180254427c083$export$76233ca4792d5ed4 = ()=>{
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const setError = (0, $hq2Sz.useSetError)();
    const setManualCreateState = (0, $hq2Sz.useSetManualCreateState)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const { setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty, setOptionsIssueTypes: setOptionsIssueTypes, setLoadingIssueType: setLoadingIssueType } = (0, $CbMiC.useIssueTypesActions)();
    (0, $42omo.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        const projectId = selectedProject?.id;
        if (!cloudId || !projectId) return;
        const fetchIssues = async ()=>{
            setLoadingIssueType(true);
            try {
                const data = await (0, $k9cgj.fetchIssueTypes)({
                    cloudId: cloudId,
                    projectId: projectId
                });
                const validIssueTypes = data?.filter((issueType)=>!issueType.subtask);
                validIssueTypes && setOptionsIssueTypes(validIssueTypes);
                const firstIssueType = validIssueTypes?.[0];
                firstIssueType && setSelectedIssueTypeIfEmpty(firstIssueType);
            } catch (e) {
                setError((0, $hq2Sz.ErrorStates).ISSUE_TYPE_RETRIEVAL);
                setManualCreateState('error');
                logRequestFailed({
                    requestName: $bc7180254427c083$export$34eff5686aa81020,
                    errorMessage: e.message
                });
            } finally{
                setLoadingIssueType(false);
            }
        };
        fetchIssues();
    }, [
        selectedAvailableSite?.cloudId,
        selectedProject?.id,
        setLoadingIssueType,
        setOptionsIssueTypes,
        setError,
        logRequestFailed,
        setSelectedIssueTypeIfEmpty,
        setManualCreateState
    ]);
};

















const $9e2ecd81fc442e69$var$BATCH_SIZE = 20;
const $9e2ecd81fc442e69$export$7f4bdffbd551b612 = ()=>{
    const [{ selectedTable: selectedTable }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { setMappingWorkItemTypes: setMappingWorkItemTypes } = (0, $CbMiC.useMappingsActions)();
    (0, $42omo.useEffect)(()=>{
        const fetchWorkItemTypes = async ()=>{
            const cloudId = selectedAvailableSite?.cloudId;
            if (!selectedTable || !cloudId) return;
            const allWorkItemKeysFlat = Array.from((0, $euVTc.getJiraWorkItemKeysFromTable)(selectedTable).values()).flat();
            const batches = [];
            for(let i = 0; i < allWorkItemKeysFlat.length; i += $9e2ecd81fc442e69$var$BATCH_SIZE)batches.push(allWorkItemKeysFlat.slice(i, i + $9e2ecd81fc442e69$var$BATCH_SIZE));
            const fetchPromises = batches.map((batch)=>(0, $k9cgj.fetchBulkWorkItemTypes)({
                    cloudId: cloudId,
                    workItemKeys: batch
                }));
            const fetchResults = await Promise.all(fetchPromises);
            // Accumulate results from all batches into a single Map
            const results = fetchResults.filter((batchResult)=>batchResult != null).reduce((acc, batchResult)=>{
                batchResult.forEach((value, key)=>{
                    acc.set(key, value);
                });
                return acc;
            }, new Map());
            setMappingWorkItemTypes(results);
        };
        fetchWorkItemTypes();
    }, [
        selectedTable,
        selectedAvailableSite?.cloudId,
        setMappingWorkItemTypes
    ]);
};




















const $9cb6313bbdd40ac6$var$BATCH_SIZE = 20;
const $9cb6313bbdd40ac6$var$ParentCandidatesForNewIssueQueryOperationName = 'ParentCandidatesForNewIssueQuery';
const $9cb6313bbdd40ac6$export$b332885c1a28726b = ()=>{
    const [{ selectedTable: selectedTable }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const { setMappingValidParentCandidates: setMappingValidParentCandidates } = (0, $CbMiC.useMappingsActions)();
    (0, $42omo.useEffect)(()=>{
        const fetchParentCandidates = async ()=>{
            const cloudId = selectedAvailableSite?.cloudId;
            const projectId = selectedProject?.id;
            const issueTypeId = selectedIssueType?.id;
            if (!selectedTable || !cloudId || !issueTypeId || !projectId) {
                // Clear the parent candidates if we don't have the required data
                setMappingValidParentCandidates(new (0, $2R8mu.SimpleJiraIssuesSet)());
                return;
            }
            const allWorkItemKeysFlat = Array.from((0, $euVTc.getJiraWorkItemKeysFromTable)(selectedTable).values()).flat();
            if (allWorkItemKeysFlat.length === 0) {
                setMappingValidParentCandidates(new (0, $2R8mu.SimpleJiraIssuesSet)());
                return;
            }
            const batches = [];
            for(let i = 0; i < allWorkItemKeysFlat.length; i += $9cb6313bbdd40ac6$var$BATCH_SIZE)batches.push(allWorkItemKeysFlat.slice(i, i + $9cb6313bbdd40ac6$var$BATCH_SIZE));
            const results = new (0, $2R8mu.SimpleJiraIssuesSet)();
            for (const batch of batches){
                const batchPromises = batch.map(async (issueKey)=>{
                    // Gets the parent candidates of the given issue type and checks to see if the issue key is a parent candidate.
                    const response = await (0, $k9cgj.executeGraphQLQuery)({
                        query: (0, $k9cgj.ParentCandidatesForNewIssueQuery),
                        variables: {
                            projectId: projectId,
                            cloudId: cloudId,
                            issueTypeId: issueTypeId,
                            searchTerm: issueKey,
                            excludeDone: true,
                            first: 1
                        },
                        operationName: $9cb6313bbdd40ac6$var$ParentCandidatesForNewIssueQueryOperationName
                    }, cloudId);
                    // The GraphQL response structure:
                    // response.data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges
                    const edges = response?.data?.jira?.parentCandidatesWithInfoForNewIssue?.parentCandidates?.edges;
                    if (Array.isArray(edges)) {
                        const issueNode = edges.find((edge)=>edge && edge.node && edge.node.key === issueKey)?.node;
                        if (issueNode) return {
                            issueId: issueNode.issueId,
                            key: issueNode.key
                        };
                    }
                    return null;
                });
                const batchResults = await Promise.all(batchPromises);
                batchResults.forEach((issue)=>{
                    if (issue) results.add(issue);
                });
            }
            setMappingValidParentCandidates(results);
        };
        fetchParentCandidates();
    }, [
        selectedTable,
        selectedAvailableSite?.cloudId,
        selectedIssueType?.id,
        setMappingValidParentCandidates,
        selectedProject?.id
    ]);
};














const $0c549d0eb9804ba4$export$667618dfdb275f3c = 'fetch-project-components';
const $0c549d0eb9804ba4$export$6083a0b8b191f442 = ()=>{
    const { logRequestFailed: logRequestFailed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const { setMappingAvailableComponents: setMappingAvailableComponents } = (0, $CbMiC.useMappingsActions)();
    (0, $42omo.useEffect)(()=>{
        const cloudId = selectedAvailableSite?.cloudId;
        const projectId = selectedProject?.id;
        if (!cloudId || !projectId) return;
        const fetchComponents = async ()=>{
            try {
                const components = await (0, $k9cgj.fetchJiraComponents)({
                    cloudId: cloudId,
                    projectId: projectId
                });
                setMappingAvailableComponents(components ?? []);
            } catch (error) {
                logRequestFailed({
                    requestName: $0c549d0eb9804ba4$export$667618dfdb275f3c,
                    errorMessage: error.message
                });
            }
        };
        fetchComponents();
    }, [
        selectedAvailableSite,
        selectedProject,
        logRequestFailed,
        setMappingAvailableComponents
    ]);
};


const $fe83b98d34932c56$export$166dc120320861d = ()=>{
    (0, $5d10bb9dbc732385$export$eb7aae190047eab2)();
    const { selectedAvailableSite: selectedAvailableSite } = (0, $CbMiC.useAvailableSitesState)();
    const [{ currentJiraSite: currentJiraSite }, { setCurrentJiraSite: setCurrentJiraSite }] = (0, $hq2Sz.useBulkCreateContext)();
    // selectedAvailableSite is the "draft" site selected by the user from the site picker, whereas currentJiraSite is the "confirmed" site displayed on the panel
    // selectedAvailableSite and currentJiraSite are synced when the user saves the selection in configure view
    // The logic below just initializes currentJiraSite with the selectedAvailableSite if it is not already set
    (0, $42omo.useEffect)(()=>{
        if (selectedAvailableSite && !currentJiraSite) setCurrentJiraSite(selectedAvailableSite);
    }, [
        selectedAvailableSite,
        currentJiraSite,
        setCurrentJiraSite
    ]);
    (0, $3fb376e27e7792bc$export$beaf2a819f4720da)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const [{ currentJiraProject: currentJiraProject }, { setCurrentJiraProject: setCurrentJiraProject }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $42omo.useEffect)(()=>{
        if (selectedProject && !currentJiraProject) setCurrentJiraProject(selectedProject);
    }, [
        selectedProject,
        currentJiraProject,
        setCurrentJiraProject
    ]);
    (0, $bc7180254427c083$export$76233ca4792d5ed4)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const [{ currentDefaultIssueType: currentDefaultIssueType }, { setCurrentDefaultIssueType: setCurrentDefaultIssueType }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $42omo.useEffect)(()=>{
        if (selectedIssueType && !currentDefaultIssueType) setCurrentDefaultIssueType(selectedIssueType);
    }, [
        selectedIssueType,
        currentDefaultIssueType,
        setCurrentDefaultIssueType
    ]);
    (0, $9e2ecd81fc442e69$export$7f4bdffbd551b612)();
    (0, $9cb6313bbdd40ac6$export$b332885c1a28726b)();
    (0, $0c549d0eb9804ba4$export$6083a0b8b191f442)();
};











const $bcdbe53c991b783f$export$8704aba2771cf253 = [
    'description',
    'issuetype',
    'project',
    'summary'
];
const $bcdbe53c991b783f$export$c85ba7cfb56ee08a = ()=>{
    const setIssueTypeHasRequiredFields = (0, $hq2Sz.useSetIssueTypeHasRequiredFields)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const [{ currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType }] = (0, $hq2Sz.useBulkCreateContext)();
    (0, $42omo.useEffect)(()=>{
        const fetchIssueMetadata = async ()=>{
            if (!currentJiraProject || !currentDefaultIssueType || !currentJiraSite) return;
            setIsLoading(true);
            try {
                const data = await (0, $k9cgj.fetchIssuesMetadata)({
                    cloudId: currentJiraSite.cloudId,
                    projectId: currentJiraProject.id,
                    issueTypeId: currentDefaultIssueType.id
                });
                if (data) {
                    const requiredFieldFound = data.fields.some((field)=>field.required && !$bcdbe53c991b783f$export$8704aba2771cf253.includes(field.key) && !field.hasDefaultValue);
                    setIssueTypeHasRequiredFields(requiredFieldFound);
                }
            } catch (e) {
                if ($bcdbe53c991b783f$var$isError(e)) setError(e.message);
            } finally{
                setIsLoading(false);
            }
        };
        fetchIssueMetadata();
    }, [
        currentJiraSite,
        currentJiraProject,
        currentDefaultIssueType,
        setIssueTypeHasRequiredFields
    ]);
    return {
        isLoading: isLoading,
        error: error
    };
};
const $bcdbe53c991b783f$var$isError = (error)=>{
    return error instanceof Error;
};



var $jwedr = parcelRequire("jwedr");


var $98CLM = parcelRequire("98CLM");




















const $5734ef8176e1881e$export$eb10de2fe984535 = ()=>{
    const { setOptionsColumns: setOptionsColumns, setColumnOffset: setColumnOffset } = (0, $CbMiC.useMappingsActions)();
    const { mappingWorkItemTypes: mappingWorkItemTypes, mappingFieldAllowedValues: mappingFieldAllowedValues } = (0, $CbMiC.useMappingsState)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const { selectedProject: selectedProject } = (0, $CbMiC.useProjectsState)();
    const [{ selectedTable: selectedTable }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { mappingValidParentCandidates: mappingValidParentCandidates } = (0, $CbMiC.useMappingsState)();
    (0, $42omo.useEffect)(()=>{
        if (selectedTable && selectedTable.rows.length > 0) {
            const columns = [];
            // Always use the first row as the header row, even if it is not a HTML header row
            const firstRow = selectedTable?.querySelector('tbody tr:first-of-type');
            if (firstRow) {
                const firstRowCells = Array.from(firstRow.querySelectorAll('td, th'));
                const hasNumberedCol = firstRowCells[0].classList.contains('ak-renderer-table-number-column') ? 1 : 0;
                const hasHeaderCol = selectedTable.rows.length > 1 && Array.from(selectedTable.rows).every((row)=>row.cells.length > 1 && (row.cells[0].tagName.toLowerCase() === 'th' || row.cells[1].tagName.toLowerCase() === 'th')) ? 1 : 0;
                // The API does not index the header column
                setColumnOffset(hasHeaderCol);
                let columnIndex = hasNumberedCol + hasHeaderCol;
                // Skip the header and numbered column
                firstRowCells.slice(hasNumberedCol + hasHeaderCol).forEach((cell)=>{
                    const column = {
                        index: columnIndex,
                        header: cell.textContent ?? ''
                    };
                    columns.push(column);
                    columnIndex += 1;
                });
            }
            setOptionsColumns(columns);
        }
    }, [
        selectedTable,
        setColumnOffset,
        setOptionsColumns,
        mappingWorkItemTypes,
        selectedIssueType,
        selectedProject,
        mappingValidParentCandidates,
        mappingFieldAllowedValues
    ]);
};








const $baa550ab5fae5345$var$createDefaultMappings = (columns, fields)=>{
    // Map both summary and description if there's only one column
    if (columns.length === 1) return [
        'summary',
        'description'
    ].map((fieldId)=>{
        const field = fields.find((f)=>f.fieldId === fieldId);
        return {
            column: columns[0],
            field: field
        };
    });
    const fieldMap = {
        0: 'summary',
        1: 'description'
    };
    return columns.slice(0, 2).map((column, index)=>{
        const fieldId = fieldMap[index];
        const field = fields.find((f)=>f.fieldId === fieldId);
        return {
            column: column,
            field: field
        };
    });
};
const $baa550ab5fae5345$export$c8ab1378f7db9642 = ()=>{
    const { optionsIssueTypeFields: optionsIssueTypeFields, optionsColumns: optionsColumns } = (0, $CbMiC.useMappingsState)();
    const { setColumnToFieldMappings: setColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings } = (0, $CbMiC.useMappingsActions)();
    (0, $42omo.useEffect)(()=>{
        if (optionsIssueTypeFields && optionsColumns) {
            const defaultMappings = $baa550ab5fae5345$var$createDefaultMappings(optionsColumns, optionsIssueTypeFields);
            setColumnToFieldMappings(defaultMappings);
            initUnsavedColumnToFieldMappings();
        }
    }, [
        optionsIssueTypeFields,
        optionsColumns,
        setColumnToFieldMappings,
        initUnsavedColumnToFieldMappings
    ]);
};























const $2e24543847a65a25$export$70098129974a7e55 = ()=>{
    const { columnToFieldMappings: columnToFieldMappings, columnOffset: columnOffset, mappingWorkItemTypes: mappingWorkItemTypes, mappingValidParentCandidates: mappingValidParentCandidates, mappingAvailableComponents: mappingAvailableComponents, mappingFieldAllowedValues: mappingFieldAllowedValues } = (0, $CbMiC.useMappingsState)();
    const { selectedIssueType: selectedIssueType } = (0, $CbMiC.useIssueTypesState)();
    const [{ selectedTable: selectedTable, insertStorageColumnTableRequestPayload: insertStorageColumnTableRequestPayload }, { setInsertStorageColumnTableRequestPayload: setInsertStorageColumnTableRequestPayload }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setBulkIssuesList = (0, $hq2Sz.useSetBulkIssuesList)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    // Memoize the options object to prevent unnecessary re-renders
    const mappingOptions = (0, $42omo.useMemo)(()=>({
            mappingWorkItemTypes: mappingWorkItemTypes ?? new Map(),
            selectedIssueType: selectedIssueType,
            mappingValidParentCandidates: mappingValidParentCandidates ?? new (0, $2R8mu.SimpleJiraIssuesSet)(),
            mappingFieldAllowedValues: new Map([
                ...mappingFieldAllowedValues ?? new Map(),
                ...mappingAvailableComponents ? new Map([
                    [
                        'components',
                        mappingAvailableComponents
                    ]
                ]) : new Map()
            ])
        }), [
        mappingWorkItemTypes,
        selectedIssueType,
        mappingValidParentCandidates,
        mappingFieldAllowedValues,
        mappingAvailableComponents
    ]);
    (0, $42omo.useEffect)(()=>{
        if (columnToFieldMappings && columnToFieldMappings.length > 0 && selectedTable) {
            const mappedIssues = (0, $euVTc.mapTableToIssues)(columnToFieldMappings, selectedTable, mappingOptions);
            setBulkIssuesList(mappedIssues);
            if (mappedIssues.length === 0) goToPage('configure');
        }
    }, [
        columnToFieldMappings,
        goToPage,
        selectedTable,
        setBulkIssuesList,
        mappingOptions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (columnToFieldMappings && columnToFieldMappings.length > 0) {
            const summaryMapping = columnToFieldMappings.find((mapping)=>mapping.field?.key === 'summary');
            //The insertion API does not include header columns in indexing
            const unadjustedIndex = summaryMapping?.column?.index ?? 0;
            const tableColumnIndex = columnOffset != null && unadjustedIndex !== 0 ? unadjustedIndex - columnOffset : unadjustedIndex;
            const updatedPayload = {
                ...insertStorageColumnTableRequestPayload,
                tableColumnIndex: tableColumnIndex
            };
            setInsertStorageColumnTableRequestPayload(updatedPayload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        columnToFieldMappings
    ]);
};






































const $15c1ee332125e9b5$export$61b27cec524a09b0 = ()=>{
    const [{ currentJiraSite: currentJiraSite, currentJiraProject: currentJiraProject, currentDefaultIssueType: currentDefaultIssueType, manualCreateState: manualCreateState, error: error, bulkIssuesList: bulkIssuesList }, actions] = (0, $hq2Sz.useBulkCreateContext)();
    const { loadingIssueTypeFields: loadingIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    (0, $42omo.useEffect)(()=>{
        const isLoading = !currentJiraSite || !currentJiraProject || !currentDefaultIssueType || loadingIssueTypeFields || bulkIssuesList?.length === 0;
        if (isLoading) actions.setManualCreateState('loading');
        const isError = error !== (0, $hq2Sz.ErrorStates).EMPTY;
        if (isError) actions.setManualCreateState('error');
        if (!isLoading && !isError) actions.setManualCreateState('idle');
    }, [
        actions,
        currentDefaultIssueType,
        currentJiraProject,
        currentJiraSite,
        loadingIssueTypeFields,
        error,
        bulkIssuesList
    ]);
    return {
        isLoading: manualCreateState === 'loading',
        isError: manualCreateState === 'error',
        isIdle: manualCreateState === 'idle'
    };
};





















var $g9Srd = parcelRequire("g9Srd");


var $fT2ta = parcelRequire("fT2ta");













const $d2d02618154bfa90$export$f14cfc3059167b17 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M79.85 47.0573H31.14V70.8573H79.85V47.0573Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M64.71 32.2773H16V56.0773H64.71V32.2773Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M64.71 47.0573H31.14V56.0773H64.71V47.0573Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M76.82 55.6573L66.33 66.1473L60.91 60.5773L63.25 58.3073L66.37 61.5073L74.52 53.3573L76.83 55.6673L76.82 55.6573Z",
        fill: "white"
    }));


const $e732ffa9717d29ba$var$loadingMessages = [
    (0, $3E5yu.messages).manualBulkCreateLoadingTextFirst,
    (0, $3E5yu.messages).manualBulkCreateLoadingTextSecond,
    (0, $3E5yu.messages).manualBulkCreateLoadingTextThird
];
const $e732ffa9717d29ba$export$45b36fb4fd03bc = ()=>{
    const [loadingMessageIndex, setLoadingMessageIndex] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        // Creates a 1.5 second interval between rotating the three text options contained in loadingMessages
        const intervalId = window.setInterval(()=>{
            setLoadingMessageIndex((prev)=>(prev + 1) % $e732ffa9717d29ba$var$loadingMessages.length);
        }, 1500);
        return ()=>window.clearInterval(intervalId);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2d02618154bfa90$export$f14cfc3059167b17), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        exitThenEnter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "right",
        duration: "large"
    }, (motionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), motionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e732ffa9717d29ba$var$loadingMessages[loadingMessageIndex]))))));
};


const $b647e1903fe52db9$var$contentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap'
});
const $b647e1903fe52db9$var$footerBaseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    flexShrink: 0,
    position: 'relative',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.150',
        right: 'space.150',
        height: '1px',
        backgroundColor: 'elevation.surface',
        borderTopColor: 'color.border',
        borderTopStyle: 'solid',
        borderTopWidth: 'border.width'
    }
});
const $b647e1903fe52db9$var$footerTopStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $b647e1903fe52db9$var$loadingScreenStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
});
const $b647e1903fe52db9$export$48c6ac1fbf5f1245 = ({ onClose: onClose })=>{
    const { isLoading: isLoading, isError: isError, isIdle: isIdle } = (0, $15c1ee332125e9b5$export$61b27cec524a09b0)();
    const resetManualBulkCreateState = (0, $hq2Sz.useResetManualBulkCreateState)();
    const { addSingleIssuesToPage: addSingleIssuesToPage } = (0, $ed2929b91c73486c$export$d58e5870a6e92835)();
    // TO-DO need to implement logic to retry fetching Jira site / project / issue type
    // const handleTryAgain = () => {}
    const onPanelClose = (0, $42omo.useCallback)(()=>{
        addSingleIssuesToPage();
        /*
    	Once the confluence-bulk-work-create-editor experiment is enabled we'll be resetting
    	the bulk create state in BulkCreateSidePanel's handleOnClose method instead of here.
    	We should clean up this code when cleaning up the experiment.
    */ if (!(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) resetManualBulkCreateState();
        onClose();
    }, [
        resetManualBulkCreateState,
        addSingleIssuesToPage,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b647e1903fe52db9$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea94463cb9b948e3$export$fe6406b062c20dac), {
        onClose: onPanelClose
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b647e1903fe52db9$var$loadingScreenStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e732ffa9717d29ba$export$45b36fb4fd03bc), null)), isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: (0, $26Yin.BULK_ISSUE_CREATE_SOURCE),
        errorMessage: (0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3E5yu.messages).connectJiraProjectErrorDescriptionGalaxia : (0, $3E5yu.messages).connectJiraProjectErrorDescription
    }), isIdle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $832bf07ce05f7f94$export$a9383f5eed4e0adc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b647e1903fe52db9$var$footerBaseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $b647e1903fe52db9$var$footerTopStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2fd9480bca9d7e8f$export$1926ccc813f04882), {
        onClose: onPanelClose,
        onCreateAll: onClose
    }))))));
};


/* eslint-disable import-extensions/file-extension-required */ 


















var $cSSgB = parcelRequire("cSSgB");

const $a1d389ff0247f1e7$export$9ed9db1aa7010490 = ()=>{
    const [{ selectedActionItems: selectedActionItems }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setBulkIssuesList = (0, $hq2Sz.useSetBulkIssuesList)();
    const goToPage = (0, $aMxFD.useAiBulkNavigationGotoPage)();
    const { optionsIssueTypeFields: optionsIssueTypeFields, loadingIssueTypeFields: loadingIssueTypeFields } = (0, $CbMiC.useMappingsState)();
    (0, $42omo.useEffect)(()=>{
        if (!selectedActionItems) return;
        if (!(0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) return;
        // When fast follows is enabled, require Jira metadata to be fully loaded
        if ((0, $9wGTI.fg)('confluence-ai-jira-work-create-fast-follows')) {
            if (!optionsIssueTypeFields || optionsIssueTypeFields.length === 0 || loadingIssueTypeFields) return;
        }
        const mappedIssues = (0, $cSSgB.mapActionItemsToIssues)(selectedActionItems);
        setBulkIssuesList(mappedIssues);
        if (mappedIssues.length === 0) goToPage('configure');
    }, [
        goToPage,
        setBulkIssuesList,
        selectedActionItems,
        optionsIssueTypeFields,
        loadingIssueTypeFields
    ]);
};





const $a1e922e86f28467f$export$3e5bfa69be7c6c6c = ({ onClose: onClose })=>{
    (0, $5acf347b59010cba$export$329fec8b4c580586)();
    (0, $5734ef8176e1881e$export$eb10de2fe984535)();
    (0, $baa550ab5fae5345$export$c8ab1378f7db9642)();
    (0, $fa4d76143b144d29$export$5cfa116e87f44d8b)();
    (0, $2e24543847a65a25$export$70098129974a7e55)();
    (0, $a1d389ff0247f1e7$export$9ed9db1aa7010490)();
    (0, $b087aae42cea54f5$export$fcc44dd45d1185f8)(onClose);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b647e1903fe52db9$export$48c6ac1fbf5f1245), {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d923f05cd22225af$export$ee2807e678386f7a), {
        closePanel: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6b2e07d107802c1$export$bfc1d0fcda79c38d), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $394c97495ccb97e6$export$faba4facebe8b231), null));
};


const $ef704f702045acf9$export$b3b1d63513bd5722 = 'bulk-issue-create-side-panel';
const $ef704f702045acf9$export$a6cf0354d3df720c = 'bulk-issue-create-side-panel';
const $ef704f702045acf9$export$8f4d251ee889c2c8 = 320;
const $ef704f702045acf9$export$b40c2dab90d99521 = 439;
const $ef704f702045acf9$export$7da6669cc576b7da = ({ onClose: onClose })=>{
    (0, $fe83b98d34932c56$export$166dc120320861d)();
    const resetTransientBulkCreateState = (0, $hq2Sz.useResetTransientBulkCreateState)();
    const bulkIssuesList = (0, $hq2Sz.useBulkIssuesList)();
    const isCreatedWithAi = (0, $hq2Sz.useIsCreatedWithAi)();
    const isRovoPanelWidth = (0, $hq2Sz.useIsRovoPanelWidth)();
    (0, $bcdbe53c991b783f$export$c85ba7cfb56ee08a)();
    const { logSidePanelClosed: logSidePanelClosed } = (0, $26Yin.useBulkCreateLoggingEvents)();
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        logSidePanelClosed();
        if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) resetTransientBulkCreateState();
        onClose();
    }, [
        logSidePanelClosed,
        onClose,
        resetTransientBulkCreateState
    ]);
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(handleOnClose);
    const aiBulkContent = isRovoPanelWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWidthProvider), {
        value: $ef704f702045acf9$export$b40c2dab90d99521
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74a1b2d516d51f88$export$7d780be885e5d51a), {
        onClose: handleOnClose
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74a1b2d516d51f88$export$7d780be885e5d51a), {
        onClose: handleOnClose
    });
    const navigationContent = isCreatedWithAi ? aiBulkContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1e922e86f28467f$export$3e5bfa69be7c6c6c), {
        onClose: handleOnClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, navigationContent, isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        issuesCount: bulkIssuesList?.length
    }));
};
const $ef704f702045acf9$export$b46ccdf5c201a7ce = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7c6d6705668316e$export$8415879aba634d17), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: (0, $26Yin.AI_BULK_ISSUE_CREATE_FEATURE_NAME),
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ef704f702045acf9$export$7da6669cc576b7da, {
        onClose: onClose
    })));
};
module.exports["bulkCreateSidePanelTestId"] = $ef704f702045acf9$export$b3b1d63513bd5722;
module.exports["BULK_ISSUE_CREATE_SIDE_PANEL_ID"] = $ef704f702045acf9$export$a6cf0354d3df720c;
module.exports["BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $ef704f702045acf9$export$8f4d251ee889c2c8;
module.exports["ROVO_BULK_CREATE_SIDE_PANEL_WIDTH"] = $ef704f702045acf9$export$b40c2dab90d99521;
module.exports["BulkCreateSidePanelComponent"] = $ef704f702045acf9$export$7da6669cc576b7da;
module.exports["BulkCreateSidePanel"] = $ef704f702045acf9$export$b46ccdf5c201a7ce;

});

parcelRegister("CbMiC", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

var $bb8ecfce0aa3278d$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType[FieldType["PARAGRAPH"] = 0] = "PARAGRAPH";
    FieldType[FieldType["SHORT_TEXT"] = 1] = "SHORT_TEXT";
    FieldType[FieldType["NUMBER"] = 2] = "NUMBER";
    FieldType[FieldType["DATE"] = 3] = "DATE";
    FieldType[FieldType["TIMESTAMP"] = 4] = "TIMESTAMP";
    FieldType[FieldType["USER"] = 5] = "USER";
    FieldType[FieldType["PEOPLE"] = 6] = "PEOPLE";
    FieldType[FieldType["TEAM"] = 7] = "TEAM";
    FieldType[FieldType["PRIORITY"] = 8] = "PRIORITY";
    FieldType[FieldType["COMPONENTS"] = 9] = "COMPONENTS";
    FieldType[FieldType["LABELS"] = 10] = "LABELS";
    FieldType[FieldType["VERSIONS"] = 11] = "VERSIONS";
    FieldType[FieldType["PARENT"] = 12] = "PARENT";
    FieldType[FieldType["UNSUPPORTED"] = 13] = "UNSUPPORTED";
    FieldType[FieldType["SINGLE_SELECT"] = 14] = "SINGLE_SELECT";
    FieldType[FieldType["MULTI_SELECT"] = 15] = "MULTI_SELECT";
    return FieldType;
}({});
const $bb8ecfce0aa3278d$var$initialState = {
    optionsAvailableSites: null,
    optionsRecentProjects: null,
    optionsAllProjects: null,
    optionsIssueTypes: null,
    optionsIssueTypeFields: null,
    optionsColumns: null,
    selectedAvailableSite: null,
    selectedProject: null,
    selectedIssueType: null,
    loadingProjects: false,
    loadingIssueType: false,
    loadingIssueTypeFields: false,
    projectSelectorQuery: '',
    isJiraError: false,
    columnToFieldMappings: null,
    unsavedColumnToFieldMappings: null,
    columnOffset: null,
    mappingWorkItemTypes: null,
    mappingValidParentCandidates: null,
    mappingFieldAllowedValues: null,
    mappingAvailableComponents: null
};
const $bb8ecfce0aa3278d$var$actions = {
    setOptionsAvailableSites: (optionsAvailableSites)=>({ setState: setState })=>{
            setState({
                optionsAvailableSites: optionsAvailableSites
            });
        },
    setOptionsRecentProjects: (optionsRecentProjects)=>({ setState: setState })=>{
            setState({
                optionsRecentProjects: optionsRecentProjects
            });
        },
    setOptionsAllProjects: (optionsAllProjects)=>({ setState: setState })=>{
            setState({
                optionsAllProjects: optionsAllProjects
            });
        },
    setOptionsIssueTypes: (optionsIssueTypes)=>({ setState: setState })=>{
            setState({
                optionsIssueTypes: optionsIssueTypes
            });
        },
    setOptionsIssueTypeFields: (optionsIssueTypeFields)=>({ setState: setState })=>{
            setState({
                optionsIssueTypeFields: optionsIssueTypeFields
            });
        },
    setOptionsColumns: (optionsColumns)=>({ setState: setState })=>{
            setState({
                optionsColumns: optionsColumns
            });
        },
    setSelectedAvailableSite: (selectedAvailableSite)=>({ setState: setState })=>{
            setState({
                selectedAvailableSite: selectedAvailableSite,
                selectedProject: null,
                selectedIssueType: null,
                optionsRecentProjects: null,
                optionsAllProjects: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null,
                isJiraError: false
            });
        },
    setSelectedProject: (selectedProject)=>({ setState: setState })=>{
            setState({
                selectedProject: selectedProject,
                selectedIssueType: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null
            });
        },
    setSelectedProjectIfEmpty: (newSelectedProject)=>({ getState: getState, setState: setState })=>{
            const { selectedProject: selectedProject } = getState();
            if (!selectedProject) setState({
                selectedProject: newSelectedProject,
                selectedIssueType: null,
                optionsIssueTypes: null,
                optionsIssueTypeFields: null
            });
        },
    setSelectedIssueType: (selectedIssueType)=>({ setState: setState })=>{
            setState({
                selectedIssueType: selectedIssueType,
                optionsIssueTypeFields: null
            });
        },
    setSelectedIssueTypeIfEmpty: (newSelectedIssueType)=>({ getState: getState, setState: setState })=>{
            const { selectedIssueType: selectedIssueType } = getState();
            if (!selectedIssueType) setState({
                selectedIssueType: newSelectedIssueType,
                optionsIssueTypeFields: null
            });
        },
    setLoadingProjects: (loadingProjects)=>({ setState: setState })=>{
            setState({
                loadingProjects: loadingProjects
            });
        },
    setLoadingIssueType: (loadingIssueType)=>({ setState: setState })=>{
            setState({
                loadingIssueType: loadingIssueType
            });
        },
    setLoadingIssueTypeFields: (loadingIssueTypeFields)=>({ setState: setState })=>{
            setState({
                loadingIssueTypeFields: loadingIssueTypeFields
            });
        },
    setProjectSelectorQuery: (projectSelectorQuery)=>({ setState: setState })=>{
            setState({
                projectSelectorQuery: projectSelectorQuery
            });
        },
    setIsJiraError: (isJiraError)=>({ setState: setState })=>{
            setState({
                isJiraError: isJiraError
            });
        },
    setColumnToFieldMappings: (columnToFieldMappings)=>({ setState: setState })=>{
            setState({
                columnToFieldMappings: columnToFieldMappings
            });
        },
    setUnsavedColumnToFieldMappings: (unsavedColumnToFieldMappings)=>({ setState: setState })=>{
            setState({
                unsavedColumnToFieldMappings: unsavedColumnToFieldMappings
            });
        },
    initUnsavedColumnToFieldMappings: ()=>({ setState: setState, getState: getState })=>{
            const { columnToFieldMappings: columnToFieldMappings, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, optionsIssueTypeFields: optionsIssueTypeFields } = getState();
            // When the issue type chenges, the issue type fields will need to be reloaded.
            // With the existing mapping:
            // If the field is not available in the newly selected issue type, we remove the mapping.
            // If the field is available, we keep the mapping and update the reference to the field.
            if (unsavedColumnToFieldMappings && optionsIssueTypeFields) {
                const fieldIdMap = new Map(optionsIssueTypeFields.map((field)=>[
                        field.fieldId,
                        field
                    ]));
                const updatedMappings = unsavedColumnToFieldMappings.reduce((acc, mapping)=>{
                    const currentFieldId = mapping.field?.fieldId;
                    if (currentFieldId === undefined || fieldIdMap.has(currentFieldId)) acc.push({
                        ...mapping,
                        field: currentFieldId ? fieldIdMap.get(currentFieldId) : undefined,
                        errors: {}
                    });
                    return acc;
                }, []);
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            } else if (columnToFieldMappings) {
                const updatedMappings = columnToFieldMappings.map((mapping)=>({
                        ...mapping,
                        isDefaultMapping: mapping.field?.fieldId === 'summary' || mapping.field?.fieldId === 'description',
                        errors: {}
                    }));
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            }
        },
    addUnsavedColumnToFieldMapping: (mapping)=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) setState({
                unsavedColumnToFieldMappings: [
                    ...unsavedColumnToFieldMappings,
                    mapping
                ]
            });
        },
    deleteUnsavedColumnToFieldMapping: (index)=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) {
                const updatedMappings = unsavedColumnToFieldMappings.filter((_, idx)=>idx !== index);
                setState({
                    unsavedColumnToFieldMappings: updatedMappings
                });
            }
        },
    saveUnsavedColumnToFieldMapping: ()=>({ getState: getState, setState: setState })=>{
            const { unsavedColumnToFieldMappings: unsavedColumnToFieldMappings } = getState();
            if (unsavedColumnToFieldMappings) {
                const updatedMappings = unsavedColumnToFieldMappings.map(({ errors: _errors, isDefaultMapping: _isDefaultMapping, ...rest })=>rest);
                setState({
                    columnToFieldMappings: updatedMappings
                });
            }
        },
    setColumnOffset: (columnOffset)=>({ setState: setState })=>{
            setState({
                columnOffset: columnOffset
            });
        },
    setFieldAllowedValues: (mappingFieldAllowedValues)=>({ setState: setState })=>{
            setState({
                mappingFieldAllowedValues: mappingFieldAllowedValues
            });
        },
    setMappingWorkItemTypes: (mappingWorkItemTypes)=>({ setState: setState })=>{
            setState({
                mappingWorkItemTypes: mappingWorkItemTypes
            });
        },
    setMappingValidParentCandidates: (mappingValidParentCandidates)=>({ setState: setState })=>{
            setState({
                mappingValidParentCandidates: mappingValidParentCandidates
            });
        },
    setMappingAvailableComponents: (mappingAvailableComponents)=>({ setState: setState })=>{
            setState({
                mappingAvailableComponents: mappingAvailableComponents
            });
        },
    resetAll: (selectedAvailableSite, selectedProject, selectedIssueType)=>({ setState: setState })=>{
            setState({
                selectedAvailableSite: selectedAvailableSite,
                selectedProject: selectedProject,
                selectedIssueType: selectedIssueType
            });
        }
};
const $bb8ecfce0aa3278d$var$Store = (0, $1P1Tu.createStore)({
    initialState: $bb8ecfce0aa3278d$var$initialState,
    actions: $bb8ecfce0aa3278d$var$actions,
    name: 'BulkConfigureState'
});
const $bb8ecfce0aa3278d$export$f3c254ba6f87ce6c = (0, $FOT9i.createContainer)($bb8ecfce0aa3278d$var$Store);
const $bb8ecfce0aa3278d$var$useActions = (0, $9zUhf.createActionsHook)($bb8ecfce0aa3278d$var$Store);
const $bb8ecfce0aa3278d$export$34f182b55b8247e5 = ()=>{
    const { setOptionsAvailableSites: setOptionsAvailableSites, setSelectedAvailableSite: setSelectedAvailableSite } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsAvailableSites: setOptionsAvailableSites,
        setSelectedAvailableSite: setSelectedAvailableSite
    };
};
const $bb8ecfce0aa3278d$export$b6149499a5c58797 = (0, $9zUhf.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsAvailableSites: optionsAvailableSites, selectedAvailableSite: selectedAvailableSite })=>({
            optionsAvailableSites: optionsAvailableSites,
            selectedAvailableSite: selectedAvailableSite
        })
});
const $bb8ecfce0aa3278d$export$af9c52e036827f6 = ()=>{
    const { setOptionsRecentProjects: setOptionsRecentProjects, setOptionsAllProjects: setOptionsAllProjects, setSelectedProject: setSelectedProject, setSelectedProjectIfEmpty: setSelectedProjectIfEmpty, setLoadingProjects: setLoadingProjects, setProjectSelectorQuery: setProjectSelectorQuery, setIsJiraError: setIsJiraError } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsRecentProjects: setOptionsRecentProjects,
        setOptionsAllProjects: setOptionsAllProjects,
        setSelectedProject: setSelectedProject,
        setSelectedProjectIfEmpty: setSelectedProjectIfEmpty,
        setLoadingProjects: setLoadingProjects,
        setProjectSelectorQuery: setProjectSelectorQuery,
        setIsJiraError: setIsJiraError
    };
};
const $bb8ecfce0aa3278d$export$f7f81cde1f4d14dd = (0, $9zUhf.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsRecentProjects: optionsRecentProjects, optionsAllProjects: optionsAllProjects, selectedProject: selectedProject, projectSelectorQuery: projectSelectorQuery })=>({
            optionsRecentProjects: optionsRecentProjects,
            optionsAllProjects: optionsAllProjects,
            selectedProject: selectedProject,
            projectSelectorQuery: projectSelectorQuery
        })
});
const $bb8ecfce0aa3278d$export$8748a77548356db8 = ()=>{
    const { setOptionsIssueTypes: setOptionsIssueTypes, setSelectedIssueType: setSelectedIssueType, setLoadingIssueType: setLoadingIssueType, setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsIssueTypes: setOptionsIssueTypes,
        setSelectedIssueType: setSelectedIssueType,
        setSelectedIssueTypeIfEmpty: setSelectedIssueTypeIfEmpty,
        setLoadingIssueType: setLoadingIssueType
    };
};
const $bb8ecfce0aa3278d$export$5c76c054e4b1d9b1 = (0, $9zUhf.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsIssueTypes: optionsIssueTypes, selectedIssueType: selectedIssueType })=>({
            optionsIssueTypes: optionsIssueTypes,
            selectedIssueType: selectedIssueType
        })
});
const $bb8ecfce0aa3278d$export$fd383356e1d8436d = (0, $9zUhf.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ selectedAvailableSite: selectedAvailableSite, loadingProjects: loadingProjects, loadingIssueType: loadingIssueType, isJiraError: isJiraError })=>({
            isLoading: selectedAvailableSite == null || loadingProjects || loadingIssueType,
            isJiraError: isJiraError
        })
});
const $bb8ecfce0aa3278d$export$d70d2e57670622a8 = ()=>{
    const { setOptionsColumns: setOptionsColumns, setOptionsIssueTypeFields: setOptionsIssueTypeFields, setLoadingIssueTypeFields: setLoadingIssueTypeFields, setColumnToFieldMappings: setColumnToFieldMappings, setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings, initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings, addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping, deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping, saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping, setColumnOffset: setColumnOffset, setFieldAllowedValues: setFieldAllowedValues, setMappingWorkItemTypes: setMappingWorkItemTypes, setMappingValidParentCandidates: setMappingValidParentCandidates, setMappingAvailableComponents: setMappingAvailableComponents } = $bb8ecfce0aa3278d$var$useActions();
    return {
        setOptionsColumns: setOptionsColumns,
        setOptionsIssueTypeFields: setOptionsIssueTypeFields,
        setLoadingIssueTypeFields: setLoadingIssueTypeFields,
        setColumnToFieldMappings: setColumnToFieldMappings,
        initUnsavedColumnToFieldMappings: initUnsavedColumnToFieldMappings,
        setUnsavedColumnToFieldMappings: setUnsavedColumnToFieldMappings,
        addUnsavedColumnToFieldMapping: addUnsavedColumnToFieldMapping,
        deleteUnsavedColumnToFieldMapping: deleteUnsavedColumnToFieldMapping,
        saveUnsavedColumnToFieldMapping: saveUnsavedColumnToFieldMapping,
        setColumnOffset: setColumnOffset,
        setFieldAllowedValues: setFieldAllowedValues,
        setMappingWorkItemTypes: setMappingWorkItemTypes,
        setMappingValidParentCandidates: setMappingValidParentCandidates,
        setMappingAvailableComponents: setMappingAvailableComponents
    };
};
const $bb8ecfce0aa3278d$export$c8eb692d6965a0dd = (0, $9zUhf.createStateHook)($bb8ecfce0aa3278d$var$Store, {
    selector: ({ optionsColumns: optionsColumns, optionsIssueTypeFields: optionsIssueTypeFields, loadingIssueTypeFields: loadingIssueTypeFields, columnToFieldMappings: columnToFieldMappings, unsavedColumnToFieldMappings: unsavedColumnToFieldMappings, columnOffset: columnOffset, mappingFieldAllowedValues: mappingFieldAllowedValues, mappingWorkItemTypes: mappingWorkItemTypes, mappingValidParentCandidates: mappingValidParentCandidates, mappingAvailableComponents: mappingAvailableComponents })=>({
            optionsColumns: optionsColumns,
            optionsIssueTypeFields: optionsIssueTypeFields,
            loadingIssueTypeFields: loadingIssueTypeFields,
            columnToFieldMappings: columnToFieldMappings,
            unsavedColumnToFieldMappings: unsavedColumnToFieldMappings,
            columnOffset: columnOffset,
            mappingFieldAllowedValues: mappingFieldAllowedValues,
            mappingWorkItemTypes: mappingWorkItemTypes,
            mappingValidParentCandidates: mappingValidParentCandidates,
            mappingAvailableComponents: mappingAvailableComponents
        })
});
const $bb8ecfce0aa3278d$export$2577d7c75421da7d = ()=>{
    const { resetAll: resetAll } = $bb8ecfce0aa3278d$var$useActions();
    return resetAll;
};
module.exports["FieldType"] = $bb8ecfce0aa3278d$export$ed12481c953b8653;
module.exports["BulkConfigureContextContainer"] = $bb8ecfce0aa3278d$export$f3c254ba6f87ce6c;
module.exports["useAvailableSitesActions"] = $bb8ecfce0aa3278d$export$34f182b55b8247e5;
module.exports["useAvailableSitesState"] = $bb8ecfce0aa3278d$export$b6149499a5c58797;
module.exports["useProjectsActions"] = $bb8ecfce0aa3278d$export$af9c52e036827f6;
module.exports["useProjectsState"] = $bb8ecfce0aa3278d$export$f7f81cde1f4d14dd;
module.exports["useIssueTypesActions"] = $bb8ecfce0aa3278d$export$8748a77548356db8;
module.exports["useIssueTypesState"] = $bb8ecfce0aa3278d$export$5c76c054e4b1d9b1;
module.exports["useIsConfigureLoading"] = $bb8ecfce0aa3278d$export$fd383356e1d8436d;
module.exports["useMappingsActions"] = $bb8ecfce0aa3278d$export$d70d2e57670622a8;
module.exports["useMappingsState"] = $bb8ecfce0aa3278d$export$c8eb692d6965a0dd;
module.exports["useResetConfigureState"] = $bb8ecfce0aa3278d$export$2577d7c75421da7d;

});

parcelRegister("2R8mu", function(module, exports) {
const $71c94b57ccceac13$export$6f9c4b5b9f7231da = (value)=>{
    return typeof value === 'object' && value !== null && 'id' in value;
};
const $71c94b57ccceac13$export$a24d9b48e1b802c6 = (value)=>{
    return Array.isArray(value) && value.every($71c94b57ccceac13$export$6f9c4b5b9f7231da);
};
var $71c94b57ccceac13$export$af05362339233870 = /*#__PURE__*/ function(JiraProjectType) {
    JiraProjectType["JiraCore"] = "jira-core";
    JiraProjectType["JiraServiceDesk"] = "jira-servicedesk";
    JiraProjectType["JiraCustomerService"] = "jira-customer-service";
    JiraProjectType["JiraSoftware"] = "jira-software";
    JiraProjectType["JiraProductDiscovery"] = "jira-product-discovery";
    return JiraProjectType;
}({});
const $71c94b57ccceac13$export$f7e2564263dc8770 = {
    service_desk: "jira-servicedesk",
    software: "jira-software",
    customer_service: "jira-customer-service",
    business: "jira-core",
    product_discovery: "jira-product-discovery"
};
var $71c94b57ccceac13$export$bff92472168efa13 = /*#__PURE__*/ function(FieldMetadataSchemaItems) {
    FieldMetadataSchemaItems["VERSION"] = "version";
    FieldMetadataSchemaItems["OPTION"] = "option";
    return FieldMetadataSchemaItems;
}({});
var $71c94b57ccceac13$export$e70f0c6fcc814588 = /*#__PURE__*/ function(FieldMetadataSchemaType) {
    FieldMetadataSchemaType["ANY"] = "any";
    FieldMetadataSchemaType["STRING"] = "string";
    FieldMetadataSchemaType["NUMBER"] = "number";
    FieldMetadataSchemaType["DATE"] = "date";
    FieldMetadataSchemaType["DATETIME"] = "datetime";
    FieldMetadataSchemaType["ISSUELINK"] = "issuelink";
    FieldMetadataSchemaType["ISSUETYPE"] = "issuetype";
    FieldMetadataSchemaType["USER"] = "user";
    FieldMetadataSchemaType["TEAM"] = "team";
    FieldMetadataSchemaType["PRIORITY"] = "priority";
    FieldMetadataSchemaType["ARRAY"] = "array";
    FieldMetadataSchemaType["COMPONENTS"] = "components";
    return FieldMetadataSchemaType;
}({});
var $71c94b57ccceac13$export$a9a7f0c9ccbb6fb6 = /*#__PURE__*/ function(FieldMetadataSchemaCustom) {
    FieldMetadataSchemaCustom["TEXT_AREA"] = "com.atlassian.jira.plugin.system.customfieldtypes:textarea";
    FieldMetadataSchemaCustom["TEXT_FIELD"] = "com.atlassian.jira.plugin.system.customfieldtypes:textfield";
    FieldMetadataSchemaCustom["PEOPLE"] = "com.atlassian.jira.plugin.system.customfieldtypes:people";
    return FieldMetadataSchemaCustom;
}({});
var $71c94b57ccceac13$export$2896cf63ba927114 = /*#__PURE__*/ function(FieldMetadataSchemaSystem) {
    FieldMetadataSchemaSystem["LABELS"] = "labels";
    FieldMetadataSchemaSystem["PARENT"] = "parent";
    return FieldMetadataSchemaSystem;
}({});
var $71c94b57ccceac13$export$e47e8d3b239f13b2 = /*#__PURE__*/ function(FieldMetadataSchemaOperations) {
    FieldMetadataSchemaOperations["ADD"] = "add";
    FieldMetadataSchemaOperations["SET"] = "set";
    FieldMetadataSchemaOperations["REMOVE"] = "remove";
    return FieldMetadataSchemaOperations;
}({});
class $71c94b57ccceac13$export$3bf230daf0bbd5c9 {
    add(priority) {
        // It's assumed that no two priorities will have the same ID so we don't have to worry about overwriting.
        this.internalMap.set(this.customIdFn(priority), priority);
    }
    has(priority) {
        return this.internalMap.has(this.customIdFn(priority));
    }
    get(key) {
        return this.internalMap.get(key);
    }
    hasId(id) {
        return this.internalMap.has(id);
    }
    union(other) {
        return new $71c94b57ccceac13$export$3bf230daf0bbd5c9([
            ...other.values(),
            ...this.values()
        ], this.customIdFn);
    }
    values() {
        return Array.from(this.internalMap.values());
    }
    size() {
        return this.internalMap.size;
    }
    constructor(priorities = [], customIdFn){
        this.internalMap = void 0;
        this.customIdFn = void 0;
        this.internalMap = new Map(priorities.map((priority)=>[
                customIdFn(priority),
                priority
            ]));
        this.customIdFn = customIdFn;
    }
}
class $71c94b57ccceac13$export$18c3c0a92740f3c1 extends $71c94b57ccceac13$export$3bf230daf0bbd5c9 {
    constructor(priorities = []){
        super(priorities, (priority)=>priority.id);
    }
}
class $71c94b57ccceac13$export$c115b35e1b0e068f extends $71c94b57ccceac13$export$3bf230daf0bbd5c9 {
    constructor(issues = []){
        super(issues, (issue)=>issue.key);
    }
}
function $71c94b57ccceac13$export$9e460c89a345e1d4(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'name' in value;
}
function $71c94b57ccceac13$export$4c30197f0b576bcc(value) {
    return Array.isArray(value) && value.every($71c94b57ccceac13$export$9e460c89a345e1d4);
}
function $71c94b57ccceac13$export$26db3529e2ea773b(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'value' in value;
}
function $71c94b57ccceac13$export$363de4039b18e730(value) {
    return Array.isArray(value) && value.every($71c94b57ccceac13$export$26db3529e2ea773b);
}
module.exports["isGICCompatibleObject"] = $71c94b57ccceac13$export$6f9c4b5b9f7231da;
module.exports["isGICCompatibleObjectList"] = $71c94b57ccceac13$export$a24d9b48e1b802c6;
module.exports["MESSAGE_PROJECT_TYPE_TO_API_PROJECT_TYPE"] = $71c94b57ccceac13$export$f7e2564263dc8770;
module.exports["FieldMetadataSchemaItems"] = $71c94b57ccceac13$export$bff92472168efa13;
module.exports["FieldMetadataSchemaType"] = $71c94b57ccceac13$export$e70f0c6fcc814588;
module.exports["FieldMetadataSchemaCustom"] = $71c94b57ccceac13$export$a9a7f0c9ccbb6fb6;
module.exports["FieldMetadataSchemaSystem"] = $71c94b57ccceac13$export$2896cf63ba927114;
module.exports["FieldMetadataSchemaOperations"] = $71c94b57ccceac13$export$e47e8d3b239f13b2;
module.exports["SimpleJiraIssuesSet"] = $71c94b57ccceac13$export$c115b35e1b0e068f;
module.exports["isIdNameObjectList"] = $71c94b57ccceac13$export$4c30197f0b576bcc;
module.exports["isSelectOptionList"] = $71c94b57ccceac13$export$363de4039b18e730;

});

parcelRegister("aMxFD", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $8e2cb5cf70790964$var$initialState = {
    currentPage: 'default',
    errorMessage: null
};
const $8e2cb5cf70790964$var$actions = {
    goToPage: (page)=>({ setState: setState })=>{
            setState({
                currentPage: page
            });
        },
    setFlags: (flags)=>({ setState: setState })=>{
            setState({
                flags: flags
            });
        },
    setErrorMessage: (errorMessage)=>({ setState: setState })=>{
            setState({
                errorMessage: errorMessage
            });
        }
};
const $8e2cb5cf70790964$var$Store = (0, $1P1Tu.createStore)({
    initialState: $8e2cb5cf70790964$var$initialState,
    actions: $8e2cb5cf70790964$var$actions,
    name: 'AiBulkNavigationState'
});
const $8e2cb5cf70790964$export$a334843fa0c1b332 = (0, $FOT9i.createContainer)($8e2cb5cf70790964$var$Store);
const $8e2cb5cf70790964$var$useActions = (0, $9zUhf.createActionsHook)($8e2cb5cf70790964$var$Store);
const $8e2cb5cf70790964$export$26ede1f3a8b75971 = ()=>{
    const { goToPage: goToPage } = $8e2cb5cf70790964$var$useActions();
    return goToPage;
};
const $8e2cb5cf70790964$export$c38ef97487898e66 = (0, $9zUhf.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.currentPage
});
const $8e2cb5cf70790964$export$94387769fbc3c2a7 = ()=>{
    const { setFlags: setFlags } = $8e2cb5cf70790964$var$useActions();
    return setFlags;
};
const $8e2cb5cf70790964$export$9800018acb54c42 = (0, $9zUhf.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.flags
});
const $8e2cb5cf70790964$export$bf8137e7995f9734 = ()=>{
    const { setErrorMessage: setErrorMessage } = $8e2cb5cf70790964$var$useActions();
    return setErrorMessage;
};
const $8e2cb5cf70790964$export$23759efdd2d2dae9 = (0, $9zUhf.createStateHook)($8e2cb5cf70790964$var$Store, {
    selector: (state)=>state.errorMessage
});
module.exports["AiBulkNavigationContextContainer"] = $8e2cb5cf70790964$export$a334843fa0c1b332;
module.exports["useAiBulkNavigationGotoPage"] = $8e2cb5cf70790964$export$26ede1f3a8b75971;
module.exports["useAiBulkNavigationCurrentPage"] = $8e2cb5cf70790964$export$c38ef97487898e66;
module.exports["useSetBulkCreateFlagsContainer"] = $8e2cb5cf70790964$export$94387769fbc3c2a7;
module.exports["useBulkCreateFlagsContainer"] = $8e2cb5cf70790964$export$9800018acb54c42;
module.exports["useSetErrorMessage"] = $8e2cb5cf70790964$export$bf8137e7995f9734;
module.exports["useErrorMessage"] = $8e2cb5cf70790964$export$23759efdd2d2dae9;

});

parcelRegister("26Yin", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $fYQcF = parcelRequire("fYQcF");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $CbMiC = parcelRequire("CbMiC");

const $33398e36495db1d3$export$44cbec570ea812dc = 'confluenceHighlightIssueCreate';
const $33398e36495db1d3$export$73d72a8adb795478 = 'confluenceBulkIssueCreate';
const $33398e36495db1d3$export$90c28b8de76b4f83 = 'aiIssueCreateConfluenceBulk';
const $33398e36495db1d3$var$buildAttributes = ({ baseAttributes: baseAttributes, isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, hasEditPermission: hasEditPermission, isCreatedFromActionItems: isCreatedFromActionItems, pageMode: pageMode })=>{
    baseAttributes.isCreatedFromTable = isCreatedFromTable;
    baseAttributes.isCreatedWithAi = isCreatedWithAi;
    baseAttributes.hasEditPermission = hasEditPermission;
    baseAttributes.isCreatedFromActionItems = isCreatedFromActionItems;
    if (pageMode) baseAttributes.pageMode = pageMode;
    if (isCreatedWithAi) return {
        ...baseAttributes,
        aiFeatureName: $33398e36495db1d3$export$90c28b8de76b4f83
    };
    return baseAttributes;
};
const $33398e36495db1d3$export$dd2b6e807fb37ba3 = (isCreatedFromTable, isCreatedFromActionItems)=>{
    return isCreatedFromTable || isCreatedFromActionItems ? $33398e36495db1d3$export$44cbec570ea812dc : $33398e36495db1d3$export$73d72a8adb795478;
};
const $33398e36495db1d3$var$getErrorMessage = (error)=>{
    if (error instanceof Error) return error.message;
    return String(error);
};
const $33398e36495db1d3$export$7e3e9ba2bdd512ee = ()=>{
    const { columnToFieldMappings: columnToFieldMappings } = (0, $CbMiC.useMappingsState)();
    const numMappings = columnToFieldMappings ? columnToFieldMappings.length : undefined;
    return {
        numMappings: numMappings
    };
};
const $33398e36495db1d3$export$ba0927ab3d0d491f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError, trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [{ isCreatedWithAi: isCreatedWithAi, isCreatedFromTable: isCreatedFromTable, isCreatedFromActionItems: isCreatedFromActionItems }] = (0, $hq2Sz.useBulkCreateContext)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { numMappings: numMappings } = $33398e36495db1d3$export$7e3e9ba2bdd512ee();
    const logMultipleIssueCreateSuccess = (0, $42omo.useCallback)((numIssues)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                numIssues: numIssues,
                ...numMappings && {
                    numMappings: numMappings
                }
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'created',
                actionSubject: 'issue',
                attributes: attributes
            }
        }).fire();
    }, [
        numMappings,
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logMultipleIssueCreateFailure = (0, $42omo.useCallback)((numIssues, error)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                error: $33398e36495db1d3$var$getErrorMessage(error),
                numIssues: numIssues
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'failed',
                actionSubject: 'issueCreation',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logIssueInsertionFailure = (0, $42omo.useCallback)((numIssues, error)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                error: $33398e36495db1d3$var$getErrorMessage(error),
                numIssues: numIssues
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'failed',
                actionSubject: 'issueInsertion',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logSingleIssueCreateSuccess = (0, $42omo.useCallback)(()=>{
        logMultipleIssueCreateSuccess(1);
    }, [
        logMultipleIssueCreateSuccess
    ]);
    const logSingleIssueCreateFailure = (0, $42omo.useCallback)((error)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                error: $33398e36495db1d3$var$getErrorMessage(error)
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logCancelAiPanel = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'cancelled',
                actionSubject: 'aiPanel',
                attributes: attributes
            }
        }).fire();
    }, [
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        hasEditPermission,
        pageMode,
        createAnalyticsEvent
    ]);
    const logAiResultViewed = (0, $42omo.useCallback)((issuesGenerated)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                issuesGenerated: issuesGenerated
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        trackAIResultView({
            attributes: attributes
        });
    }, [
        trackAIResultView,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logAiResultActioned = (0, $42omo.useCallback)((aiResultAction, issueId)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        trackAIResultAction(aiResultAction, {
            attributes: {
                ...attributes,
                issueId: issueId
            }
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        trackAIResultAction,
        hasEditPermission
    ]);
    const logAiResultRemoved = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'removed',
                actionSubject: 'aiResult',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logRequestFailed = (0, $42omo.useCallback)(({ requestName: requestName, errorMessage: errorMessage })=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                errorMessage: errorMessage
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'failed',
                actionSubject: requestName,
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logDefaultJiraSiteNotFound = (0, $42omo.useCallback)(({ persistedCloudId: persistedCloudId, fallbackCloudId: fallbackCloudId })=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                persistedCloudId: persistedCloudId,
                fallbackCloudId: fallbackCloudId
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'notFound',
                actionSubject: 'jiraSite',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logSidePanelIssueRemoved = (0, $42omo.useCallback)(()=>{
        if (isCreatedWithAi) logAiResultRemoved();
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'removed',
                actionSubject: 'sidePanelIssue',
                attributes: attributes
            }
        }).fire();
    }, [
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        createAnalyticsEvent,
        logAiResultRemoved,
        hasEditPermission
    ]);
    const logSidePanelIssueApproved = (0, $42omo.useCallback)((issueAction)=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                issueAction: issueAction
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'approved',
                actionSubject: 'sidePanelIssue',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logCreateAllClick = (0, $42omo.useCallback)(()=>{
        if (isCreatedWithAi) logAiResultActioned('createAll');
        logSidePanelIssueApproved('createAll');
    }, [
        isCreatedWithAi,
        logAiResultActioned,
        logSidePanelIssueApproved
    ]);
    const logCreateSingleIssueClick = (0, $42omo.useCallback)((issueId)=>{
        if (isCreatedWithAi) logAiResultActioned('createSingleIssue', issueId);
        logSidePanelIssueApproved('createSingleIssue');
    }, [
        isCreatedWithAi,
        logAiResultActioned,
        logSidePanelIssueApproved
    ]);
    const logAiIssueCreationFailed = (0, $42omo.useCallback)((numIssues, error = '')=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {
                errorMessage: $33398e36495db1d3$var$getErrorMessage(error),
                numIssues: numIssues
            },
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'failed',
                actionSubject: 'aiIssueCreation',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logAiInteractionDismissed = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        trackAIInteractionDismiss({
            attributes: attributes
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        trackAIInteractionDismiss,
        hasEditPermission
    ]);
    const logAiNoResultsGenerated = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'generated',
                actionSubject: 'aiNoResults',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logAiInvalidResultsGenerated = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'generated',
                actionSubject: 'aiInvalidResults',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logAiInteractionInitiated = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        trackAIInteractionInit({
            attributes: attributes
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        trackAIInteractionInit,
        hasEditPermission
    ]);
    const logAiStreamingBackendFailed = (0, $42omo.useCallback)((error = '')=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        trackAIResultError({
            aiErrorMessage: $33398e36495db1d3$var$getErrorMessage(error)
        }, {
            attributes: attributes
        });
    }, [
        isCreatedFromTable,
        isCreatedWithAi,
        isCreatedFromActionItems,
        pageMode,
        trackAIResultError,
        hasEditPermission
    ]);
    const logIssueCreationFailed = (0, $42omo.useCallback)((numIssues, error = '')=>{
        if (isCreatedWithAi) logAiIssueCreationFailed(numIssues, error);
        logMultipleIssueCreateFailure(numIssues, error);
    }, [
        isCreatedWithAi,
        logAiIssueCreationFailed,
        logMultipleIssueCreateFailure
    ]);
    const logSidePanelClosed = (0, $42omo.useCallback)(()=>{
        const attributes = $33398e36495db1d3$var$buildAttributes({
            baseAttributes: {},
            isCreatedWithAi: isCreatedWithAi,
            isCreatedFromTable: isCreatedFromTable,
            isCreatedFromActionItems: isCreatedFromActionItems,
            hasEditPermission: hasEditPermission,
            pageMode: pageMode
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: $33398e36495db1d3$export$dd2b6e807fb37ba3(isCreatedFromTable, isCreatedFromActionItems),
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromTable,
        isCreatedFromActionItems,
        pageMode,
        hasEditPermission
    ]);
    const logAddMappingClicked = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'addMapping',
                type: 'ui',
                attributes: {
                    pageMode: pageMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageMode
    ]);
    const logDeleteMappingClicked = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'deleteMapping',
                type: 'ui',
                attributes: {
                    pageMode: pageMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageMode
    ]);
    return {
        logSingleIssueCreateSuccess: logSingleIssueCreateSuccess,
        logMultipleIssueCreateSuccess: logMultipleIssueCreateSuccess,
        logSingleIssueCreateFailure: logSingleIssueCreateFailure,
        logIssueInsertionFailure: logIssueInsertionFailure,
        logCancelAiPanel: logCancelAiPanel,
        logCreateAllClick: logCreateAllClick,
        logCreateSingleIssueClick: logCreateSingleIssueClick,
        logAiInteractionInitiated: logAiInteractionInitiated,
        logAiResultViewed: logAiResultViewed,
        logAiResultRemoved: logAiResultRemoved,
        logAiInteractionDismissed: logAiInteractionDismissed,
        logAiNoResultsGenerated: logAiNoResultsGenerated,
        logAiInvalidResultsGenerated: logAiInvalidResultsGenerated,
        logRequestFailed: logRequestFailed,
        logDefaultJiraSiteNotFound: logDefaultJiraSiteNotFound,
        logAiStreamingBackendFailed: logAiStreamingBackendFailed,
        logSidePanelIssueRemoved: logSidePanelIssueRemoved,
        logSidePanelIssueApproved: logSidePanelIssueApproved,
        logIssueCreationFailed: logIssueCreationFailed,
        logSidePanelClosed: logSidePanelClosed,
        logAddMappingClicked: logAddMappingClicked,
        logDeleteMappingClicked: logDeleteMappingClicked
    };
};
module.exports["BULK_ISSUE_CREATE_SOURCE"] = $33398e36495db1d3$export$73d72a8adb795478;
module.exports["AI_BULK_ISSUE_CREATE_FEATURE_NAME"] = $33398e36495db1d3$export$90c28b8de76b4f83;
module.exports["getSource"] = $33398e36495db1d3$export$dd2b6e807fb37ba3;
module.exports["useBulkCreateLoggingEvents"] = $33398e36495db1d3$export$ba0927ab3d0d491f;

});

parcelRegister("k9cgj", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $2R8mu = parcelRequire("2R8mu");

const $8c7990e76592fea1$var$getJiraProjectsEndpoint = ({ cloudId: cloudId, query: query, projectIds: projectIds, orderBy: orderBy })=>{
    let endpoint = `/gateway/api/ex/jira/${cloudId}/rest/api/3/project/search?action=create`;
    if (orderBy) endpoint += `&orderBy=${orderBy}`;
    if (projectIds && projectIds.length > 0) endpoint += `&id=${projectIds.join('&id=')}`;
    if (query && query.length > 0) endpoint += `&query=${query}`;
    return endpoint;
};
const $8c7990e76592fea1$export$3643d7b900ddb907 = async ({ cloudId: cloudId, query: query, projectIds: projectIds, orderBy: orderBy })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getJiraProjectsEndpoint({
            cloudId: cloudId,
            query: query,
            projectIds: projectIds,
            orderBy: orderBy
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        const projects = data?.values;
        if (!projects) throw new Error('Parsing response from fetchJiraProjects failed');
        return projects;
    } catch  {
        throw new Error('Request to fetchJiraProjects agent failed');
    }
};
const $8c7990e76592fea1$var$getRecentJiraProjectsEndpoint = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/recent`;
const $8c7990e76592fea1$export$7c1ee4a22f76eab4 = async ({ cloudId: cloudId })=>{
    try {
        if (!cloudId) throw new Error('cloudId is required');
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getRecentJiraProjectsEndpoint(cloudId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const recentProjects = await response.json();
        if (!recentProjects) throw new Error('Parsing response from getRecentJiraProjects failed');
        return recentProjects;
    } catch  {
        throw new Error('Request to fetchRecentJiraProjects agent failed');
    }
};
const $8c7990e76592fea1$export$7486116a104ef6e1 = ({ cloudId: cloudId, projectId: projectId })=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes`;
const $8c7990e76592fea1$export$2434906985ee7db = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$export$7486116a104ef6e1({
            cloudId: cloudId,
            projectId: projectId
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        const issues = data?.issueTypes;
        if (!issues) throw new Error('Parsing response from fetchIssueTypes failed');
        return issues;
    } catch  {
        throw new Error('Request to fetchIssueTypes agent failed');
    }
};
const $8c7990e76592fea1$export$2c19a8a7ef06a941 = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue`;
const $8c7990e76592fea1$export$f47c2dad96a0a8ce = ({ cloudId: cloudId, issueBody: issueBody })=>{
    return (0, $f7B1p.cfetch)($8c7990e76592fea1$export$2c19a8a7ef06a941(cloudId), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(issueBody)
    });
};
const $8c7990e76592fea1$export$b61347e00e271b8e = async ({ cloudId: cloudId, issueBody: issueBody })=>{
    try {
        const response = await $8c7990e76592fea1$export$f47c2dad96a0a8ce({
            cloudId: cloudId,
            issueBody: issueBody
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from createIssue failed');
        return data;
    } catch  {
        throw new Error('Request to createIssue agent failed');
    }
};
const $8c7990e76592fea1$export$7308ced31fe15b63 = (cloudId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/bulk`;
const $8c7990e76592fea1$export$b2c5c6a2eab6752b = async ({ cloudId: cloudId, issueBody: issueBody })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$export$7308ced31fe15b63(cloudId), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(issueBody)
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from createBulkIssues failed');
        return data;
    } catch  {
        throw new Error('Request to createBulkIssues agent failed');
    }
};
const $8c7990e76592fea1$export$e2e9228ec6723fb3 = (tasks, limit)=>{
    return new Promise((resolve)=>{
        const results = [];
        if (tasks.length <= 0) return resolve(results);
        let currentIndex = 0;
        let activePromises = 0;
        const processNext = ()=>{
            while(activePromises < limit && currentIndex < tasks.length){
                const index = currentIndex++;
                activePromises++;
                tasks[index]().then((value)=>handleSettlement(index, {
                        status: 'fulfilled',
                        value: value
                    }), (reason)=>handleSettlement(index, {
                        status: 'rejected',
                        reason: reason
                    }));
            }
        };
        const handleSettlement = (index, result)=>{
            results[index] = result;
            activePromises--;
            if (currentIndex >= tasks.length && activePromises === 0) resolve(results);
            else processNext();
        };
        processNext();
    });
};
const $8c7990e76592fea1$var$getIssuesMetadataEndpoint = ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, maxResults: maxResults, startAt: startAt })=>{
    const base = `/gateway/api/ex/jira/${cloudId}/rest/api/3/issue/createmeta/${projectId}/issuetypes/${issueTypeId}`;
    const withMaxResults = `${base}?maxResults=${maxResults}`;
    return `${withMaxResults}&startAt=${startAt}`;
};
const $8c7990e76592fea1$export$33757cfaf527b436 = async ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId, maxResults: maxResults = 200, page: page = 0, consolidatedFields: consolidatedFields = [] })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getIssuesMetadataEndpoint({
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            maxResults: maxResults,
            startAt: page * maxResults
        }), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from issues metadata failed');
        const finalConsolidatedFields = [
            ...consolidatedFields,
            ...data.fields
        ];
        // The API can return a maximum result of 200. However, Issue types can sometimes have more than
        // 200 fields, in which case, the API may not be able to retrieve the summary and description fields correctly.
        // Therefore we call this API until the number of consolidated fields is equal to the value of 'total' indicated in the API response.
        // This 'total' indicates the total number of fields in all pages.
        if (data.total > finalConsolidatedFields.length) return await $8c7990e76592fea1$export$33757cfaf527b436({
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            maxResults: maxResults,
            page: page + 1,
            consolidatedFields: finalConsolidatedFields
        });
        return {
            fields: finalConsolidatedFields,
            maxResults: data.maxResults,
            total: data.total,
            startAt: data.startAt
        };
    } catch  {
        throw new Error('Error retrieving issue metadata');
    }
};
const $8c7990e76592fea1$export$fea6fd4de12a3df = (payload)=>{
    return {
        id: payload.issueId ? payload.issueId.toString() : '',
        key: payload.issueKey,
        self: payload.link,
        transition: {
            status: 200,
            errorCollection: {
                errorMessages: [],
                errors: {}
            }
        },
        summary: payload.summary
    };
};
const $8c7990e76592fea1$export$bed1e93b328a9d5f = (field)=>{
    if ((0, $2R8mu.isGICCompatibleObject)(field.value)) return field.value.id;
    if ((0, $2R8mu.isGICCompatibleObjectList)(field.value)) return field.value.map((value)=>value.id);
    // For all other primitive cases, we will just use the value directly.
    return field.value;
};
const $8c7990e76592fea1$export$f758b0f2f750cf99 = (cloudId, jiraProduct)=>`/gateway/api/ex/jira/${cloudId}/rest/api/1/aiconfig/ai-enabled/${jiraProduct}`;
const $8c7990e76592fea1$export$922a2bf0f405ea63 = (cloudId, jiraProduct)=>{
    return (0, $f7B1p.cfetch)($8c7990e76592fea1$export$f758b0f2f750cf99(cloudId, jiraProduct), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include'
    });
};
const $8c7990e76592fea1$export$741d044e24209da7 = async (cloudId, jiraProduct)=>{
    try {
        const response = await $8c7990e76592fea1$export$922a2bf0f405ea63(cloudId, jiraProduct);
        const data = await response.json();
        if (!data) throw new Error('Parsing response from getJiraAiEnablementRequest failed');
        return data;
    } catch  {
        throw new Error('Request to getJiraAiEnablementRequest agent failed');
    }
};
const $8c7990e76592fea1$var$getBulkWorkItemTypesEndpoint = (cloudId, workItemIds)=>{
    const searchTerms = encodeURI(`issuekey in (${workItemIds.join(',')})`);
    return `/gateway/api/ex/jira/${cloudId}/rest/api/3/search?jql=${searchTerms}&fields=issuetype`;
};
const $8c7990e76592fea1$export$29f6d64e496bf360 = async ({ cloudId: cloudId, workItemKeys: workItemKeys })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getBulkWorkItemTypesEndpoint(cloudId, workItemKeys), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data || !data.issues) throw new Error('Parsing response from fetchBulkIssueTypes failed');
        const issueTypeMap = new Map();
        data.issues.forEach((issue)=>{
            if (issue.key && issue.fields?.issuetype) issueTypeMap.set(issue.key, {
                issueType: issue.fields.issuetype,
                id: issue.id
            });
        });
        return issueTypeMap;
    } catch (error) {
        // Return an empty map if the request fails due to a bad request, which should only happen if the work item keys are invalid.
        if (error instanceof (0, $hBkCm.BadStatusError) && error.response.status === 400) return new Map();
        throw new Error('Request to fetchBulkIssueTypes agent failed');
    }
};
const $8c7990e76592fea1$var$getComponentsEndpoint = (cloudId, projectId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/${projectId}/components`;
const $8c7990e76592fea1$export$85ceea444bba598d = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getComponentsEndpoint(cloudId, projectId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from fetchComponents failed');
        return data;
    } catch  {
        throw new Error('Request to fetchComponents agent failed');
    }
};
const $8c7990e76592fea1$var$getVersionsEndpoint = (cloudId, projectId)=>`/gateway/api/ex/jira/${cloudId}/rest/api/3/project/${projectId}/versions`;
const $8c7990e76592fea1$export$d21a3f2efb15f4cc = async ({ cloudId: cloudId, projectId: projectId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getVersionsEndpoint(cloudId, projectId), {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'include'
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from fetchVersions failed');
        return data;
    } catch  {
        throw new Error('Request to fetchVersions agent failed');
    }
};
const $8c7990e76592fea1$var$getWorkflowValidatorsEndpoint = (cloudId)=>`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial?expand=fieldRequiredValidators`;
const $8c7990e76592fea1$export$7986722e27b5683d = async ({ cloudId: cloudId, projectId: projectId, issueTypeId: issueTypeId })=>{
    try {
        const response = await (0, $f7B1p.cfetch)($8c7990e76592fea1$var$getWorkflowValidatorsEndpoint(cloudId), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                projectId: projectId,
                issueTypeId: issueTypeId
            })
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from fetchWorkflowValidators failed');
        return data;
    } catch (error) {
        if (error instanceof Error && error.message.includes('Parsing response')) throw error;
        if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) {
            const status = error.response.status;
            throw new Error(`Request to fetchWorkflowValidators failed with status ${status}: ${error.message}`);
        }
        if (error instanceof SyntaxError) throw new Error(`Invalid JSON response from fetchWorkflowValidators: ${error.message}`);
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        throw new Error(`Request to fetchWorkflowValidators agent failed: ${errorMessage}`);
    }
};
const $8c7990e76592fea1$export$f8fab2cbd65681b8 = async (query, cloudId)=>{
    const url = `/gateway/api/ex/jira/${cloudId}/rest/gira/1/?operation=${encodeURIComponent(query.operationName)}`;
    const requestBody = {
        query: query.query,
        variables: query.variables,
        operationName: query.operationName
    };
    try {
        const response = await (0, $f7B1p.cfetch)(url, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        if (!data) throw new Error('Parsing response from GraphQL query failed');
        return data;
    } catch  {
        throw new Error('Request to GraphQL endpoint failed');
    }
};
const $8c7990e76592fea1$export$90b69b40e344dcd5 = `
	query ParentCandidatesForNewIssueQuery(
		$projectId: ID!
		$issueTypeId: ID!
		$cloudId: ID!
		$searchTerm: String
	) {
		jira {
			parentCandidatesWithInfoForNewIssue(
				projectId: $projectId
				issueTypeId: $issueTypeId
				cloudId: $cloudId
				searchTerm: $searchTerm
				excludeDone: false
				first: 1
			) {
				parentCandidates {
					edges {
						node {
							key
							issueId
						}
					}
				}
				message
			}
		}
	}
`;
module.exports["fetchJiraProjects"] = $8c7990e76592fea1$export$3643d7b900ddb907;
module.exports["fetchRecentJiraProjects"] = $8c7990e76592fea1$export$7c1ee4a22f76eab4;
module.exports["fetchIssueTypes"] = $8c7990e76592fea1$export$2434906985ee7db;
module.exports["createBulkIssues"] = $8c7990e76592fea1$export$b2c5c6a2eab6752b;
module.exports["fetchIssuesMetadata"] = $8c7990e76592fea1$export$33757cfaf527b436;
module.exports["mapGICPayloadToCreateIssueResponse"] = $8c7990e76592fea1$export$fea6fd4de12a3df;
module.exports["convertToGICFieldValue"] = $8c7990e76592fea1$export$bed1e93b328a9d5f;
module.exports["getJiraAiEnablement"] = $8c7990e76592fea1$export$741d044e24209da7;
module.exports["fetchBulkWorkItemTypes"] = $8c7990e76592fea1$export$29f6d64e496bf360;
module.exports["fetchJiraComponents"] = $8c7990e76592fea1$export$85ceea444bba598d;
module.exports["fetchWorkflowValidators"] = $8c7990e76592fea1$export$7986722e27b5683d;
module.exports["executeGraphQLQuery"] = $8c7990e76592fea1$export$f8fab2cbd65681b8;
module.exports["ParentCandidatesForNewIssueQuery"] = $8c7990e76592fea1$export$90b69b40e344dcd5;

});

parcelRegister("f0BVO", function(module, exports) {
// Projects and Issue Types aratar URLs are returned wrongly for Stargate requests.
// This function corrects the URLs.
// This can be removed once the Stargate issue is fixed. Ticket: https://donut-world-dogfood.atlassian.net/browse/MCRTB-1099
const $09059fa00e602c45$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};
module.exports["transformStargateUrl"] = $09059fa00e602c45$export$96f8b7181eacc12a;

});


//# sourceMappingURL=FullPageEditorComponent.62ebce58.js.map
